import { defineComponent as W, openBlock as p, createElementBlock as w, renderSlot as z, withAsyncContext as Ut, ref as U, onMounted as Ke, watch as de, normalizeClass as D, createElementVNode as x, createCommentVNode as E, nextTick as Je, withKeys as Re, toDisplayString as O, createVNode as C, unref as u, withCtx as k, createBlock as L, resolveDynamicComponent as Me, computed as B, createTextVNode as K, Fragment as te, renderList as ue, mergeProps as ae, mergeModels as se, useModel as me, reactive as kn, isRef as ct, shallowRef as pn, onBeforeUnmount as wn, normalizeStyle as Ae, onDeactivated as Xa, useAttrs as Wt, useId as lt, withModifiers as Le, withDirectives as Et, vModelCheckbox as Za, Teleport as $n, Transition as nt, vShow as qt, normalizeProps as Ja, resolveComponent as Qa, useSlots as ga, createSlots as Yt, onBeforeMount as es, toRefs as Gt, inject as va, provide as Xn, toHandlers as wt, watchEffect as ts } from "vue";
import * as ns from "@cfgtech/icons";
import { ChevronDownIcon as at, InfoCircleIcon as mn, CheckCircleIcon as as, DangerTriangleFillIcon as ss, ErrorOctagonIcon as ls, ChevronLeftIcon as Rt, ChevronRightIcon as Kt, TickIcon as Ne, HomeIcon as os, QuestionCircleIcon as ht, CheckmarkIcon as ha, SearchIcon as rs, DangerTriangleIcon as is, CalendarIcon as us, EyeIcon as ds, ArrowLeftIcon as cs, MoreDotsIcon as fs } from "@cfgtech/icons";
import { templateRef as jt, watchDebounced as ya, useArrayMap as $t, useFocus as gt, unrefElement as ps, tryOnScopeDispose as ms, useEventListener as gn, useTextareaAutosize as gs, useElementSize as Cn, onClickOutside as ba, useElementBounding as Ct, computedAsync as vs, useResizeObserver as hs, asyncComputed as ys, computedEager as bs } from "@vueuse/core";
import { translations as vn, asyncArrayFilter as xs, BankCodes as on, bankTranslations as ks, validators as ws, getBirthDateFromBirthNumber as $s, useMoneyFormat as Lt, roundToNearest as Cs } from "@cfgtech/helpers";
import Ss from "dayjs";
import { ProgressRoot as Ms, ProgressIndicator as Ds, PinInputRoot as Ts, PinInputInput as Es, TooltipProvider as Vs, TooltipRoot as Bs, TooltipTrigger as zs, TooltipPortal as Ls, TooltipContent as As, TabsTrigger as Is, TabsContent as Ps, TabsRoot as Os, TabsList as Fs, TabsIndicator as Rs, SliderRoot as js, SliderTrack as Hs, SliderRange as Ns, SliderThumb as _s } from "reka-ui";
import { useFloating as Sn, autoUpdate as Mn, flip as xa, shift as ka, offset as wa, autoPlacement as $a } from "@floating-ui/vue";
import { cloneDeep as bt, isEqual as St, pick as Ge, isUndefined as hn, isEmpty as Zn, omit as Xt, pickBy as Us } from "lodash-es";
import { SwitchGroup as Ws, Switch as qs, SwitchLabel as Ys, SwitchDescription as Gs, TransitionRoot as Dn, Dialog as Tn, TransitionChild as ft, DialogPanel as En, DialogTitle as Ks, DialogDescription as Xs, Listbox as Zs, ListboxButton as Js, ListboxOptions as Qs, ListboxOption as el } from "@headlessui/vue";
import { createFocusTrap as tl } from "focus-trap";
const $d = /* @__PURE__ */ W({
  __name: "CfgAccordion",
  props: {
    opened: {}
  },
  emits: ["update:opened"],
  setup(e, { emit: n }) {
    const t = e, o = n;
    function a(l) {
      o("update:opened", l !== t.opened ? l : -1);
    }
    return (l, s) => (p(), w("ul", null, [
      z(l.$slots, "default", {
        activeIdx: l.opened,
        on: { "click:header": a }
      })
    ]));
  }
}), Ca = /* @__PURE__ */ W({
  __name: "CfgCollapsable",
  props: {
    closedHeight: {
      type: Number,
      default: 0
    },
    opened: {
      type: Boolean,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:opened", "update:content-overflowed"],
  async setup(e, { emit: n }) {
    let t, o;
    const a = e, l = n, { default: s } = ([t, o] = Ut(() => import("gsap")), t = await t, o(), t), i = jt("contentController"), r = jt("contentWrapper"), d = U(a.opened), m = U(a.opened ?? !0);
    Ke(() => {
      a.opened || h();
    }), ya([m, () => a.disabled], () => h(), {
      debounce: 50
    }), de(
      () => a.opened,
      (v) => {
        m.value = v ?? !1;
      }
    ), de(
      () => m.value,
      () => {
        m.value !== a.opened && l("update:opened", m.value);
      }
    );
    const c = U(!1), g = U([]);
    async function h(v = !0) {
      if (!r.value)
        return;
      if (c.value) {
        g.value.push(() => h(v));
        return;
      }
      await (async () => {
        c.value = !0;
        const S = m.value && !a.disabled, b = v ? 0.4 : 0;
        r.value && (r.value.style.overflow = "hidden"), await Je(async () => {
          S && (s.set(r.value, { height: 0 }), await Je(() => {
            d.value = !0;
          })), await Je(() => new Promise((f) => {
            s.to(r.value, {
              duration: S ? b * 1.3 : b * 0.7,
              ease: "expo.inOut",
              autoAlpha: S ? 1 : 0
            }), s.to(r.value, {
              duration: b,
              ease: "expo.inOut",
              height: S ? "auto" : 0,
              onComplete() {
                r.value && (r.value.style.overflow = "initial"), S || (d.value = !1), c.value = !1, f(!0);
              }
            });
          }));
        });
      })();
      const M = g.value;
      g.value = [];
      for await (const S of M)
        await S();
    }
    return (v, y) => (p(), w("div", {
      class: D(["collapsable_wrapper transform-all relative duration-300", {
        closed: !m.value && !e.disabled
      }])
    }, [
      x("div", {
        ref_key: "contentWrapper",
        ref: r,
        class: "relative"
      }, [
        x("div", {
          ref_key: "contentController",
          ref: i
        }, [
          d.value ? z(v.$slots, "default", { key: 0 }) : E("", !0)
        ], 512)
      ], 512)
    ], 2));
  }
}), nl = {
  key: 0,
  class: "shrink grow text-md font-highlighted"
}, Cd = /* @__PURE__ */ W({
  __name: "CfgAccordionItem",
  props: {
    opened: { type: Boolean },
    headerText: { default: "" },
    index: {},
    headClass: { default: "" },
    bodyClass: { default: "" }
  },
  emits: ["click:header"],
  setup(e, { emit: n }) {
    const t = e, o = n;
    function a() {
      o("click:header", t.index);
    }
    return (l, s) => (p(), w("li", null, [
      z(l.$slots, "static"),
      x("header", {
        class: D(["flex cursor-pointer justify-between py-3", {
          "text-brand": l.opened,
          "text-dark-200": !l.opened,
          [l.headClass]: l.headClass
        }]),
        onClick: a,
        onKeydown: Re(a, ["enter"])
      }, [
        z(l.$slots, "head", {}, () => [
          l.headerText ? (p(), w("span", nl, O(l.headerText), 1)) : E("", !0)
        ]),
        x("span", {
          class: D(["shrink-0 transition-all duration-300", { "rotate-180": l.opened }])
        }, [
          C(u(at))
        ], 2)
      ], 34),
      x("main", {
        class: D({ [l.bodyClass]: l.bodyClass })
      }, [
        C(Ca, {
          "closed-height": 0,
          opened: l.opened
        }, {
          default: k(() => [
            z(l.$slots, "default")
          ]),
          _: 3
        }, 8, ["opened"])
      ], 2)
    ]));
  }
});
var $e = /* @__PURE__ */ ((e) => (e.brand = "brand", e.success = "success", e.warning = "warning", e.info = "info", e.error = "error", e))($e || {}), H = /* @__PURE__ */ ((e) => (e.h1 = "h1", e.h2 = "h2", e.h3 = "h3", e.h4 = "h4", e.h5 = "h5", e.h6 = "h6", e.subtitle = "subtitle", e.md = "md", e.sm = "sm", e.xs = "xs", e["h1-large"] = "h1-large", e.label = "label", e.xl = "xl", e.lg = "lg", e.perex = "perex", e.small = "small", e.micro = "micro", e))(H || {});
const al = ["innerHTML"], sl = /* @__PURE__ */ W({
  __name: "CfgTypography",
  props: {
    size: {
      type: String,
      default: H.md
    },
    tagName: {
      type: String,
      default: "span"
    },
    html: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (n, t) => n.$slots.default ? (p(), L(Me(e.tagName), {
      key: 0,
      class: D(["heading", {
        [`heading-${e.size}`]: !!e.size
      }])
    }, {
      default: k(() => [
        z(n.$slots, "default", {}, () => [
          e.html ? (p(), w("span", {
            key: 0,
            innerHTML: e.html
          }, null, 8, al)) : E("", !0)
        ], !0)
      ]),
      _: 3
    }, 8, ["class"])) : e.html ? (p(), L(Me(e.tagName), {
      key: 1,
      class: D(["heading", {
        [`heading-${e.size}`]: !!e.size
      }]),
      innerHTML: e.html
    }, null, 8, ["class", "innerHTML"])) : E("", !0);
  }
}), Xe = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [o, a] of n)
    t[o] = a;
  return t;
}, _ = /* @__PURE__ */ Xe(sl, [["__scopeId", "data-v-7704f0a9"]]), ll = { class: "flex gap-x-3" }, ol = { class: "space-y-1" }, Sd = /* @__PURE__ */ W({
  __name: "CfgAlert",
  props: {
    variant: {
      type: String,
      default: $e.info
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const n = e, t = B(() => {
      if (n.variant === $e.info)
        return mn;
      if (n.variant === $e.success)
        return as;
      if (n.variant === $e.warning)
        return ss;
      if (n.variant === $e.error)
        return ls;
    });
    return (o, a) => (p(), w("div", {
      class: D(["mb-4 rounded-md px-3 py-4 text-black md:px-4", {
        "bg-brand/20": e.variant === u($e).brand,
        "bg-blue/20": e.variant === u($e).info,
        "bg-success-light": e.variant === u($e).success,
        "bg-warning-light": e.variant === u($e).warning,
        "bg-red-light": e.variant === u($e).error
      }])
    }, [
      x("div", ll, [
        t.value || o.$slots.icon ? (p(), w("div", {
          key: 0,
          class: D(["w-6 flex-none [&>*]:text-[24px]", {
            "text-brand": e.variant === u($e).brand,
            "text-blue": e.variant === u($e).info,
            "text-success": e.variant === u($e).success,
            "text-warning": e.variant === u($e).warning,
            "text-red": e.variant === u($e).error
          }])
        }, [
          z(o.$slots, "icon", {}, () => [
            (p(), L(Me(t.value), { "aria-hidden": "true" }))
          ])
        ], 2)) : E("", !0),
        x("div", ol, [
          e.title ? (p(), L(_, {
            key: 0,
            class: "text-start !font-highlighted",
            size: u(H).md,
            "tag-name": "h3"
          }, {
            default: k(() => [
              K(O(e.title), 1)
            ]),
            _: 1
          }, 8, ["size"])) : E("", !0),
          C(_, {
            size: u(H).md,
            "tag-name": "p"
          }, {
            default: k(() => [
              z(o.$slots, "text", {}, () => [
                K(O(e.text), 1)
              ])
            ]),
            _: 3
          }, 8, ["size"])
        ])
      ])
    ], 2));
  }
}), rl = {}, il = { class: "lds-ring" };
function ul(e, n) {
  return p(), w("span", il, [
    (p(), w(te, null, ue(4, (t) => x("span", { key: t })), 64))
  ]);
}
const Vt = /* @__PURE__ */ Xe(rl, [["render", ul]]), we = {
  primary: "primary",
  primaryLight: "primary-light",
  secondary: "secondary",
  successLight: "success-light",
  success: "success",
  grey: "grey",
  light: "light",
  orange: "orange",
  dark: "dark",
  danger: "danger",
  dangerLight: "danger-light",
  black: "black",
  stroke: "stroke",
  white: "white"
}, dl = { class: "relative block" }, cl = {
  key: 0,
  class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
}, Zt = /* @__PURE__ */ W({
  __name: "CfgButton",
  props: {
    variant: { default: we.primary },
    label: { default: "" },
    flat: { type: Boolean },
    text: { type: Boolean },
    loading: { type: Boolean },
    small: { type: Boolean },
    stroke: { type: Boolean },
    as: { default: "button" },
    iconPlacement: { default: "right" }
  },
  setup(e) {
    const n = e, t = B(() => ({
      [we.primary]: {
        DEFAULT: "text-white bg-brand border-brand",
        stroke: "border-brand text-brand",
        text: "text-brand"
      },
      "primary-inverted": {
        DEFAULT: "text-brand bg-white border-white",
        stroke: "border-white text-white",
        text: "text-white"
      },
      [we.primaryLight]: {
        DEFAULT: "text-brand bg-brand-opacity border-brand-opacity",
        stroke: "border-brand-opacity text-brand-opacity",
        text: "text-brand-opacity"
      },
      [we.secondary]: {
        DEFAULT: "text-white bg-secondary border-secondary",
        stroke: "border-secondary text-secondary",
        text: "text-secondary"
      },
      [we.grey]: {
        DEFAULT: "text-white bg-grey-300 border-grey-300",
        stroke: "border-grey-300 text-grey-300",
        text: "text-grey-300"
      },
      [we.dark]: {
        DEFAULT: "text-white bg-secondary-dark border-secondary-dark",
        stroke: "border-secondary-dark text-secondary-dark",
        text: "text-secondary-dark"
      },
      [we.light]: {
        DEFAULT: "text-secondary-dark bg-grey-100 border-grey-100",
        stroke: "border-grey-100 text-grey-100",
        text: "text text-grey-100"
      },
      [we.orange]: {
        DEFAULT: "text-white bg-orange border-orange",
        stroke: "border-orange text-orange",
        text: "text-orange"
      },
      [we.danger]: {
        DEFAULT: "text-red-light bg-red border-red",
        stroke: "border-red text-red",
        text: "text-red"
      },
      [we.dangerLight]: {
        DEFAULT: "text-red bg-red-light border-red-light",
        stroke: "border-red-light text-red-light",
        text: "text-red-light"
      },
      [we.success]: {
        DEFAULT: "text-success-light bg-success border-success",
        stroke: "border-success text-success",
        text: "text-success"
      },
      [we.successLight]: {
        DEFAULT: "text-success bg-success-light border-success-light",
        stroke: "border-success-light text-success-light",
        text: "text-success-light"
      },
      [we.black]: {
        DEFAULT: "text-white bg-black border-black",
        stroke: "border-black text-black",
        text: "text-black"
      },
      [we.stroke]: {
        DEFAULT: "text-grey-100 bg-black border-grey-100",
        stroke: "border-grey-100 text-black",
        text: "text-black"
      },
      [we.white]: {
        DEFAULT: "text-black bg-white border-black",
        stroke: "border-white text-white",
        text: "text-white"
      }
    })), o = B(() => {
      if (n.text && n.stroke)
        throw new Error("CfgButton cannot have both text and stroke properties");
      return n.stroke ? "stroke" : n.text ? "text" : "DEFAULT";
    }), a = B(() => {
      const l = n.variant || we.primary;
      return t.value[l][o.value];
    });
    return (l, s) => (p(), L(Me(l.as), ae({
      ...l.as === "button" && !l.$attrs.type ? { type: "button" } : {}
    }, {
      class: ["button focusable inline-block px-0 font-display font-highlighted", {
        [`button-variant__${l.variant}`]: !0,
        "button-flat": l.flat,
        "button-small": l.small,
        "button-text": l.text,
        "cursor-not-allowed opacity-60": l.$attrs.disabled,
        "button-stroke": l.stroke,
        [a.value]: !0
      }],
      disabled: l.$attrs.disabled || l.loading
    }), {
      default: k(() => [
        x("span", dl, [
          x("span", {
            class: D(["flex items-center justify-center", {
              "opacity-0": l.loading,
              "gap-x-3": !l.small,
              "gap-x-2": l.small
            }])
          }, [
            l.label || l.$slots.default ? (p(), w("span", {
              key: 0,
              class: D(["button_label block text-center first-letter:uppercase", { "order-2": l.iconPlacement === "left" }])
            }, [
              z(l.$slots, "default", {}, () => [
                K(O(l.label), 1)
              ])
            ], 2)) : E("", !0),
            l.$slots.icon ? (p(), w("span", {
              key: 1,
              class: D({ "order-1": l.iconPlacement === "left" })
            }, [
              z(l.$slots, "icon")
            ], 2)) : E("", !0)
          ], 2),
          l.loading ? (p(), w("span", cl, [
            C(Vt, {
              class: D({
                "text-[7px]": !l.small,
                "text-[5px]": l.small
              })
            }, null, 8, ["class"])
          ])) : E("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "disabled"]));
  }
});
var Sa = 60, Ma = Sa * 60, Da = Ma * 24, fl = Da * 7, pt = 1e3, rn = Sa * pt, Jn = Ma * pt, pl = Da * pt, ml = fl * pt, Vn = "millisecond", rt = "second", it = "minute", ut = "hour", qe = "day", Pt = "week", Ie = "month", Ta = "quarter", Ye = "year", dt = "date", gl = "YYYY-MM-DDTHH:mm:ssZ", Qn = "Invalid Date", vl = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, hl = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
const yl = {
  name: "en",
  weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
  months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
  ordinal: function(n) {
    var t = ["th", "st", "nd", "rd"], o = n % 100;
    return "[" + n + (t[(o - 20) % 10] || t[o] || t[0]) + "]";
  }
};
var yn = function(n, t, o) {
  var a = String(n);
  return !a || a.length >= t ? n : "" + Array(t + 1 - a.length).join(o) + n;
}, bl = function(n) {
  var t = -n.utcOffset(), o = Math.abs(t), a = Math.floor(o / 60), l = o % 60;
  return (t <= 0 ? "+" : "-") + yn(a, 2, "0") + ":" + yn(l, 2, "0");
}, xl = function e(n, t) {
  if (n.date() < t.date()) return -e(t, n);
  var o = (t.year() - n.year()) * 12 + (t.month() - n.month()), a = n.clone().add(o, Ie), l = t - a < 0, s = n.clone().add(o + (l ? -1 : 1), Ie);
  return +(-(o + (t - a) / (l ? a - s : s - a)) || 0);
}, kl = function(n) {
  return n < 0 ? Math.ceil(n) || 0 : Math.floor(n);
}, wl = function(n) {
  var t = {
    M: Ie,
    y: Ye,
    w: Pt,
    d: qe,
    D: dt,
    h: ut,
    m: it,
    s: rt,
    ms: Vn,
    Q: Ta
  };
  return t[n] || String(n || "").toLowerCase().replace(/s$/, "");
}, $l = function(n) {
  return n === void 0;
};
const Cl = {
  s: yn,
  z: bl,
  m: xl,
  a: kl,
  p: wl,
  u: $l
};
var xt = "en", Qe = {};
Qe[xt] = yl;
var Ea = "$isDayjsObject", Bn = function(n) {
  return n instanceof Jt || !!(n && n[Ea]);
}, Ht = function e(n, t, o) {
  var a;
  if (!n) return xt;
  if (typeof n == "string") {
    var l = n.toLowerCase();
    Qe[l] && (a = l), t && (Qe[l] = t, a = l);
    var s = n.split("-");
    if (!a && s.length > 1)
      return e(s[0]);
  } else {
    var i = n.name;
    Qe[i] = n, a = i;
  }
  return !o && a && (xt = a), a || !o && xt;
}, oe = function(n, t) {
  if (Bn(n))
    return n.clone();
  var o = typeof t == "object" ? t : {};
  return o.date = n, o.args = arguments, new Jt(o);
}, Sl = function(n, t) {
  return oe(n, {
    locale: t.$L,
    utc: t.$u,
    x: t.$x,
    $offset: t.$offset
    // todo: refactor; do not use this.$offset in you code
  });
}, le = Cl;
le.l = Ht;
le.i = Bn;
le.w = Sl;
var Ml = function(n) {
  var t = n.date, o = n.utc;
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  if (le.u(t)) return /* @__PURE__ */ new Date();
  if (t instanceof Date) return new Date(t);
  if (typeof t == "string" && !/Z$/i.test(t)) {
    var a = t.match(vl);
    if (a) {
      var l = a[2] - 1 || 0, s = (a[7] || "0").substring(0, 3);
      return o ? new Date(Date.UTC(a[1], l, a[3] || 1, a[4] || 0, a[5] || 0, a[6] || 0, s)) : new Date(a[1], l, a[3] || 1, a[4] || 0, a[5] || 0, a[6] || 0, s);
    }
  }
  return new Date(t);
}, Jt = /* @__PURE__ */ function() {
  function e(t) {
    this.$L = Ht(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[Ea] = !0;
  }
  var n = e.prototype;
  return n.parse = function(o) {
    this.$d = Ml(o), this.init();
  }, n.init = function() {
    var o = this.$d;
    this.$y = o.getFullYear(), this.$M = o.getMonth(), this.$D = o.getDate(), this.$W = o.getDay(), this.$H = o.getHours(), this.$m = o.getMinutes(), this.$s = o.getSeconds(), this.$ms = o.getMilliseconds();
  }, n.$utils = function() {
    return le;
  }, n.isValid = function() {
    return this.$d.toString() !== Qn;
  }, n.isSame = function(o, a) {
    var l = oe(o);
    return this.startOf(a) <= l && l <= this.endOf(a);
  }, n.isAfter = function(o, a) {
    return oe(o) < this.startOf(a);
  }, n.isBefore = function(o, a) {
    return this.endOf(a) < oe(o);
  }, n.$g = function(o, a, l) {
    return le.u(o) ? this[a] : this.set(l, o);
  }, n.unix = function() {
    return Math.floor(this.valueOf() / 1e3);
  }, n.valueOf = function() {
    return this.$d.getTime();
  }, n.startOf = function(o, a) {
    var l = this, s = le.u(a) ? !0 : a, i = le.p(o), r = function(S, b) {
      var f = le.w(l.$u ? Date.UTC(l.$y, b, S) : new Date(l.$y, b, S), l);
      return s ? f : f.endOf(qe);
    }, d = function(S, b) {
      var f = [0, 0, 0, 0], $ = [23, 59, 59, 999];
      return le.w(l.toDate()[S].apply(
        // eslint-disable-line prefer-spread
        l.toDate("s"),
        (s ? f : $).slice(b)
      ), l);
    }, m = this.$W, c = this.$M, g = this.$D, h = "set" + (this.$u ? "UTC" : "");
    switch (i) {
      case Ye:
        return s ? r(1, 0) : r(31, 11);
      case Ie:
        return s ? r(1, c) : r(0, c + 1);
      case Pt: {
        var v = this.$locale().weekStart || 0, y = (m < v ? m + 7 : m) - v;
        return r(s ? g - y : g + (6 - y), c);
      }
      case qe:
      case dt:
        return d(h + "Hours", 0);
      case ut:
        return d(h + "Minutes", 1);
      case it:
        return d(h + "Seconds", 2);
      case rt:
        return d(h + "Milliseconds", 3);
      default:
        return this.clone();
    }
  }, n.endOf = function(o) {
    return this.startOf(o, !1);
  }, n.$set = function(o, a) {
    var l, s = le.p(o), i = "set" + (this.$u ? "UTC" : ""), r = (l = {}, l[qe] = i + "Date", l[dt] = i + "Date", l[Ie] = i + "Month", l[Ye] = i + "FullYear", l[ut] = i + "Hours", l[it] = i + "Minutes", l[rt] = i + "Seconds", l[Vn] = i + "Milliseconds", l)[s], d = s === qe ? this.$D + (a - this.$W) : a;
    if (s === Ie || s === Ye) {
      var m = this.clone().set(dt, 1);
      m.$d[r](d), m.init(), this.$d = m.set(dt, Math.min(this.$D, m.daysInMonth())).$d;
    } else r && this.$d[r](d);
    return this.init(), this;
  }, n.set = function(o, a) {
    return this.clone().$set(o, a);
  }, n.get = function(o) {
    return this[le.p(o)]();
  }, n.add = function(o, a) {
    var l = this, s;
    o = Number(o);
    var i = le.p(a), r = function(g) {
      var h = oe(l);
      return le.w(h.date(h.date() + Math.round(g * o)), l);
    };
    if (i === Ie)
      return this.set(Ie, this.$M + o);
    if (i === Ye)
      return this.set(Ye, this.$y + o);
    if (i === qe)
      return r(1);
    if (i === Pt)
      return r(7);
    var d = (s = {}, s[it] = rn, s[ut] = Jn, s[rt] = pt, s)[i] || 1, m = this.$d.getTime() + o * d;
    return le.w(m, this);
  }, n.subtract = function(o, a) {
    return this.add(o * -1, a);
  }, n.format = function(o) {
    var a = this, l = this.$locale();
    if (!this.isValid()) return l.invalidDate || Qn;
    var s = o || gl, i = le.z(this), r = this.$H, d = this.$m, m = this.$M, c = l.weekdays, g = l.months, h = l.meridiem, v = function(f, $, T, A) {
      return f && (f[$] || f(a, s)) || T[$].slice(0, A);
    }, y = function(f) {
      return le.s(r % 12 || 12, f, "0");
    }, M = h || function(b, f, $) {
      var T = b < 12 ? "AM" : "PM";
      return $ ? T.toLowerCase() : T;
    }, S = function(f) {
      switch (f) {
        case "YY":
          return String(a.$y).slice(-2);
        case "YYYY":
          return le.s(a.$y, 4, "0");
        case "M":
          return m + 1;
        case "MM":
          return le.s(m + 1, 2, "0");
        case "MMM":
          return v(l.monthsShort, m, g, 3);
        case "MMMM":
          return v(g, m);
        case "D":
          return a.$D;
        case "DD":
          return le.s(a.$D, 2, "0");
        case "d":
          return String(a.$W);
        case "dd":
          return v(l.weekdaysMin, a.$W, c, 2);
        case "ddd":
          return v(l.weekdaysShort, a.$W, c, 3);
        case "dddd":
          return c[a.$W];
        case "H":
          return String(r);
        case "HH":
          return le.s(r, 2, "0");
        case "h":
          return y(1);
        case "hh":
          return y(2);
        case "a":
          return M(r, d, !0);
        case "A":
          return M(r, d, !1);
        case "m":
          return String(d);
        case "mm":
          return le.s(d, 2, "0");
        case "s":
          return String(a.$s);
        case "ss":
          return le.s(a.$s, 2, "0");
        case "SSS":
          return le.s(a.$ms, 3, "0");
        case "Z":
          return i;
      }
      return null;
    };
    return s.replace(hl, function(b, f) {
      return f || S(b) || i.replace(":", "");
    });
  }, n.utcOffset = function() {
    return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
  }, n.diff = function(o, a, l) {
    var s = this, i = le.p(a), r = oe(o), d = (r.utcOffset() - this.utcOffset()) * rn, m = this - r, c = function() {
      return le.m(s, r);
    }, g;
    switch (i) {
      case Ye:
        g = c() / 12;
        break;
      case Ie:
        g = c();
        break;
      case Ta:
        g = c() / 3;
        break;
      case Pt:
        g = (m - d) / ml;
        break;
      case qe:
        g = (m - d) / pl;
        break;
      case ut:
        g = m / Jn;
        break;
      case it:
        g = m / rn;
        break;
      case rt:
        g = m / pt;
        break;
      default:
        g = m;
        break;
    }
    return l ? g : le.a(g);
  }, n.daysInMonth = function() {
    return this.endOf(Ie).$D;
  }, n.$locale = function() {
    return Qe[this.$L];
  }, n.locale = function(o, a) {
    if (!o) return this.$L;
    var l = this.clone(), s = Ht(o, a, !0);
    return s && (l.$L = s), l;
  }, n.clone = function() {
    return le.w(this.$d, this);
  }, n.toDate = function() {
    return new Date(this.valueOf());
  }, n.toJSON = function() {
    return this.isValid() ? this.toISOString() : null;
  }, n.toISOString = function() {
    return this.$d.toISOString();
  }, n.toString = function() {
    return this.$d.toUTCString();
  }, e;
}(), Va = Jt.prototype;
oe.prototype = Va;
[["$ms", Vn], ["$s", rt], ["$m", it], ["$H", ut], ["$W", qe], ["$M", Ie], ["$y", Ye], ["$D", dt]].forEach(function(e) {
  Va[e[1]] = function(n) {
    return this.$g(n, e[0], e[1]);
  };
});
oe.extend = function(e, n) {
  return e.$i || (e(n, Jt, oe), e.$i = !0), oe;
};
oe.locale = Ht;
oe.isDayjs = Bn;
oe.unix = function(e) {
  return oe(e * 1e3);
};
oe.en = Qe[xt];
oe.Ls = Qe;
oe.p = {};
const Ot = 7, Dl = 5;
function Tl(e) {
  const n = new Date(e.getFullYear(), e.getMonth() + 1, 0), t = Array.from({ length: n.getDate() }, (l, s) => s + 1).map((l) => un(new Date(
    Date.UTC(e.getFullYear(), e.getMonth(), l)
  )));
  if (t[0].dayOfWeek !== 1) {
    const l = new Date(e.getFullYear(), e.getMonth(), 0), s = new Date(l.getFullYear(), l.getMonth() + 1, 0).getDate(), i = t[0].dayOfWeek - 1, r = [];
    let d = 0;
    for (; d < i; )
      r.unshift(
        un(
          new Date(l.getFullYear(), l.getMonth(), s - d),
          { isPast: !0 }
        )
      ), d++;
    t.unshift(...r);
  }
  if (t[t.length - 1].dayOfWeek !== 7) {
    const l = new Date(e.getFullYear(), e.getMonth() + 1, 1), s = Ot * Dl + 1 - t.length;
    let i = 0;
    for (; i < s; )
      t.push(
        un(
          new Date(l.getFullYear(), l.getMonth(), i + 1),
          { isFuture: !0 }
        )
      ), i++;
  }
  const o = Array.from({ length: 6 }, (l, s) => s + 1).map((l) => t.slice((l - 1) * Ot, l * Ot)), a = o[o.length - 1];
  return (!a.length || a.every((l) => l.inNextMonth)) && o.pop(), o;
}
function un(e, n) {
  const t = /* @__PURE__ */ new Date(), o = e.getDay();
  return {
    day: e.getDate(),
    date: e.toISOString(),
    isToday: e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear(),
    isWeekend: [6, 7].includes(e.getDay()),
    dayOfWeek: o === 0 ? Ot : o,
    inPastMonth: n == null ? void 0 : n.isPast,
    inNextMonth: n == null ? void 0 : n.isFuture
  };
}
const Ba = {
  disabledDates: {
    type: Array,
    default: () => []
  },
  minDate: {
    type: Date,
    default: null
  },
  maxDate: {
    type: Date,
    default: null
  },
  format: {
    type: String,
    default: "D. M. YYYY"
  }
}, El = { class: "mb-5" }, Vl = { class: "flex items-center justify-center gap-x-10 pb-5" }, Bl = ["disabled"], zl = ["disabled"], Ll = {
  key: 0,
  class: "absolute left-0 top-10 z-10 size-full overflow-auto bg-white pb-10"
}, Al = { class: "grid max-h-full grid-cols-3 gap-3" }, Il = ["onClick"], Pl = { key: 1 }, Ol = { class: "grid auto-rows-fr grid-cols-3 gap-3 pb-10" }, Fl = ["disabled", "onClick"], Rl = /* @__PURE__ */ W({
  __name: "CfgMonthAndYearSelection",
  props: /* @__PURE__ */ se({
    minDate: {
      type: Date,
      default: () => new Date(1900, 0, 1)
    },
    maxDate: {
      type: Date,
      default: () => new Date((/* @__PURE__ */ new Date()).getFullYear() + 10, 0, 1)
    },
    openWindow: {
      type: String,
      default: "month"
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ se(["close"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, o = n, a = [...vn.localeObjectCs.months], l = B(() => {
      const f = [];
      for (let $ = new Date(t.minDate).getFullYear(); $ <= new Date(t.maxDate).getFullYear(); $ += 1)
        f.push($);
      return f.sort(($, T) => T - $);
    }), s = me(e, "modelValue"), i = U(s.value.year), r = U(t.openWindow === "year"), d = $t(a, (f, $) => {
      const T = Ss(
        new Date(i.value, $, 1)
      );
      return {
        month: f,
        number: $,
        isSelected: $ === s.value.month,
        disabled: T.isBefore(t.minDate, "month") || T.isAfter(t.maxDate, "month")
      };
    }), m = $t(l, (f) => ({
      year: f,
      isSelected: f === i.value
    })), c = U([]), g = B(() => i.value > new Date(t.minDate).getFullYear()), h = B(() => i.value < new Date(t.maxDate).getFullYear());
    de(() => t.modelValue, (f) => {
      i.value = f.year;
    }), de(() => t.openWindow, () => {
      r.value = t.openWindow === "year";
    }), de(r, (f) => {
      f && Je(() => {
        var $, T;
        (T = ($ = c.value) == null ? void 0 : $[l.value.findIndex((A) => A === i.value)]) == null || T.focus();
      });
    });
    function v() {
      i.value += 1;
    }
    function y() {
      i.value -= 1;
    }
    function M(f) {
      s.value = {
        month: f,
        year: i.value
      };
    }
    function S(f) {
      i.value = f, r.value = !1;
    }
    function b() {
      r.value ? r.value = !1 : o("close");
    }
    return (f, $) => (p(), w("div", null, [
      x("div", El, [
        C(u(Zt), {
          "aria-label": r.value ? "Měsíc" : "Zavřít",
          class: "mb-5",
          "icon-placement": "left",
          text: "",
          onClick: b
        }, {
          icon: k(() => [
            C(u(Rt), { class: "text-sm" })
          ]),
          default: k(() => [
            C(u(_), {
              size: u(H).sm
            }, {
              default: k(() => [
                K(O(r.value ? "Měsíc" : "Zpět"), 1)
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["aria-label"])
      ]),
      x("div", Vl, [
        x("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !g.value,
          type: "button",
          onClick: y
        }, [
          C(u(Rt))
        ], 8, Bl),
        C(u(_), {
          class: "flex min-w-[140px] shrink-0 grow justify-center text-center",
          size: u(H).sm
        }, {
          default: k(() => [
            x("button", {
              class: "flex items-center justify-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              type: "button",
              onClick: $[0] || ($[0] = (T) => r.value = !0)
            }, [
              x("span", null, O(i.value), 1),
              C(u(at), { class: "text-[0.85em] text-grey-300" })
            ])
          ]),
          _: 1
        }, 8, ["size"]),
        x("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !h.value,
          type: "button",
          onClick: v
        }, [
          C(u(Kt))
        ], 8, zl)
      ]),
      r.value ? (p(), w("div", Ll, [
        x("ul", Al, [
          (p(!0), w(te, null, ue(u(m), ({ year: T, isSelected: A }) => (p(), w("li", { key: T }, [
            x("button", {
              ref_for: !0,
              ref_key: "yearsButtonRefs",
              ref: c,
              class: D(["flex w-full flex-1 items-center justify-center rounded-xl border border-grey-stroke p-3 lg:transition lg:duration-200 lg:hover:border-brand", {
                "border-brand text-brand": A
              }]),
              type: "button",
              onClick: (R) => S(T)
            }, [
              C(u(_), {
                class: "capitalize",
                size: u(H).sm
              }, {
                default: k(() => [
                  K(O(T), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 10, Il)
          ]))), 128))
        ])
      ])) : (p(), w("div", Pl, [
        x("ul", Ol, [
          (p(!0), w(te, null, ue(u(d), ({
            month: T,
            number: A,
            isSelected: R,
            disabled: V
          }) => (p(), w("li", {
            key: T,
            class: "col-span-1 flex"
          }, [
            x("button", {
              class: D(["focusable flex w-full flex-1 items-center justify-center rounded-xl border border-grey-stroke p-3 disabled:cursor-not-allowed disabled:line-through disabled:opacity-50 lg:transition lg:duration-200 lg:hover:border-brand", {
                "border-brand text-brand": R
              }]),
              disabled: V,
              type: "button",
              onClick: (P) => M(A)
            }, [
              C(u(_), {
                class: "capitalize",
                size: u(H).sm
              }, {
                default: k(() => [
                  K(O(T), 1)
                ]),
                _: 2
              }, 1032, ["size"])
            ], 10, Fl)
          ]))), 128))
        ])
      ]))
    ]));
  }
}), jl = { class: "relative" }, Hl = {
  key: 0,
  class: "absolute left-0 top-0 z-20 flex size-full bg-white"
}, Nl = { class: "flex items-center justify-center gap-x-5 px-1 pb-7" }, _l = ["disabled"], Ul = {
  key: 1,
  class: "grid grid-cols-7"
}, Wl = { class: "mt-3 grid grid-cols-7" }, ql = ["aria-label", "data-selected", "disabled", "onClick"], Yl = { class: "cfg-day-item__content" }, Gl = { class: "block w-full" }, Kl = /* @__PURE__ */ W({
  __name: "CfgCalendar",
  props: /* @__PURE__ */ se(Ba, {
    modelValue: { default: null, type: Date },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ se(["selectDate"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, o = n, a = [...vn.localeObjectCs.weekdaysShort];
    a.push(a.shift());
    const l = [...vn.localeObjectCs.months], s = me(e, "modelValue"), i = U([]), r = U(!1), d = U("month"), m = oe(s.value || /* @__PURE__ */ new Date()), c = kn({
      year: m.year(),
      month: m.month()
    }), g = B(() => l[c.month]), h = B(() => new Date(c.year, c.month, 1)), v = B(() => $(
      T(
        Tl(h.value)
      )
    )), y = B(() => new Date(t.minDate || "1900") < new Date(h.value)), M = B(() => t.maxDate ? oe(t.maxDate).isAfter(oe(h.value), "month") : !0);
    Ke(() => {
      i.value.length && (i.value.find((P) => P.getAttribute("data-selected") === "true") || i.value[0]).focus();
    });
    function S() {
      c.month === 11 ? (c.month = 0, c.year += 1) : c.month += 1;
    }
    function b() {
      c.month === 0 ? (c.month = 11, c.year -= 1) : c.month -= 1;
    }
    function f(V) {
      s.value = new Date(V), o("selectDate", new Date(V));
    }
    function $(V) {
      return V.map((P) => P.map((q) => {
        var N;
        const j = oe(q.date);
        let Y = (N = t.disabledDates) == null ? void 0 : N.some((F) => {
          const X = oe(F);
          return j.isSame(X, "day");
        });
        if (!Y && t.minDate) {
          const F = oe(t.minDate);
          Y = j.isBefore(F, "day");
        }
        if (!Y && t.maxDate) {
          const F = oe(t.maxDate);
          Y = j.isAfter(F, "day");
        }
        return { ...q, disabled: Y };
      }));
    }
    function T(V) {
      return V.map((P) => P.map((q) => {
        const j = oe(q.date), Y = oe(s.value);
        return { ...q, selected: j.isSame(Y, "day") };
      }));
    }
    function A({ month: V, year: P }) {
      c.month = V, c.year = P, r.value = !1;
    }
    function R(V = "month") {
      d.value = V, r.value = !0;
    }
    return (V, P) => (p(), w("div", jl, [
      r.value ? (p(), w("div", Hl, [
        C(Rl, {
          class: "w-full flex-1",
          "max-date": V.maxDate || void 0,
          "min-date": V.minDate || void 0,
          "model-value": {
            year: c.year,
            month: c.month
          },
          "open-window": d.value,
          onClose: P[0] || (P[0] = (q) => r.value = !1),
          "onUpdate:modelValue": A
        }, null, 8, ["max-date", "min-date", "model-value", "open-window"])
      ])) : E("", !0),
      x("div", Nl, [
        x("button", {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !y.value,
          type: "button",
          onClick: b
        }, [
          C(u(Rt))
        ], 8, _l),
        C(_, {
          class: "flex min-w-[140px] shrink-0 grow items-center justify-center gap-x-5 text-center",
          size: u(H).sm
        }, {
          default: k(() => [
            C(_, {
              class: "flex items-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              size: u(H).sm,
              "tag-name": "button",
              type: "button",
              onClick: P[1] || (P[1] = (q) => R("month"))
            }, {
              default: k(() => [
                K(O(g.value) + " ", 1),
                C(u(at), { class: "text-[0.85em] text-grey-300" })
              ]),
              _: 1
            }, 8, ["size"]),
            C(_, {
              class: "flex items-center gap-x-2 capitalize lg:transition lg:duration-200 lg:hover:text-brand",
              size: u(H).sm,
              "tag-name": "button",
              type: "button",
              onClick: P[2] || (P[2] = (q) => R("year"))
            }, {
              default: k(() => [
                K(O(c.year) + " ", 1),
                C(u(at), { class: "text-[0.85em] text-grey-300" })
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }, 8, ["size"]),
        C(_, {
          class: "focusable rounded-md border border-grey-stroke p-1 disabled:cursor-not-allowed disabled:opacity-50",
          disabled: !M.value,
          size: u(H).sm,
          "tag-name": "button",
          type: "button",
          onClick: S
        }, {
          default: k(() => [
            C(u(Kt))
          ]),
          _: 1
        }, 8, ["disabled", "size"])
      ]),
      r.value ? E("", !0) : (p(), w("div", Ul, [
        (p(), w(te, null, ue(a, (q) => C(_, {
          key: q,
          class: "px-3 text-center text-grey-300",
          size: u(H).xs
        }, {
          default: k(() => [
            K(O(q), 1)
          ]),
          _: 2
        }, 1032, ["size"])), 64))
      ])),
      x("div", Wl, [
        (p(!0), w(te, null, ue(v.value, (q) => (p(), w(te, null, [
          (p(!0), w(te, null, ue(q, (j) => (p(), w("button", {
            key: j.day,
            ref_for: !0,
            ref_key: "dayRefs",
            ref: i,
            "aria-label": j.date,
            class: D(["focusable cfg-day-item disabled:cursor-not-allowed disabled:line-through disabled:opacity-50", {
              selected: j.selected
            }]),
            "data-selected": j.selected,
            disabled: j.disabled,
            type: "button",
            onClick: (Y) => !j.disabled && f(j.date)
          }, [
            C(_, {
              class: D({
                "text-grey-200": (j.inPastMonth || j.inNextMonth) && !c,
                disabled: j.disabled
              }),
              disabled: j.disabled,
              size: u(H).sm,
              "tag-name": "span"
            }, {
              default: k(() => [
                x("span", Yl, [
                  x("span", Gl, O(j.day), 1),
                  j.isToday ? (p(), w("span", {
                    key: 0,
                    class: D(["absolute bottom-1.5 left-1/2 block size-1 -translate-x-1/2 rounded-full bg-brand", { "!bg-white": j.selected }])
                  }, null, 2)) : E("", !0)
                ])
              ]),
              _: 2
            }, 1032, ["class", "disabled", "size"])
          ], 10, ql))), 128))
        ], 64))), 256))
      ])
    ]));
  }
}), Xl = /* @__PURE__ */ Xe(Kl, [["__scopeId", "data-v-3a16ba56"]]), Zl = {}, Jl = { class: "rounded-xl p-5" };
function Ql(e, n) {
  return p(), w("div", Jl, [
    z(e.$slots, "default")
  ]);
}
const Md = /* @__PURE__ */ Xe(Zl, [["render", Ql]]), eo = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function zn(e = {}) {
  let n, t, o, a = !1, l = !0, s = !1, i = 0;
  function r($, T) {
    t = $;
    const {
      mergeOptions: A,
      optionsAtMedia: R
    } = T, V = A(eo, zn.globalOptions), P = A(V, e);
    if (n = R(P), t.scrollSnapList().length <= 1) return;
    s = n.jump, o = !1;
    const {
      eventStore: q,
      ownerDocument: j
    } = t.internalEngine(), Y = t.rootNode(), N = n.rootNode && n.rootNode(Y) || Y, F = t.containerNode();
    t.on("pointerDown", c), n.stopOnInteraction || t.on("pointerUp", m), n.stopOnMouseEnter && (q.add(N, "mouseenter", () => {
      l = !1, c();
    }), n.stopOnInteraction || q.add(N, "mouseleave", () => {
      l = !0, m();
    })), n.stopOnFocusIn && (t.on("slideFocusStart", c), n.stopOnInteraction || q.add(F, "focusout", m)), q.add(j, "visibilitychange", g), n.playOnInit && !h() && m();
  }
  function d() {
    t.off("pointerDown", c).off("pointerUp", m).off("slideFocusStart", c), c(), o = !0, a = !1;
  }
  function m() {
    if (o || !l) return;
    a || t.emit("autoplay:play");
    const {
      ownerWindow: $
    } = t.internalEngine();
    $.clearInterval(i), i = $.setInterval(b, n.delay), a = !0;
  }
  function c() {
    if (o) return;
    a && t.emit("autoplay:stop");
    const {
      ownerWindow: $
    } = t.internalEngine();
    $.clearInterval(i), i = 0, a = !1;
  }
  function g() {
    if (h())
      return l = a, c();
    l && m();
  }
  function h() {
    const {
      ownerDocument: $
    } = t.internalEngine();
    return $.visibilityState === "hidden";
  }
  function v($) {
    typeof $ < "u" && (s = $), l = !0, m();
  }
  function y() {
    a && c();
  }
  function M() {
    a && v();
  }
  function S() {
    return a;
  }
  function b() {
    const {
      index: $
    } = t.internalEngine(), T = $.clone().add(1).get(), A = t.scrollSnapList().length - 1;
    n.stopOnLastSnap && T === A && c(), t.canScrollNext() ? t.scrollNext(s) : t.scrollTo(0, s);
  }
  return {
    name: "autoplay",
    options: e,
    init: r,
    destroy: d,
    play: v,
    stop: y,
    reset: M,
    isPlaying: S
  };
}
zn.globalOptions = void 0;
function to(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ea(e) {
  return to(e) || Array.isArray(e);
}
function no() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Ln(e, n) {
  const t = Object.keys(e), o = Object.keys(n);
  if (t.length !== o.length) return !1;
  const a = JSON.stringify(Object.keys(e.breakpoints || {})), l = JSON.stringify(Object.keys(n.breakpoints || {}));
  return a !== l ? !1 : t.every((s) => {
    const i = e[s], r = n[s];
    return typeof i == "function" ? `${i}` == `${r}` : !ea(i) || !ea(r) ? i === r : Ln(i, r);
  });
}
function ta(e) {
  return e.concat().sort((n, t) => n.name > t.name ? 1 : -1).map((n) => n.options);
}
function ao(e, n) {
  if (e.length !== n.length) return !1;
  const t = ta(e), o = ta(n);
  return t.every((a, l) => {
    const s = o[l];
    return Ln(a, s);
  });
}
function An(e) {
  return typeof e == "number";
}
function bn(e) {
  return typeof e == "string";
}
function Qt(e) {
  return typeof e == "boolean";
}
function na(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function fe(e) {
  return Math.abs(e);
}
function In(e) {
  return Math.sign(e);
}
function kt(e, n) {
  return fe(e - n);
}
function so(e, n) {
  if (e === 0 || n === 0 || fe(e) <= fe(n)) return 0;
  const t = kt(fe(e), fe(n));
  return fe(t / e);
}
function Mt(e) {
  return Dt(e).map(Number);
}
function Pe(e) {
  return e[Bt(e)];
}
function Bt(e) {
  return Math.max(0, e.length - 1);
}
function Pn(e, n) {
  return n === Bt(e);
}
function aa(e, n = 0) {
  return Array.from(Array(e), (t, o) => n + o);
}
function Dt(e) {
  return Object.keys(e);
}
function za(e, n) {
  return [e, n].reduce((t, o) => (Dt(o).forEach((a) => {
    const l = t[a], s = o[a], i = na(l) && na(s);
    t[a] = i ? za(l, s) : s;
  }), t), {});
}
function xn(e, n) {
  return typeof n.MouseEvent < "u" && e instanceof n.MouseEvent;
}
function lo(e, n) {
  const t = {
    start: o,
    center: a,
    end: l
  };
  function o() {
    return 0;
  }
  function a(r) {
    return l(r) / 2;
  }
  function l(r) {
    return n - r;
  }
  function s(r, d) {
    return bn(e) ? t[e](r) : e(n, r, d);
  }
  return {
    measure: s
  };
}
function Tt() {
  let e = [];
  function n(a, l, s, i = {
    passive: !0
  }) {
    let r;
    if ("addEventListener" in a)
      a.addEventListener(l, s, i), r = () => a.removeEventListener(l, s, i);
    else {
      const d = a;
      d.addListener(s), r = () => d.removeListener(s);
    }
    return e.push(r), o;
  }
  function t() {
    e = e.filter((a) => a());
  }
  const o = {
    add: n,
    clear: t
  };
  return o;
}
function oo(e, n, t, o) {
  const a = Tt(), l = 1e3 / 60;
  let s = null, i = 0, r = 0;
  function d() {
    a.add(e, "visibilitychange", () => {
      e.hidden && v();
    });
  }
  function m() {
    h(), a.clear();
  }
  function c(M) {
    if (!r) return;
    s || (s = M);
    const S = M - s;
    for (s = M, i += S; i >= l; )
      t(l), i -= l;
    const b = i / l;
    o(b), r && n.requestAnimationFrame(c);
  }
  function g() {
    r || (r = n.requestAnimationFrame(c));
  }
  function h() {
    n.cancelAnimationFrame(r), s = null, i = 0, r = 0;
  }
  function v() {
    s = null, i = 0;
  }
  return {
    init: d,
    destroy: m,
    start: g,
    stop: h,
    update: () => t(l),
    render: o
  };
}
function ro(e, n) {
  const t = n === "rtl", o = e === "y", a = o ? "y" : "x", l = o ? "x" : "y", s = !o && t ? -1 : 1, i = m(), r = c();
  function d(v) {
    const {
      height: y,
      width: M
    } = v;
    return o ? y : M;
  }
  function m() {
    return o ? "top" : t ? "right" : "left";
  }
  function c() {
    return o ? "bottom" : t ? "left" : "right";
  }
  function g(v) {
    return v * s;
  }
  return {
    scroll: a,
    cross: l,
    startEdge: i,
    endEdge: r,
    measureSize: d,
    direction: g
  };
}
function st(e = 0, n = 0) {
  const t = fe(e - n);
  function o(d) {
    return d < e;
  }
  function a(d) {
    return d > n;
  }
  function l(d) {
    return o(d) || a(d);
  }
  function s(d) {
    return l(d) ? o(d) ? e : n : d;
  }
  function i(d) {
    return t ? d - t * Math.ceil((d - n) / t) : d;
  }
  return {
    length: t,
    max: n,
    min: e,
    constrain: s,
    reachedAny: l,
    reachedMax: a,
    reachedMin: o,
    removeOffset: i
  };
}
function La(e, n, t) {
  const {
    constrain: o
  } = st(0, e), a = e + 1;
  let l = s(n);
  function s(g) {
    return t ? fe((a + g) % a) : o(g);
  }
  function i() {
    return l;
  }
  function r(g) {
    return l = s(g), c;
  }
  function d(g) {
    return m().set(i() + g);
  }
  function m() {
    return La(e, i(), t);
  }
  const c = {
    get: i,
    set: r,
    add: d,
    clone: m
  };
  return c;
}
function io(e, n, t, o, a, l, s, i, r, d, m, c, g, h, v, y, M, S, b) {
  const {
    cross: f,
    direction: $
  } = e, T = ["INPUT", "SELECT", "TEXTAREA"], A = {
    passive: !1
  }, R = Tt(), V = Tt(), P = st(50, 225).constrain(h.measure(20)), q = {
    mouse: 300,
    touch: 400
  }, j = {
    mouse: 500,
    touch: 600
  }, Y = v ? 43 : 25;
  let N = !1, F = 0, X = 0, Q = !1, I = !1, J = !1, Z = !1;
  function ne(G) {
    if (!b) return;
    function ie(Se) {
      (Qt(b) || b(G, Se)) && xe(Se);
    }
    const he = n;
    R.add(he, "dragstart", (Se) => Se.preventDefault(), A).add(he, "touchmove", () => {
    }, A).add(he, "touchend", () => {
    }).add(he, "touchstart", ie).add(he, "mousedown", ie).add(he, "touchcancel", Ce).add(he, "contextmenu", Ce).add(he, "click", je, !0);
  }
  function pe() {
    R.clear(), V.clear();
  }
  function De() {
    const G = Z ? t : n;
    V.add(G, "touchmove", ke, A).add(G, "touchend", Ce).add(G, "mousemove", ke, A).add(G, "mouseup", Ce);
  }
  function ee(G) {
    const ie = G.nodeName || "";
    return T.includes(ie);
  }
  function re() {
    return (v ? j : q)[Z ? "mouse" : "touch"];
  }
  function ve(G, ie) {
    const he = c.add(In(G) * -1), Se = m.byDistance(G, !v).distance;
    return v || fe(G) < P ? Se : M && ie ? Se * 0.5 : m.byIndex(he.get(), 0).distance;
  }
  function xe(G) {
    const ie = xn(G, o);
    Z = ie, J = v && ie && !G.buttons && N, N = kt(a.get(), s.get()) >= 2, !(ie && G.button !== 0) && (ee(G.target) || (Q = !0, l.pointerDown(G), d.useFriction(0).useDuration(0), a.set(s), De(), F = l.readPoint(G), X = l.readPoint(G, f), g.emit("pointerDown")));
  }
  function ke(G) {
    if (!xn(G, o) && G.touches.length >= 2) return Ce(G);
    const he = l.readPoint(G), Se = l.readPoint(G, f), Oe = kt(he, F), He = kt(Se, X);
    if (!I && !Z && (!G.cancelable || (I = Oe > He, !I)))
      return Ce(G);
    const _e = l.pointerMove(G);
    Oe > y && (J = !0), d.useFriction(0.3).useDuration(0.75), i.start(), a.add($(_e)), G.preventDefault();
  }
  function Ce(G) {
    const he = m.byDistance(0, !1).index !== c.get(), Se = l.pointerUp(G) * re(), Oe = ve($(Se), he), He = so(Se, Oe), _e = Y - 10 * He, Ue = S + He / 50;
    I = !1, Q = !1, V.clear(), d.useDuration(_e).useFriction(Ue), r.distance(Oe, !v), Z = !1, g.emit("pointerUp");
  }
  function je(G) {
    J && (G.stopPropagation(), G.preventDefault(), J = !1);
  }
  function Be() {
    return Q;
  }
  return {
    init: ne,
    destroy: pe,
    pointerDown: Be
  };
}
function uo(e, n) {
  let o, a;
  function l(c) {
    return c.timeStamp;
  }
  function s(c, g) {
    const v = `client${(g || e.scroll) === "x" ? "X" : "Y"}`;
    return (xn(c, n) ? c : c.touches[0])[v];
  }
  function i(c) {
    return o = c, a = c, s(c);
  }
  function r(c) {
    const g = s(c) - s(a), h = l(c) - l(o) > 170;
    return a = c, h && (o = c), g;
  }
  function d(c) {
    if (!o || !a) return 0;
    const g = s(a) - s(o), h = l(c) - l(o), v = l(c) - l(a) > 170, y = g / h;
    return h && !v && fe(y) > 0.1 ? y : 0;
  }
  return {
    pointerDown: i,
    pointerMove: r,
    pointerUp: d,
    readPoint: s
  };
}
function co() {
  function e(t) {
    const {
      offsetTop: o,
      offsetLeft: a,
      offsetWidth: l,
      offsetHeight: s
    } = t;
    return {
      top: o,
      right: a + l,
      bottom: o + s,
      left: a,
      width: l,
      height: s
    };
  }
  return {
    measure: e
  };
}
function fo(e) {
  function n(o) {
    return e * (o / 100);
  }
  return {
    measure: n
  };
}
function po(e, n, t, o, a, l, s) {
  const i = [e].concat(o);
  let r, d, m = [], c = !1;
  function g(M) {
    return a.measureSize(s.measure(M));
  }
  function h(M) {
    if (!l) return;
    d = g(e), m = o.map(g);
    function S(b) {
      for (const f of b) {
        if (c) return;
        const $ = f.target === e, T = o.indexOf(f.target), A = $ ? d : m[T], R = g($ ? e : o[T]);
        if (fe(R - A) >= 0.5) {
          M.reInit(), n.emit("resize");
          break;
        }
      }
    }
    r = new ResizeObserver((b) => {
      (Qt(l) || l(M, b)) && S(b);
    }), t.requestAnimationFrame(() => {
      i.forEach((b) => r.observe(b));
    });
  }
  function v() {
    c = !0, r && r.disconnect();
  }
  return {
    init: h,
    destroy: v
  };
}
function mo(e, n, t, o, a, l) {
  let s = 0, i = 0, r = a, d = l, m = e.get(), c = 0;
  function g(A) {
    const R = A / 1e3, V = r * R, P = o.get() - e.get(), q = !r;
    let j = 0;
    return q ? (s = 0, t.set(o), e.set(o), j = P) : (t.set(e), s += P / V, s *= d, m += s, e.add(s * R), j = m - c), i = In(j), c = m, T;
  }
  function h() {
    const A = o.get() - n.get();
    return fe(A) < 1e-3;
  }
  function v() {
    return r;
  }
  function y() {
    return i;
  }
  function M() {
    return s;
  }
  function S() {
    return f(a);
  }
  function b() {
    return $(l);
  }
  function f(A) {
    return r = A, T;
  }
  function $(A) {
    return d = A, T;
  }
  const T = {
    direction: y,
    duration: v,
    velocity: M,
    seek: g,
    settled: h,
    useBaseFriction: b,
    useBaseDuration: S,
    useFriction: $,
    useDuration: f
  };
  return T;
}
function go(e, n, t, o, a) {
  const l = a.measure(10), s = a.measure(50), i = st(0.1, 0.99);
  let r = !1;
  function d() {
    return !(r || !e.reachedAny(t.get()) || !e.reachedAny(n.get()));
  }
  function m(h) {
    if (!d()) return;
    const v = e.reachedMin(n.get()) ? "min" : "max", y = fe(e[v] - n.get()), M = t.get() - n.get(), S = i.constrain(y / s);
    t.subtract(M * S), !h && fe(M) < l && (t.set(e.constrain(t.get())), o.useDuration(25).useBaseFriction());
  }
  function c(h) {
    r = !h;
  }
  return {
    shouldConstrain: d,
    constrain: m,
    toggleActive: c
  };
}
function vo(e, n, t, o, a) {
  const l = st(-n + e, 0), s = c(), i = m(), r = g();
  function d(v, y) {
    return kt(v, y) < 1;
  }
  function m() {
    const v = s[0], y = Pe(s), M = s.lastIndexOf(v), S = s.indexOf(y) + 1;
    return st(M, S);
  }
  function c() {
    return t.map((v, y) => {
      const {
        min: M,
        max: S
      } = l, b = l.constrain(v), f = !y, $ = Pn(t, y);
      return f ? S : $ || d(M, b) ? M : d(S, b) ? S : b;
    }).map((v) => parseFloat(v.toFixed(3)));
  }
  function g() {
    if (n <= e + a) return [l.max];
    if (o === "keepSnaps") return s;
    const {
      min: v,
      max: y
    } = i;
    return s.slice(v, y);
  }
  return {
    snapsContained: r,
    scrollContainLimit: i
  };
}
function ho(e, n, t) {
  const o = n[0], a = t ? o - e : Pe(n);
  return {
    limit: st(a, o)
  };
}
function yo(e, n, t, o) {
  const l = n.min + 0.1, s = n.max + 0.1, {
    reachedMin: i,
    reachedMax: r
  } = st(l, s);
  function d(g) {
    return g === 1 ? r(t.get()) : g === -1 ? i(t.get()) : !1;
  }
  function m(g) {
    if (!d(g)) return;
    const h = e * (g * -1);
    o.forEach((v) => v.add(h));
  }
  return {
    loop: m
  };
}
function bo(e) {
  const {
    max: n,
    length: t
  } = e;
  function o(l) {
    const s = l - n;
    return t ? s / -t : 0;
  }
  return {
    get: o
  };
}
function xo(e, n, t, o, a) {
  const {
    startEdge: l,
    endEdge: s
  } = e, {
    groupSlides: i
  } = a, r = c().map(n.measure), d = g(), m = h();
  function c() {
    return i(o).map((y) => Pe(y)[s] - y[0][l]).map(fe);
  }
  function g() {
    return o.map((y) => t[l] - y[l]).map((y) => -fe(y));
  }
  function h() {
    return i(d).map((y) => y[0]).map((y, M) => y + r[M]);
  }
  return {
    snaps: d,
    snapsAligned: m
  };
}
function ko(e, n, t, o, a, l) {
  const {
    groupSlides: s
  } = a, {
    min: i,
    max: r
  } = o, d = m();
  function m() {
    const g = s(l), h = !e || n === "keepSnaps";
    return t.length === 1 ? [l] : h ? g : g.slice(i, r).map((v, y, M) => {
      const S = !y, b = Pn(M, y);
      if (S) {
        const f = Pe(M[0]) + 1;
        return aa(f);
      }
      if (b) {
        const f = Bt(l) - Pe(M)[0] + 1;
        return aa(f, Pe(M)[0]);
      }
      return v;
    });
  }
  return {
    slideRegistry: d
  };
}
function wo(e, n, t, o, a) {
  const {
    reachedAny: l,
    removeOffset: s,
    constrain: i
  } = o;
  function r(v) {
    return v.concat().sort((y, M) => fe(y) - fe(M))[0];
  }
  function d(v) {
    const y = e ? s(v) : i(v), M = n.map((b, f) => ({
      diff: m(b - y, 0),
      index: f
    })).sort((b, f) => fe(b.diff) - fe(f.diff)), {
      index: S
    } = M[0];
    return {
      index: S,
      distance: y
    };
  }
  function m(v, y) {
    const M = [v, v + t, v - t];
    if (!e) return v;
    if (!y) return r(M);
    const S = M.filter((b) => In(b) === y);
    return S.length ? r(S) : Pe(M) - t;
  }
  function c(v, y) {
    const M = n[v] - a.get(), S = m(M, y);
    return {
      index: v,
      distance: S
    };
  }
  function g(v, y) {
    const M = a.get() + v, {
      index: S,
      distance: b
    } = d(M), f = !e && l(M);
    if (!y || f) return {
      index: S,
      distance: v
    };
    const $ = n[S] - b, T = v + m($, 0);
    return {
      index: S,
      distance: T
    };
  }
  return {
    byDistance: g,
    byIndex: c,
    shortcut: m
  };
}
function $o(e, n, t, o, a, l, s) {
  function i(c) {
    const g = c.distance, h = c.index !== n.get();
    l.add(g), g && (o.duration() ? e.start() : (e.update(), e.render(1), e.update())), h && (t.set(n.get()), n.set(c.index), s.emit("select"));
  }
  function r(c, g) {
    const h = a.byDistance(c, g);
    i(h);
  }
  function d(c, g) {
    const h = n.clone().set(c), v = a.byIndex(h.get(), g);
    i(v);
  }
  return {
    distance: r,
    index: d
  };
}
function Co(e, n, t, o, a, l, s, i) {
  const r = {
    passive: !0,
    capture: !0
  };
  let d = 0;
  function m(h) {
    if (!i) return;
    function v(y) {
      if ((/* @__PURE__ */ new Date()).getTime() - d > 10) return;
      s.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = t.findIndex((f) => f.includes(y));
      An(b) && (a.useDuration(0), o.index(b, 0), s.emit("slideFocus"));
    }
    l.add(document, "keydown", c, !1), n.forEach((y, M) => {
      l.add(y, "focus", (S) => {
        (Qt(i) || i(h, S)) && v(M);
      }, r);
    });
  }
  function c(h) {
    h.code === "Tab" && (d = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: m
  };
}
function yt(e) {
  let n = e;
  function t() {
    return n;
  }
  function o(r) {
    n = s(r);
  }
  function a(r) {
    n += s(r);
  }
  function l(r) {
    n -= s(r);
  }
  function s(r) {
    return An(r) ? r : r.get();
  }
  return {
    get: t,
    set: o,
    add: a,
    subtract: l
  };
}
function Aa(e, n) {
  const t = e.scroll === "x" ? l : s, o = n.style;
  let a = !1;
  function l(c) {
    return `translate3d(${c}px,0px,0px)`;
  }
  function s(c) {
    return `translate3d(0px,${c}px,0px)`;
  }
  function i(c) {
    a || (o.transform = t(e.direction(c)));
  }
  function r(c) {
    a = !c;
  }
  function d() {
    a || (o.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: d,
    to: i,
    toggleActive: r
  };
}
function So(e, n, t, o, a, l, s, i, r) {
  const m = Mt(a), c = Mt(a).reverse(), g = S().concat(b());
  function h(R, V) {
    return R.reduce((P, q) => P - a[q], V);
  }
  function v(R, V) {
    return R.reduce((P, q) => h(P, V) > 0 ? P.concat([q]) : P, []);
  }
  function y(R) {
    return l.map((V, P) => ({
      start: V - o[P] + 0.5 + R,
      end: V + n - 0.5 + R
    }));
  }
  function M(R, V, P) {
    const q = y(V);
    return R.map((j) => {
      const Y = P ? 0 : -t, N = P ? t : 0, F = P ? "end" : "start", X = q[j][F];
      return {
        index: j,
        loopPoint: X,
        slideLocation: yt(-1),
        translate: Aa(e, r[j]),
        target: () => i.get() > X ? Y : N
      };
    });
  }
  function S() {
    const R = s[0], V = v(c, R);
    return M(V, t, !1);
  }
  function b() {
    const R = n - s[0] - 1, V = v(m, R);
    return M(V, -t, !0);
  }
  function f() {
    return g.every(({
      index: R
    }) => {
      const V = m.filter((P) => P !== R);
      return h(V, n) <= 0.1;
    });
  }
  function $() {
    g.forEach((R) => {
      const {
        target: V,
        translate: P,
        slideLocation: q
      } = R, j = V();
      j !== q.get() && (P.to(j), q.set(j));
    });
  }
  function T() {
    g.forEach((R) => R.translate.clear());
  }
  return {
    canLoop: f,
    clear: T,
    loop: $,
    loopPoints: g
  };
}
function Mo(e, n, t) {
  let o, a = !1;
  function l(r) {
    if (!t) return;
    function d(m) {
      for (const c of m)
        if (c.type === "childList") {
          r.reInit(), n.emit("slidesChanged");
          break;
        }
    }
    o = new MutationObserver((m) => {
      a || (Qt(t) || t(r, m)) && d(m);
    }), o.observe(e, {
      childList: !0
    });
  }
  function s() {
    o && o.disconnect(), a = !0;
  }
  return {
    init: l,
    destroy: s
  };
}
function Do(e, n, t, o) {
  const a = {};
  let l = null, s = null, i, r = !1;
  function d() {
    i = new IntersectionObserver((v) => {
      r || (v.forEach((y) => {
        const M = n.indexOf(y.target);
        a[M] = y;
      }), l = null, s = null, t.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: o
    }), n.forEach((v) => i.observe(v));
  }
  function m() {
    i && i.disconnect(), r = !0;
  }
  function c(v) {
    return Dt(a).reduce((y, M) => {
      const S = parseInt(M), {
        isIntersecting: b
      } = a[S];
      return (v && b || !v && !b) && y.push(S), y;
    }, []);
  }
  function g(v = !0) {
    if (v && l) return l;
    if (!v && s) return s;
    const y = c(v);
    return v && (l = y), v || (s = y), y;
  }
  return {
    init: d,
    destroy: m,
    get: g
  };
}
function To(e, n, t, o, a, l) {
  const {
    measureSize: s,
    startEdge: i,
    endEdge: r
  } = e, d = t[0] && a, m = v(), c = y(), g = t.map(s), h = M();
  function v() {
    if (!d) return 0;
    const b = t[0];
    return fe(n[i] - b[i]);
  }
  function y() {
    if (!d) return 0;
    const b = l.getComputedStyle(Pe(o));
    return parseFloat(b.getPropertyValue(`margin-${r}`));
  }
  function M() {
    return t.map((b, f, $) => {
      const T = !f, A = Pn($, f);
      return T ? g[f] + m : A ? g[f] + c : $[f + 1][i] - b[i];
    }).map(fe);
  }
  return {
    slideSizes: g,
    slideSizesWithGaps: h,
    startGap: m,
    endGap: c
  };
}
function Eo(e, n, t, o, a, l, s, i, r) {
  const {
    startEdge: d,
    endEdge: m,
    direction: c
  } = e, g = An(t);
  function h(S, b) {
    return Mt(S).filter((f) => f % b === 0).map((f) => S.slice(f, f + b));
  }
  function v(S) {
    return S.length ? Mt(S).reduce((b, f, $) => {
      const T = Pe(b) || 0, A = T === 0, R = f === Bt(S), V = a[d] - l[T][d], P = a[d] - l[f][m], q = !o && A ? c(s) : 0, j = !o && R ? c(i) : 0, Y = fe(P - j - (V + q));
      return $ && Y > n + r && b.push(f), R && b.push(S.length), b;
    }, []).map((b, f, $) => {
      const T = Math.max($[f - 1] || 0);
      return S.slice(T, b);
    }) : [];
  }
  function y(S) {
    return g ? h(S, t) : v(S);
  }
  return {
    groupSlides: y
  };
}
function Vo(e, n, t, o, a, l, s) {
  const {
    align: i,
    axis: r,
    direction: d,
    startIndex: m,
    loop: c,
    duration: g,
    dragFree: h,
    dragThreshold: v,
    inViewThreshold: y,
    slidesToScroll: M,
    skipSnaps: S,
    containScroll: b,
    watchResize: f,
    watchSlides: $,
    watchDrag: T,
    watchFocus: A
  } = l, R = 2, V = co(), P = V.measure(n), q = t.map(V.measure), j = ro(r, d), Y = j.measureSize(P), N = fo(Y), F = lo(i, Y), X = !c && !!b, Q = c || !!b, {
    slideSizes: I,
    slideSizesWithGaps: J,
    startGap: Z,
    endGap: ne
  } = To(j, P, q, t, Q, a), pe = Eo(j, Y, M, c, P, q, Z, ne, R), {
    snaps: De,
    snapsAligned: ee
  } = xo(j, F, P, q, pe), re = -Pe(De) + Pe(J), {
    snapsContained: ve,
    scrollContainLimit: xe
  } = vo(Y, re, ee, b, R), ke = X ? ve : ee, {
    limit: Ce
  } = ho(re, ke, c), je = La(Bt(ke), m, c), Be = je.clone(), ce = Mt(t), G = ({
    dragHandler: We,
    scrollBody: an,
    scrollBounds: sn,
    options: {
      loop: zt
    }
  }, ln) => {
    zt || sn.constrain(We.pointerDown()), an.seek(ln);
  }, ie = ({
    scrollBody: We,
    translate: an,
    location: sn,
    offsetLocation: zt,
    scrollLooper: ln,
    slideLooper: Ua,
    dragHandler: Wa,
    animation: qa,
    eventHandler: Wn,
    scrollBounds: Ya,
    options: {
      loop: qn
    }
  }, Yn) => {
    const Gn = We.settled(), Ga = !Ya.shouldConstrain(), Kn = qn ? Gn : Gn && Ga;
    Kn && !Wa.pointerDown() && (qa.stop(), Wn.emit("settle")), Kn || Wn.emit("scroll");
    const Ka = sn.get() * Yn + _e.get() * (1 - Yn);
    zt.set(Ka), qn && (ln.loop(We.direction()), Ua.loop()), an.to(zt.get());
  }, he = oo(o, a, (We) => G(nn, We), (We) => ie(nn, We)), Se = 0.68, Oe = ke[je.get()], He = yt(Oe), _e = yt(Oe), Ue = yt(Oe), Ze = yt(Oe), vt = mo(He, Ue, _e, Ze, g, Se), en = wo(c, ke, re, Ce, Ze), tn = $o(he, je, Be, vt, en, Ze, s), Nn = bo(Ce), _n = Tt(), Na = Do(n, t, s, y), {
    slideRegistry: Un
  } = ko(X, b, ke, xe, pe, ce), _a = Co(e, t, Un, tn, vt, _n, s, A), nn = {
    ownerDocument: o,
    ownerWindow: a,
    eventHandler: s,
    containerRect: P,
    slideRects: q,
    animation: he,
    axis: j,
    dragHandler: io(j, e, o, a, Ze, uo(j, a), He, he, tn, vt, en, je, s, N, h, v, S, Se, T),
    eventStore: _n,
    percentOfView: N,
    index: je,
    indexPrevious: Be,
    limit: Ce,
    location: He,
    offsetLocation: Ue,
    previousLocation: _e,
    options: l,
    resizeHandler: po(n, s, a, t, j, f, V),
    scrollBody: vt,
    scrollBounds: go(Ce, Ue, Ze, vt, N),
    scrollLooper: yo(re, Ce, Ue, [He, Ue, _e, Ze]),
    scrollProgress: Nn,
    scrollSnapList: ke.map(Nn.get),
    scrollSnaps: ke,
    scrollTarget: en,
    scrollTo: tn,
    slideLooper: So(j, Y, re, I, J, De, ke, Ue, t),
    slideFocus: _a,
    slidesHandler: Mo(n, s, $),
    slidesInView: Na,
    slideIndexes: ce,
    slideRegistry: Un,
    slidesToScroll: pe,
    target: Ze,
    translate: Aa(j, n)
  };
  return nn;
}
function Bo() {
  let e = {}, n;
  function t(d) {
    n = d;
  }
  function o(d) {
    return e[d] || [];
  }
  function a(d) {
    return o(d).forEach((m) => m(n, d)), r;
  }
  function l(d, m) {
    return e[d] = o(d).concat([m]), r;
  }
  function s(d, m) {
    return e[d] = o(d).filter((c) => c !== m), r;
  }
  function i() {
    e = {};
  }
  const r = {
    init: t,
    emit: a,
    off: s,
    on: l,
    clear: i
  };
  return r;
}
const zo = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Lo(e) {
  function n(l, s) {
    return za(l, s || {});
  }
  function t(l) {
    const s = l.breakpoints || {}, i = Dt(s).filter((r) => e.matchMedia(r).matches).map((r) => s[r]).reduce((r, d) => n(r, d), {});
    return n(l, i);
  }
  function o(l) {
    return l.map((s) => Dt(s.breakpoints || {})).reduce((s, i) => s.concat(i), []).map(e.matchMedia);
  }
  return {
    mergeOptions: n,
    optionsAtMedia: t,
    optionsMediaQueries: o
  };
}
function Ao(e) {
  let n = [];
  function t(l, s) {
    return n = s.filter(({
      options: i
    }) => e.optionsAtMedia(i).active !== !1), n.forEach((i) => i.init(l, e)), s.reduce((i, r) => Object.assign(i, {
      [r.name]: r
    }), {});
  }
  function o() {
    n = n.filter((l) => l.destroy());
  }
  return {
    init: t,
    destroy: o
  };
}
function Nt(e, n, t) {
  const o = e.ownerDocument, a = o.defaultView, l = Lo(a), s = Ao(l), i = Tt(), r = Bo(), {
    mergeOptions: d,
    optionsAtMedia: m,
    optionsMediaQueries: c
  } = l, {
    on: g,
    off: h,
    emit: v
  } = r, y = j;
  let M = !1, S, b = d(zo, Nt.globalOptions), f = d(b), $ = [], T, A, R;
  function V() {
    const {
      container: ce,
      slides: G
    } = f;
    A = (bn(ce) ? e.querySelector(ce) : ce) || e.children[0];
    const he = bn(G) ? A.querySelectorAll(G) : G;
    R = [].slice.call(he || A.children);
  }
  function P(ce) {
    const G = Vo(e, A, R, o, a, ce, r);
    if (ce.loop && !G.slideLooper.canLoop()) {
      const ie = Object.assign({}, ce, {
        loop: !1
      });
      return P(ie);
    }
    return G;
  }
  function q(ce, G) {
    M || (b = d(b, ce), f = m(b), $ = G || $, V(), S = P(f), c([b, ...$.map(({
      options: ie
    }) => ie)]).forEach((ie) => i.add(ie, "change", j)), f.active && (S.translate.to(S.location.get()), S.animation.init(), S.slidesInView.init(), S.slideFocus.init(Be), S.eventHandler.init(Be), S.resizeHandler.init(Be), S.slidesHandler.init(Be), S.options.loop && S.slideLooper.loop(), A.offsetParent && R.length && S.dragHandler.init(Be), T = s.init(Be, $)));
  }
  function j(ce, G) {
    const ie = pe();
    Y(), q(d({
      startIndex: ie
    }, ce), G), r.emit("reInit");
  }
  function Y() {
    S.dragHandler.destroy(), S.eventStore.clear(), S.translate.clear(), S.slideLooper.clear(), S.resizeHandler.destroy(), S.slidesHandler.destroy(), S.slidesInView.destroy(), S.animation.destroy(), s.destroy(), i.clear();
  }
  function N() {
    M || (M = !0, i.clear(), Y(), r.emit("destroy"), r.clear());
  }
  function F(ce, G, ie) {
    !f.active || M || (S.scrollBody.useBaseFriction().useDuration(G === !0 ? 0 : f.duration), S.scrollTo.index(ce, ie || 0));
  }
  function X(ce) {
    const G = S.index.add(1).get();
    F(G, ce, -1);
  }
  function Q(ce) {
    const G = S.index.add(-1).get();
    F(G, ce, 1);
  }
  function I() {
    return S.index.add(1).get() !== pe();
  }
  function J() {
    return S.index.add(-1).get() !== pe();
  }
  function Z() {
    return S.scrollSnapList;
  }
  function ne() {
    return S.scrollProgress.get(S.location.get());
  }
  function pe() {
    return S.index.get();
  }
  function De() {
    return S.indexPrevious.get();
  }
  function ee() {
    return S.slidesInView.get();
  }
  function re() {
    return S.slidesInView.get(!1);
  }
  function ve() {
    return T;
  }
  function xe() {
    return S;
  }
  function ke() {
    return e;
  }
  function Ce() {
    return A;
  }
  function je() {
    return R;
  }
  const Be = {
    canScrollNext: I,
    canScrollPrev: J,
    containerNode: Ce,
    internalEngine: xe,
    destroy: N,
    off: h,
    on: g,
    emit: v,
    plugins: ve,
    previousScrollSnap: De,
    reInit: y,
    rootNode: ke,
    scrollNext: X,
    scrollPrev: Q,
    scrollProgress: ne,
    scrollSnapList: Z,
    scrollTo: F,
    selectedScrollSnap: pe,
    slideNodes: je,
    slidesInView: ee,
    slidesNotInView: re
  };
  return q(n, t), setTimeout(() => r.emit("init"), 0), Be;
}
Nt.globalOptions = void 0;
function On(e = {}, n = []) {
  const t = ct(e), o = ct(n);
  let a = t ? e.value : e, l = o ? n.value : n;
  const s = pn(), i = pn();
  function r() {
    i.value && i.value.reInit(a, l);
  }
  return Ke(() => {
    !no() || !s.value || (Nt.globalOptions = On.globalOptions, i.value = Nt(s.value, a, l));
  }), wn(() => {
    i.value && i.value.destroy();
  }), t && de(e, (d) => {
    Ln(a, d) || (a = d, r());
  }), o && de(n, (d) => {
    ao(l, d) || (l = d, r());
  }), [s, i];
}
On.globalOptions = void 0;
function et() {
  return et = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, et.apply(this, arguments);
}
var Io = 0.996, Po = function(n, t) {
  return t === void 0 && (t = Io), n * t / (1 - t);
};
function Oo(e) {
  return e[e.length - 1];
}
function Fo(e) {
  return e.reduce(function(n, t) {
    return n + t;
  }) / e.length;
}
var Ro = function(n, t, o) {
  return Math.min(Math.max(t, n), o);
};
function dn(e, n) {
  if (e.length !== n.length)
    throw new Error("vectors must be same length");
  return e.map(function(t, o) {
    return t + n[o];
  });
}
function sa(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function mt(e) {
  return Object.freeze(e), Object.values(e).forEach(function(n) {
    n !== null && typeof n == "object" && !Object.isFrozen(n) && mt(n);
  }), e;
}
function jo() {
  var e = {};
  function n(a, l) {
    return e[a] = (e[a] || []).concat(l), function() {
      return t(a, l);
    };
  }
  function t(a, l) {
    e[a] = (e[a] || []).filter(function(s) {
      return s !== l;
    });
  }
  function o(a, l) {
    a in e && e[a].forEach(function(s) {
      return s(l);
    });
  }
  return mt({
    on: n,
    off: t,
    dispatch: o
  });
}
function Ho(e) {
  var n = [], t = function(s) {
    return s.addEventListener("wheel", e, {
      passive: !1
    }), n.push(s), function() {
      return o(s);
    };
  }, o = function(s) {
    s.removeEventListener("wheel", e), n = n.filter(function(i) {
      return i !== s;
    });
  }, a = function() {
    n.forEach(o);
  };
  return mt({
    observe: t,
    unobserve: o,
    disconnect: a
  });
}
var No = 16 * 1.125, _o = typeof window < "u" && window.innerHeight || 800, cn = [1, No, _o];
function Uo(e) {
  var n = e.deltaX * cn[e.deltaMode], t = e.deltaY * cn[e.deltaMode], o = (e.deltaZ || 0) * cn[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [n, t, o]
  };
}
var Wo = [-1, -1, -1];
function qo(e, n) {
  if (!n)
    return e;
  var t = n === !0 ? Wo : n.map(function(o) {
    return o ? -1 : 1;
  });
  return et({}, e, {
    axisDelta: e.axisDelta.map(function(o, a) {
      return o * t[a];
    })
  });
}
var la = 700, Yo = function(n) {
  return et({}, n, {
    axisDelta: n.axisDelta.map(function(t) {
      return Ro(t, -la, la);
    })
  });
}, fn = process.env.NODE_ENV !== "production", Go = 0.6, Ko = 0.96, Xo = 2, oa = 5, ra = /* @__PURE__ */ mt({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), Zo = 400;
function ia() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: Zo
  };
}
function Jo(e) {
  e === void 0 && (e = {});
  var n = jo(), t = n.on, o = n.off, a = n.dispatch, l = ra, s = ia(), i, r = !1, d, m = function(F) {
    Array.isArray(F) ? F.forEach(function(X) {
      return v(X);
    }) : v(F);
  }, c = function(F) {
    return F === void 0 && (F = {}), Object.values(F).some(function(X) {
      return X == null;
    }) ? (fn && console.error("updateOptions ignored! undefined & null options not allowed"), l) : l = mt(et({}, ra, l, F));
  }, g = function(F) {
    var X = et({
      event: i,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: s.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: s.axisVelocity,
      axisMovement: s.axisMovement,
      get axisMovementProjection() {
        return dn(X.axisMovement, X.axisVelocity.map(function(Q) {
          return Po(Q);
        }));
      }
    }, F);
    a("wheel", et({}, X, {
      previous: d
    })), d = X;
  }, h = function(F, X) {
    var Q = l, I = Q.preventWheelAction, J = X[0], Z = X[1], ne = X[2];
    if (typeof I == "boolean") return I;
    switch (I) {
      case "x":
        return Math.abs(J) >= F;
      case "y":
        return Math.abs(Z) >= F;
      case "z":
        return Math.abs(ne) >= F;
      default:
        return fn && console.warn("unsupported preventWheelAction value: " + I, "warn"), !1;
    }
  }, v = function(F) {
    var X = Yo(qo(Uo(F), l.reverseSign)), Q = X.axisDelta, I = X.timeStamp, J = sa(Q);
    if (F.preventDefault && h(J, Q) && F.preventDefault(), s.isStarted ? s.isMomentum && J > Math.max(2, s.lastAbsDelta * 2) && (V(!0), A()) : A(), J === 0 && Object.is && Object.is(F.deltaX, -0)) {
      r = !0;
      return;
    }
    i = F, s.axisMovement = dn(s.axisMovement, Q), s.lastAbsDelta = J, s.scrollPointsToMerge.push({
      axisDelta: Q,
      timeStamp: I
    }), y(), g({
      axisDelta: Q,
      isStart: !s.isStartPublished
    }), s.isStartPublished = !0, R();
  }, y = function() {
    s.scrollPointsToMerge.length === Xo ? (s.scrollPoints.unshift({
      axisDeltaSum: s.scrollPointsToMerge.map(function(F) {
        return F.axisDelta;
      }).reduce(dn),
      timeStamp: Fo(s.scrollPointsToMerge.map(function(F) {
        return F.timeStamp;
      }))
    }), S(), s.scrollPointsToMerge.length = 0, s.scrollPoints.length = 1, s.isMomentum || $()) : s.isStartPublished || M();
  }, M = function() {
    s.axisVelocity = Oo(s.scrollPointsToMerge).axisDelta.map(function(F) {
      return F / s.willEndTimeout;
    });
  }, S = function() {
    var F = s.scrollPoints, X = F[0], Q = F[1];
    if (!(!Q || !X)) {
      var I = X.timeStamp - Q.timeStamp;
      if (I <= 0) {
        fn && console.warn("invalid deltaTime");
        return;
      }
      var J = X.axisDeltaSum.map(function(ne) {
        return ne / I;
      }), Z = J.map(function(ne, pe) {
        return ne / (s.axisVelocity[pe] || 1);
      });
      s.axisVelocity = J, s.accelerationFactors.push(Z), b(I);
    }
  }, b = function(F) {
    var X = Math.ceil(F / 10) * 10 * 1.2;
    s.isMomentum || (X = Math.max(100, X * 2)), s.willEndTimeout = Math.min(1e3, Math.round(X));
  }, f = function(F) {
    return F === 0 ? !0 : F <= Ko && F >= Go;
  }, $ = function() {
    if (s.accelerationFactors.length >= oa) {
      if (r && (r = !1, sa(s.axisVelocity) >= 0.2)) {
        T();
        return;
      }
      var F = s.accelerationFactors.slice(oa * -1), X = F.every(function(Q) {
        var I = !!Q.reduce(function(Z, ne) {
          return Z && Z < 1 && Z === ne ? 1 : 0;
        }), J = Q.filter(f).length === Q.length;
        return I || J;
      });
      X && T(), s.accelerationFactors = F;
    }
  }, T = function() {
    s.isMomentum = !0;
  }, A = function() {
    s = ia(), s.isStarted = !0, s.startTime = Date.now(), d = void 0, r = !1;
  }, R = /* @__PURE__ */ function() {
    var N;
    return function() {
      clearTimeout(N), N = setTimeout(V, s.willEndTimeout);
    };
  }(), V = function(F) {
    F === void 0 && (F = !1), s.isStarted && (s.isMomentum && F ? g({
      isEnding: !0,
      isMomentumCancel: !0
    }) : g({
      isEnding: !0
    }), s.isMomentum = !1, s.isStarted = !1);
  }, P = Ho(m), q = P.observe, j = P.unobserve, Y = P.disconnect;
  return c(e), mt({
    on: t,
    off: o,
    observe: q,
    unobserve: j,
    disconnect: Y,
    feedWheel: m,
    updateOptions: c
  });
}
var Qo = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
Fn.globalOptions = void 0;
var er = process.env.NODE_ENV !== "production";
function Fn(e) {
  e === void 0 && (e = {});
  var n, t = function() {
  };
  function o(l, s) {
    var i, r, d = s.mergeOptions, m = s.optionsAtMedia, c = d(Qo, Fn.globalOptions), g = d(c, e);
    n = m(g);
    var h = l.internalEngine(), v = (i = n.target) != null ? i : l.containerNode().parentNode, y = (r = n.forceWheelAxis) != null ? r : h.options.axis, M = Jo({
      preventWheelAction: y,
      reverseSign: [!0, !0, !1]
    }), S = M.observe(v), b = M.on("wheel", Y), f = !1, $;
    function T(N) {
      try {
        $ = new MouseEvent("mousedown", N.event), j($);
      } catch {
        return er && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), t();
      }
      f = !0, R(), n.wheelDraggingClass && v.classList.add(n.wheelDraggingClass);
    }
    function A(N) {
      f = !1, j(q("mouseup", N)), V(), n.wheelDraggingClass && v.classList.remove(n.wheelDraggingClass);
    }
    function R() {
      document.documentElement.addEventListener("mousemove", P, !0), document.documentElement.addEventListener("mouseup", P, !0), document.documentElement.addEventListener("mousedown", P, !0);
    }
    function V() {
      document.documentElement.removeEventListener("mousemove", P, !0), document.documentElement.removeEventListener("mouseup", P, !0), document.documentElement.removeEventListener("mousedown", P, !0);
    }
    function P(N) {
      f && N.isTrusted && N.stopImmediatePropagation();
    }
    function q(N, F) {
      var X, Q;
      if (y === h.options.axis) {
        var I = F.axisMovement;
        X = I[0], Q = I[1];
      } else {
        var J = F.axisMovement;
        Q = J[0], X = J[1];
      }
      if (!h.options.skipSnaps && !h.options.dragFree) {
        var Z = h.containerRect.width, ne = h.containerRect.height;
        X = X < 0 ? Math.max(X, -Z) : Math.min(X, Z), Q = Q < 0 ? Math.max(Q, -ne) : Math.min(Q, ne);
      }
      return new MouseEvent(N, {
        clientX: $.clientX + X,
        clientY: $.clientY + Q,
        screenX: $.screenX + X,
        screenY: $.screenY + Q,
        movementX: X,
        movementY: Q,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function j(N) {
      l.containerNode().dispatchEvent(N);
    }
    function Y(N) {
      var F = N.axisDelta, X = F[0], Q = F[1], I = y === "x" ? X : Q, J = y === "x" ? Q : X, Z = N.isMomentum && N.previous && !N.previous.isMomentum, ne = N.isEnding && !N.isMomentum || Z, pe = Math.abs(I) > Math.abs(J);
      pe && !f && !N.isMomentum && T(N), f && (ne ? A(N) : j(q("mousemove", N)));
    }
    t = function() {
      S(), b(), V();
    };
  }
  var a = {
    name: "wheelGestures",
    options: e,
    init: o,
    destroy: function() {
      return t();
    }
  };
  return a;
}
const tr = { class: "relative size-[4em]" }, nr = {
  class: "size-full",
  viewBox: "0 0 100 100"
}, ar = ["d"], sr = ["d"], ua = 45, lr = /* @__PURE__ */ W({
  __name: "CfgCircularProgress",
  props: /* @__PURE__ */ se({
    circleClass: { default: "stroke-brand" },
    useBackground: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = 2 * Math.PI * ua, t = me(e, "modelValue"), o = B(() => {
      const l = ua;
      return `
          M 50 50
          m 0 -${l}
          a ${l} ${l} 0 1 1 0 ${l * 2}
          a ${l} ${l} 0 1 1 0 -${l * 2}
          `;
    }), a = B(() => t.value / 100 * n);
    return (l, s) => (p(), w("div", tr, [
      C(u(Ms), {
        modelValue: t.value,
        "onUpdate:modelValue": s[0] || (s[0] = (i) => t.value = i),
        "as-child": ""
      }, {
        default: k(() => [
          (p(), w("svg", nr, [
            l.useBackground ? (p(), w("path", {
              key: 0,
              class: "fill-none stroke-grey-50 stroke-[8px]",
              d: o.value
            }, null, 8, ar)) : E("", !0),
            C(u(Ds), { "as-child": "" }, {
              default: k(() => [
                x("path", {
                  class: D(["fill-none stroke-[8px] transition-[stroke-dasharray,opacity] duration-700 data-[value='0']:opacity-0", l.circleClass]),
                  d: o.value,
                  style: Ae({
                    "stroke-linecap": "round",
                    "stroke-dasharray": `${a.value}px, ${n}px`,
                    "stroke-dashoffset": "0px"
                  })
                }, null, 14, sr)
              ]),
              _: 1
            })
          ]))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
}), or = { class: "flex" }, rr = { key: 0 }, ir = { class: "mt-5 flex items-center justify-center gap-x-3" }, da = 4e3, Dd = /* @__PURE__ */ W({
  __name: "CfgCarousel",
  props: {
    items: {},
    dots: { type: Boolean, default: !1 },
    wheelGestures: { type: Boolean, default: !1 },
    autoplay: { type: [Boolean, Object], default: !1 },
    options: { default: () => ({}) }
  },
  setup(e) {
    const n = B(() => ({
      // TODO: Add more options per usecase
      containScroll: !1,
      ...e.options
    })), t = B(() => {
      const f = [];
      if (e.wheelGestures && f.push(Fn(typeof e.wheelGestures == "boolean" ? {} : e.wheelGestures)), e.autoplay) {
        const $ = {
          stopOnInteraction: !1
        };
        f.push(zn(typeof e.autoplay == "boolean" ? $ : { ...$, ...e.autoplay }));
      }
      return f;
    }), [o, a] = On(n.value, t.value), l = U(!1), s = U(!1), i = U(0), r = U([]), d = U(100), m = U(null), c = B(() => {
      var f;
      return typeof e.autoplay == "boolean" ? da : ((f = e.autoplay) == null ? void 0 : f.delay) || da;
    });
    function g(f) {
      r.value = (f == null ? void 0 : f.scrollSnapList()) || [];
    }
    function h(f) {
      l.value = (f == null ? void 0 : f.canScrollNext()) || !1, s.value = (f == null ? void 0 : f.canScrollPrev()) || !1, i.value = (f == null ? void 0 : f.selectedScrollSnap()) || 0;
    }
    function v() {
      var f;
      (f = a.value) == null || f.scrollPrev();
    }
    function y() {
      var f;
      (f = a.value) == null || f.scrollNext();
    }
    function M(f) {
      var $;
      ($ = a.value) == null || $.scrollTo(f);
    }
    function S(f) {
      const $ = "ArrowLeft", T = "ArrowRight";
      if (f.key === $) {
        f.preventDefault(), v();
        return;
      }
      f.key === T && (f.preventDefault(), y());
    }
    Ke(() => {
      var f, $, T, A, R;
      a.value && ((f = a.value) == null || f.on("init", g), ($ = a.value) == null || $.on("init", h), (T = a.value) == null || T.on("reInit", g), (A = a.value) == null || A.on("reInit", h), (R = a.value) == null || R.on("select", h));
    }), Xa(() => {
      clearInterval(m.value || 0);
    });
    function b() {
      clearInterval(m.value || 0), d.value = 0, m.value = setInterval(() => {
        const f = 1 / c.value * 1e5;
        d.value += f, d.value >= 100 && clearInterval(m.value || 0);
      }, 1e3);
    }
    return de(i, () => {
      !e.autoplay || !e.dots || b();
    }, { immediate: !0 }), (f, $) => (p(), w("section", {
      "aria-roledescription": "carousel",
      role: "region",
      tabindex: "0",
      onKeydown: S
    }, [
      x("div", {
        ref_key: "emblaRef",
        ref: o,
        class: "hide-scrollbar overflow-hidden"
      }, [
        x("ul", or, [
          (p(!0), w(te, null, ue(f.items, (T, A) => (p(), w("li", {
            key: A,
            "aria-roledescription": "slide",
            class: D(["shrink-0 grow-0 px-2", {
              "size-full": !f.wheelGestures,
              "size-4/5": f.wheelGestures
            }]),
            role: "group"
          }, [
            z(f.$slots, "items", {
              index: A,
              item: T
            })
          ], 2))), 128))
        ]),
        f.dots ? (p(), w("div", rr, [
          z(f.$slots, "dot", {
            scrollTo: M,
            selectedIndex: i.value
          }, () => [
            x("ul", ir, [
              (p(!0), w(te, null, ue(f.items, (T, A) => (p(), w("li", { key: A }, [
                C(lr, {
                  class: D(["transition-all duration-200", {
                    "!size-[24px]": A === i.value,
                    "!size-[16px] opacity-50": A !== i.value
                  }]),
                  "model-value": A === i.value ? d.value : 100,
                  "use-background": "",
                  onClick: (R) => M(A)
                }, null, 8, ["class", "model-value", "onClick"])
              ]))), 128))
            ])
          ])
        ])) : E("", !0)
      ], 512)
    ], 32));
  }
}), be = {
  required: {
    type: Boolean,
    default: !1
  },
  /**
   * Placeholder text
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * Field error state (will show error message if provided and set to true)
   */
  error: {
    type: Boolean,
    default: !1
  },
  /**
   * Field error message
   */
  errorMessage: {
    type: String,
    default: ""
  },
  /**
   * Caption text. Will be shown below input. Recommended length is 2-3 words, like 'Enter your name'.
   * In case of error, will be replaced with error message
   */
  caption: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Will set input focus on mount
   */
  initialFocused: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, Ve = {
  ...be,
  /**
   * Input type like text, number, email, etc.
   */
  type: {
    type: String,
    default: "text"
  },
  /**
   * Will make input fluid (100% width)
   */
  fluid: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  /**
   * Input suffix. The Recommended length is 2-3 characters, like 'Let'
   */
  suffix: {
    type: String,
    default: ""
  },
  transformToCommaDelimiter: {
    type: Boolean,
    default: void 0
  }
}, ur = { class: "flex" }, dr = { class: "cfg-checkbox__checkbox flex size-[1.3em] items-center" }, cr = ["id", "disabled"], fr = { class: "flex" }, pr = ["innerHTML"], mr = {
  key: 0,
  class: "text-red"
}, gr = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "CfgCheckbox",
  props: /* @__PURE__ */ se({
    ...be,
    inputClasses: {
      type: String,
      default: ""
    },
    focused: {
      type: Boolean,
      default: !1
    },
    link: {
      type: String,
      default: ""
    }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ se(["update:focused"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, o = n, { class: a, ...l } = Wt(), s = B(() => l.id || lt()), i = jt("inputRef"), r = me(e, "modelValue"), d = B(() => ({
      root: {
        class: a || "",
        ...t.link ? { href: t.link } : {}
      },
      input: l
    })), { focused: m } = gt(i, {
      initialValue: t.initialFocused
    });
    return de(m, (c) => {
      o("update:focused", c);
    }), de(() => t.focused, (c) => {
      m.value = c;
    }), (c, g) => (p(), L(Me(e.link ? "a" : "span"), ae(d.value.root, {
      class: ["cfg-checkbox relative block", {
        focused: e.focused,
        disabled: c.disabled,
        "opacity-60": c.disabled,
        "cursor-pointer": !c.disabled,
        "cursor-not-allowed": c.disabled
      }],
      onClick: g[3] || (g[3] = Le((h) => r.value = !r.value, ["prevent"]))
    }), {
      default: k(() => [
        x("span", ur, [
          x("label", dr, [
            Et(x("input", ae({
              id: String(s.value),
              ref_key: "inputRef",
              ref: i,
              "onUpdate:modelValue": g[0] || (g[0] = (h) => r.value = h)
            }, d.value.input, {
              class: ["relative z-10 size-[1.3em] rounded border-grey-stroke text-brand focus:ring-brand-200", e.inputClasses],
              disabled: c.disabled,
              type: "checkbox",
              onClick: g[1] || (g[1] = Le(() => {
              }, ["stop"]))
            }), null, 16, cr), [
              [Za, r.value]
            ])
          ]),
          x("span", {
            class: D(["ml-3 block text-sm", {
              "text-red": c.error
            }])
          }, [
            C(_, {
              class: D(["block", {
                "cursor-pointer": !c.disabled,
                "cursor-not-allowed": c.disabled,
                "pt-1": !c.caption && !c.$slots.label && !c.placeholder,
                "text-grey-400": !c.error
              }]),
              for: String(s.value),
              size: u(H).sm,
              "tag-name": "label",
              onClick: g[2] || (g[2] = Le(() => {
              }, ["stop"]))
            }, {
              default: k(() => [
                c.$slots.label || c.placeholder ? z(c.$slots, "label", {
                  key: 0,
                  checked: e.modelValue,
                  focused: e.focused
                }, () => [
                  x("span", fr, [
                    x("span", {
                      class: "leading-6",
                      innerHTML: c.placeholder
                    }, null, 8, pr),
                    c.required ? (p(), w("span", mr, "*")) : E("", !0)
                  ])
                ], !0) : E("", !0)
              ]),
              _: 3
            }, 8, ["class", "for", "size"]),
            c.caption && c.placeholder ? (p(), L(_, {
              key: 0,
              class: D(["mt-1 block", {
                "text-grey-300": !c.error
              }]),
              size: u(H).xs
            }, {
              default: k(() => [
                K(O(c.caption), 1)
              ]),
              _: 1
            }, 8, ["class", "size"])) : E("", !0)
          ], 2)
        ]),
        c.error && c.errorMessage ? (p(), L(_, {
          key: 0,
          class: "mt-3 block text-red",
          size: u(H).xs
        }, {
          default: k(() => [
            K(O(c.errorMessage), 1)
          ]),
          _: 1
        }, 8, ["size"])) : c.caption && !c.placeholder ? (p(), L(_, {
          key: 1,
          class: "mt-3 block text-grey-300",
          size: u(H).xs
        }, {
          default: k(() => [
            K(O(c.caption), 1)
          ]),
          _: 1
        }, 8, ["size"])) : E("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), _t = /* @__PURE__ */ Xe(gr, [["__scopeId", "data-v-f380d145"]]), vr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _t
}, Symbol.toStringTag, { value: "Module" })), Te = {
  default: "brand",
  blue: "blue",
  success: "success",
  warning: "warning",
  danger: "danger",
  neutral: "neutral"
}, hr = { class: "cfg-assist-chip__content" }, Td = /* @__PURE__ */ W({
  __name: "CfgChip",
  props: {
    label: {},
    color: { default: Te.default }
  },
  setup(e) {
    const n = e, t = B(() => ({
      background: {
        "bg-brand-light": n.color === Te.default,
        "bg-blue/20": n.color === Te.blue,
        "bg-success/20": n.color === Te.success,
        "bg-warning/20": n.color === Te.warning,
        "bg-red/20": n.color === Te.danger,
        "bg-grey-100": n.color === Te.neutral
      },
      text: {
        "text-brand": n.color === Te.default,
        "text-blue": n.color === Te.blue,
        "text-success": n.color === Te.success,
        "text-warning": n.color === Te.warning,
        "text-red": n.color === Te.danger,
        "text-black": n.color === Te.neutral
      }
    }));
    return (o, a) => (p(), w("span", {
      class: D(["cfg-assist-chip", { ...t.value.background, ...t.value.text }])
    }, [
      x("span", hr, [
        o.$slots.leadingIcon ? z(o.$slots, "leadingIcon", { key: 0 }) : E("", !0),
        C(_, {
          size: u(H).xs
        }, {
          default: k(() => [
            o.$slots.default ? z(o.$slots, "default", { key: 0 }) : (p(), w(te, { key: 1 }, [
              K(O(n.label), 1)
            ], 64))
          ]),
          _: 3
        }, 8, ["size"])
      ])
    ], 2));
  }
}), yr = { class: "relative block" }, br = ["value"], xr = {
  inheritAttrs: !1
}, ca = /* @__PURE__ */ W({
  ...xr,
  __name: "CfgCompactInput",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    /**
     * @param string
     * Suffix to be displayed after the input. Recommended length is 2-3 characters.
     */
    suffix: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur", "keydown:enter"],
  setup(e, { emit: n }) {
    const t = n;
    function o(s) {
      var i;
      t("update:modelValue", ((i = s == null ? void 0 : s.target) == null ? void 0 : i.value) || "");
    }
    function a(s) {
      var i;
      t("blur", ((i = s == null ? void 0 : s.target) == null ? void 0 : i.value) || "");
    }
    function l(s) {
      var i;
      t("keydown:enter", ((i = s == null ? void 0 : s.target) == null ? void 0 : i.value) || "");
    }
    return (s, i) => {
      var r;
      return p(), w("label", yr, [
        x("input", ae({
          class: ["cfg-slider__input focusable w-full rounded-md border border-grey-stroke px-3 py-2 text-xs !leading-none", {
            "!pr-11": !!((r = e.suffix) != null && r.trim())
          }],
          value: e.modelValue
        }, s.$attrs, {
          onBlur: a,
          onInput: o,
          onKeydown: Re(l, ["enter"])
        }), null, 16, br),
        e.suffix ? (p(), L(_, {
          key: 0,
          class: "absolute right-4 top-1/2 -translate-y-1/2 leading-none text-grey-300",
          size: u(H).xs
        }, {
          default: k(() => [
            K(O(e.suffix), 1)
          ]),
          _: 1
        }, 8, ["size"])) : E("", !0)
      ]);
    };
  }
});
function fa(e) {
  return typeof e == "function" ? e() : u(e);
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const kr = (e) => e != null;
function wr(e, n = {}) {
  let t;
  const { immediate: o, ...a } = n, l = U(!1), s = U(!1), i = (g) => t && t.activate(g), r = (g) => t && t.deactivate(g), d = () => {
    t && (t.pause(), s.value = !0);
  }, m = () => {
    t && (t.unpause(), s.value = !1);
  }, c = B(() => {
    const g = fa(e);
    return (Array.isArray(g) ? g : [g]).map((h) => {
      const v = fa(h);
      return typeof v == "string" ? v : ps(v);
    }).filter(kr);
  });
  return de(
    c,
    (g) => {
      g.length && (t = tl(g, {
        ...a,
        onActivate() {
          l.value = !0, n.onActivate && n.onActivate();
        },
        onDeactivate() {
          l.value = !1, n.onDeactivate && n.onDeactivate();
        }
      }), o && i());
    },
    { flush: "post" }
  ), ms(() => r()), {
    hasFocus: l,
    isPaused: s,
    activate: i,
    deactivate: r,
    pause: d,
    unpause: m
  };
}
const $r = ["aria-expanded"], Cr = {
  inheritAttrs: !1
}, Sr = /* @__PURE__ */ W({
  ...Cr,
  __name: "CfgDropdown",
  props: {
    /**
     * Controls the position of the menu;
     */
    originX: {
      type: String,
      default: "right"
    },
    /**
     * Controls showing overlay under other elements
     */
    overlay: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: String,
      default: "280px"
    },
    hideOnScroll: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { expose: n }) {
    const t = e, o = 50, a = U(!1), l = U(null), s = U(null), i = U(null), r = U(a.value);
    let d = null;
    const { deactivate: m, activate: c } = wr(i, {
      immediate: !1,
      preventScroll: !0,
      clickOutsideDeactivates: !0
    });
    Ke(() => {
      if (gn(document.documentElement, "keydown", (f) => {
        f.key === "Escape" && b();
      }), t.hideOnScroll) {
        let f = 0;
        gn(window, "scroll", () => {
          f += 1, f > 3 && (b(), f = 0);
        });
      }
    });
    const { x: g, y: h, strategy: v } = Sn(s, i, {
      placement: "bottom-end",
      whileElementsMounted: Mn
    });
    de(a, (f) => {
      f || (d && (clearTimeout(d), d = null), d = setTimeout(() => {
        r.value = f;
      }, f ? 0 : o), M() && m()), r.value = f;
    });
    function y() {
      M() && c();
    }
    function M() {
      return i.value && i.value.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').length > 0;
    }
    function S() {
      a.value = !0;
    }
    function b() {
      a.value = !1;
    }
    return n({ open: S, close: b }), (f, $) => (p(), w("div", {
      ref_key: "dropdownRoot",
      ref: l
    }, [
      x("div", ae(f.$attrs, {
        class: ["relative w-max", {
          "z-floating-overlay": a.value && e.overlay
        }]
      }), [
        x("div", {
          ref_key: "menuButton",
          ref: s
        }, [
          x("button", {
            "aria-expanded": a.value,
            class: D(["focusable flex cursor-pointer items-center justify-center", {
              "relative z-floating-trigger rounded-t-xl bg-white": a.value && e.overlay,
              "lg:hover:bor==der-brand rounded-xl hover:!text-brand": !a.value && e.overlay,
              "border-2 border-transparent !transition-all !duration-300": e.overlay
            }]),
            type: "button",
            onClick: $[0] || ($[0] = (T) => a.value ? b() : S())
          }, [
            z(f.$slots, "trigger", { opened: a.value })
          ], 10, $r)
        ], 512),
        (p(), L($n, { to: "body" }, [
          x("div", {
            class: D(["fixed inset-0 z-floating-overlay", {
              "pointer-events-none opacity-0": !a.value,
              "bg-black/30": e.overlay
            }]),
            onClick: b,
            onKeydown: Re(() => {
            }, ["enter"])
          }, null, 34),
          C(nt, {
            "enter-active-class": "transition duration-200 ease-out",
            "enter-from-class": "transform scale-75 -translate-y-3 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
            "leave-active-class": "transition duration-200 ease-out",
            "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
            "leave-to-class": "transform scale-75 -translate-y-3 opacity-0",
            onAfterEnter: y
          }, {
            default: k(() => [
              r.value ? Et((p(), w("div", {
                key: 0,
                ref_key: "dropdownContent",
                ref: i,
                class: D(["dropdown-content z-floating-content w-max bg-white focus:outline-none", {
                  "origin-top-right": e.originX === "right",
                  "left-0 origin-top-left": e.originX === "left",
                  "mt-2 rounded-xl shadow-extra": !e.overlay,
                  "rounded-b-xl rounded-tl-xl": e.overlay
                }]),
                style: Ae({
                  top: `${u(h)}px`,
                  left: `${u(g)}px`,
                  position: u(v),
                  maxWidth: e.maxWidth
                })
              }, [
                z(f.$slots, "default", {
                  close: b,
                  opened: a.value
                })
              ], 6)), [
                [qt, a.value]
              ]) : E("", !0)
            ]),
            _: 3
          })
        ]))
      ], 16)
    ], 512));
  }
}), Mr = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "CfgTransition",
  props: {
    from: {},
    to: {},
    rendered: { type: Boolean },
    as: { default: "span" }
  },
  async setup(e) {
    let n, t;
    const o = ([n, t] = Ut(() => import("gsap")), n = await n, t(), n).default;
    return (a, l) => (p(), L(nt, {
      css: !1,
      onBeforeEnter: l[0] || (l[0] = (s) => {
        u(o).set(s, a.from);
      }),
      onEnter: l[1] || (l[1] = (s, i) => {
        u(o).to(s, { ...a.to, onComplete: i });
      }),
      onLeave: l[2] || (l[2] = (s, i) => {
        u(o).to(s, {
          ...a.from,
          onComplete: i
        });
      })
    }, {
      default: k(() => [
        a.rendered ? (p(), w("span", Ja(ae({ key: 0 }, a.$attrs)), [
          z(a.$slots, "default")
        ], 16)) : E("", !0)
      ]),
      _: 3
    }));
  }
}), Dr = ["aria-pressed"], Tr = { class: "filter-chip__content" }, Er = {
  class: "filter-chip__close-icon",
  style: { "--stroke-width": "2px" }
}, Ed = /* @__PURE__ */ W({
  __name: "CfgFilterChip",
  props: /* @__PURE__ */ se({
    label: {}
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = me(e, "modelValue");
    return (t, o) => (p(), w("button", {
      "aria-pressed": n.value,
      class: D(["filter-chip focusabl", {
        "filter-chip--selected !border-brand-light bg-brand-light focus:!border-brand-light": n.value,
        "!border-grey-300 focus:!border-grey-300": !n.value
      }]),
      type: "button",
      onClick: o[0] || (o[0] = () => {
        t.$attrs.disabled || (n.value = !n.value);
      })
    }, [
      x("span", Tr, [
        t.$slots.leadingIcon ? z(t.$slots, "leadingIcon", { key: 0 }) : E("", !0),
        C(_, {
          size: u(H).sm,
          "tag-name": "span"
        }, {
          default: k(() => [
            K(O(t.label), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      C(Mr, {
        from: {
          width: 0,
          autoAlpha: 0,
          duration: 0.25,
          ease: "power3.out"
        },
        rendered: n.value,
        to: {
          autoAlpha: 1,
          width: 20,
          duration: 0.25,
          ease: "power3.out"
        }
      }, {
        default: k(() => [
          x("span", Er, [
            C(u(Ne), { class: "text-[12px] text-grey-400" })
          ])
        ]),
        _: 1
      }, 8, ["rendered"])
    ], 10, Dr));
  }
}), Vr = {
  primary: "primary",
  secondary: "secondary",
  grey: "grey",
  light: "light",
  warning: "warning",
  dark: "dark"
}, Br = { class: "container mx-auto py-3" }, zr = { class: "flex flex-wrap items-center justify-between" }, Lr = { class: "flex w-0 flex-1 items-center" }, Ar = {
  key: 0,
  class: "cfg-header-banner--icon flex rounded-lg p-2"
}, Ir = {
  key: 1,
  class: "cfg-header-banner--text ml-3"
}, Pr = {
  key: 0,
  class: "order-3 mt-2 w-full shrink-0 sm:order-2 sm:mt-0 sm:w-auto"
}, Or = { class: "order-2 shrink-0 sm:order-3 sm:ml-3" }, Vd = /* @__PURE__ */ W({
  __name: "CfgHeaderBanner",
  props: /* @__PURE__ */ se({
    variant: { default: Vr.primary },
    modelValue: { type: Boolean, default: !0 },
    text: { default: "" },
    buttonText: { default: "" },
    buttonLink: { default: "" }
  }, {
    modelValue: { type: Boolean, default: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = me(e, "modelValue");
    return (t, o) => {
      const a = Qa("RouterLink");
      return Et((p(), w("div", {
        class: D(["cfg-header-banner", { [`cfg-header-banner--${t.variant}`]: !0 }])
      }, [
        x("div", Br, [
          x("div", zr, [
            x("div", Lr, [
              t.$slots.icon ? (p(), w("span", Ar, [
                z(t.$slots, "icon", {
                  ariaHidden: "true",
                  class: "size-6"
                })
              ])) : E("", !0),
              t.text || t.$slots.default ? (p(), w("p", Ir, [
                z(t.$slots, "default", {}, () => [
                  K(O(t.text), 1)
                ])
              ])) : E("", !0)
            ]),
            t.buttonLink ? (p(), w("div", Pr, [
              C(a, {
                class: "cfg-header-banner--link flex items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm",
                to: t.buttonLink
              }, {
                default: k(() => [
                  K(O(t.buttonText || t.buttonLink), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])) : E("", !0),
            x("div", Or, [
              x("button", {
                class: "cfg-header-banner--dismiss -mr-1 flex rounded-md p-2 focus:outline-none focus:ring-2 sm:-mr-2",
                type: "button",
                onClick: o[0] || (o[0] = (l) => n.value = !1)
              }, [
                o[1] || (o[1] = x("span", { class: "sr-only" }, "Dismiss", -1)),
                C(u(Ne), {
                  "aria-hidden": "true",
                  class: "size-6"
                })
              ])
            ])
          ])
        ])
      ], 2)), [
        [qt, n.value]
      ]);
    };
  }
}), Fr = {
  key: 0,
  class: "text-red"
}, Rr = {
  key: 0,
  class: "text-field-template__right absolute top-1/2 flex -translate-y-1/2 items-center justify-center"
}, jr = /* @__PURE__ */ W({
  __name: "AbstractTextField",
  props: {
    required: { type: Boolean },
    placeholder: { default: "" },
    fluid: { type: Boolean },
    error: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    empty: { type: Boolean, default: !0 },
    focused: { type: Boolean },
    placeholderAs: { default: "span" },
    placeholderAttrs: { default: () => ({}) },
    loading: { type: Boolean },
    height: { default: void 0 },
    as: { default: "span" }
  },
  emits: ["update:focused"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = B(() => ({
      "--height": t.height || "var(--input-height)"
    })), l = U(), { focused: s } = gt(l), i = B(() => t.focused || !t.empty);
    return de(s, (r) => {
      o("update:focused", r);
    }), (r, d) => {
      var m, c;
      return p(), L(Me(r.as), {
        ref_key: "textFieldRef",
        ref: l,
        class: D(["text-field-template relative block rounded-xl text-sm transition-all duration-200", {
          "w-full": r.fluid,
          "w-max": !r.fluid,
          "with-right-content": (c = (m = r.$slots).placeRight) == null ? void 0 : c.call(m),
          "opacity-50": r.disabled
        }]),
        style: Ae(a.value),
        onClick: d[0] || (d[0] = () => {
          s.value = !0;
        }),
        onKeypress: d[1] || (d[1] = Re(() => {
          s.value = !0;
        }, ["enter"]))
      }, {
        default: k(() => [
          (p(), L(Me(r.placeholderAs), ae(r.placeholderAttrs, {
            class: ["text-field-template__placeholder absolute left-[var(--pl)] origin-top-left -translate-y-1/2 cursor-text leading-none text-grey-200 transition-all duration-200", {
              active: i.value,
              "text-red": r.error,
              "!text-brand": !r.error && i.value && r.focused
            }]
          }), {
            default: k(() => [
              K(O(r.placeholder) + " ", 1),
              r.required ? (p(), w("span", Fr, "*")) : E("", !0)
            ]),
            _: 1
          }, 16, ["class"])),
          x("span", {
            class: D(["text-field-template__wrapper block rounded-xl border transition duration-200", {
              "border-grey-stroke": !i.value || !r.focused,
              "border-brand": i.value && r.focused,
              "disabled:border-gray-200 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-grey-500": r.disabled,
              "error border-red text-red": r.error
            }])
          }, [
            z(r.$slots, "default", {}, void 0, !0)
          ], 2),
          r.$slots.placeRight || r.loading ? (p(), w("span", Rr, [
            r.loading ? (p(), L(u(Vt), {
              key: 0,
              class: "text-[6px] text-brand"
            })) : z(r.$slots, "placeRight", { key: 1 }, void 0, !0)
          ])) : E("", !0)
        ]),
        _: 3
      }, 40, ["class", "style"]);
    };
  }
}), Rn = /* @__PURE__ */ Xe(jr, [["__scopeId", "data-v-7871f9f5"]]), Hr = { class: "block leading-none" }, Nr = ["id", "disabled", "readonly", "tabindex", "type", "value"], _r = { class: "absolute inset-y-0 right-0 flex items-center" }, Ur = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, Wr = ["innerHTML"], ze = /* @__PURE__ */ W({
  __name: "CfgInput",
  props: /* @__PURE__ */ se({
    ...be,
    ...Ve,
    fieldClass: {
      type: String,
      default: ""
    },
    /**
     * If false, icon slot will have pointer-events-none class
     * @default false
     */
    interactWithIcon: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ se(["input", "focusout", "focusin", "blur", "keydown"], ["update:modelValue"]),
  setup(e, { expose: n, emit: t }) {
    const o = e, a = t, l = lt(), s = me(e, "modelValue"), i = B(() => o.transformToCommaDelimiter !== void 0 ? o.transformToCommaDelimiter : o.type === "number"), r = B(() => i.value && i.value && o.type === "number" ? "tel" : o.type), d = B(() => i.value ? String(s.value).replaceAll(".", ",") : s.value), m = ga(), c = B(() => !String(s.value).trim().length), g = B(() => !!(m.icon || o.suffix) || o.type === "search" && !c.value), h = U(), { focused: v } = gt(h, {
      initialValue: o.initialFocused
    });
    n({
      focus() {
        v.value = !0;
      }
    }), de(v, (f) => {
      a(f ? "focusin" : "focusout");
    });
    function y(f) {
      f && (v.value = !0);
    }
    function M(f) {
      const { value: $ } = f.target;
      if (i.value) {
        s.value = S(
          $.replace(/[^0-9,.]/g, "").replaceAll(",", ".")
          // replace comma with dot
        );
        return;
      }
      s.value = $;
    }
    function S(f) {
      const $ = f.split(".");
      if ($.length > 1 && $[0] !== "") {
        const T = $[0], A = $.slice(1).join("");
        return `${T}.${A}`;
      }
      return f.replaceAll(".", "");
    }
    function b() {
      s.value = "", y(!0);
    }
    return (f, $) => (p(), w("div", {
      class: D({ "w-full": f.fluid, "w-72": !f.fluid })
    }, [
      C(u(Rn), {
        as: "label",
        class: D(["cfg-input cursor-text bg-white", { [e.fieldClass]: e.fieldClass }]),
        disabled: f.disabled,
        empty: c.value,
        error: f.error,
        fluid: !0,
        focused: u(v),
        loading: f.loading,
        placeholder: f.placeholder,
        "placeholder-as": "span",
        "placeholder-attrs": { for: u(l) },
        readonly: f.readonly,
        required: f.required,
        "onUpdate:focused": y
      }, Yt({
        default: k(() => [
          x("span", Hr, [
            x("input", ae({
              id: u(l),
              ref_key: "inputRef",
              ref: h,
              class: "cfg-input__input h-[1em] w-full border-none bg-transparent p-0 leading-none outline-none focus:border-none focus:outline-none focus:ring-0 focus-visible:outline-none",
              disabled: f.disabled,
              readonly: f.readonly,
              tabindex: f.readonly ? -1 : 0,
              type: r.value,
              value: d.value
            }, f.$attrs.autocomplete ? {
              autocomplete: f.$attrs.autocomplete
            } : {}, {
              onBlur: $[0] || ($[0] = (T) => a("blur")),
              onFocusin: $[1] || ($[1] = (T) => v.value = !0),
              onFocusout: $[2] || ($[2] = (T) => v.value = !1),
              onInput: M,
              onKeydown: $[3] || ($[3] = (T) => a("keydown", T))
            }), null, 16, Nr)
          ])
        ]),
        _: 2
      }, [
        g.value ? {
          name: "placeRight",
          fn: k(() => [
            x("div", _r, [
              f.suffix ? (p(), w("span", {
                key: 0,
                id: "price-currency",
                class: D(["text-grey-500 sm:text-sm", { "pointer-events-none": !e.interactWithIcon }])
              }, O(f.suffix), 3)) : E("", !0),
              f.type === "search" && String(s.value).length ? (p(), L(Zt, {
                key: 1,
                flat: "",
                text: "",
                onClick: b
              }, {
                default: k(() => [
                  C(u(Ne))
                ]),
                _: 1
              })) : f.$slots.icon ? z(f.$slots, "icon", {
                key: 2,
                class: D({ "pointer-events-none": !e.interactWithIcon })
              }) : E("", !0)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["class", "disabled", "empty", "error", "focused", "loading", "placeholder", "placeholder-attrs", "readonly", "required"]),
      f.error && f.errorMessage ? (p(), w("small", Ur, O(f.errorMessage), 1)) : E("", !0),
      !(f.errorMessage && f.error) && f.caption ? (p(), w("small", {
        key: 1,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: f.caption
      }, null, 8, Wr)) : E("", !0)
    ], 2));
  }
}), Bd = /* @__PURE__ */ W({
  __name: "CfgOtpInput",
  props: /* @__PURE__ */ se({
    placeholder: {},
    disabled: { type: Boolean },
    size: { default: 6 },
    error: { type: Boolean, default: !1 },
    inputClass: { default: "" }
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ se(["complete"], ["update:modelValue"]),
  setup(e) {
    const n = me(e, "modelValue");
    return (t, o) => (p(), L(u(Ts), {
      modelValue: n.value,
      "onUpdate:modelValue": o[0] || (o[0] = (a) => n.value = a),
      class: "flex items-center gap-x-4",
      otp: "",
      type: "number",
      onComplete: o[1] || (o[1] = (a) => t.$emit("complete", a))
    }, {
      default: k(() => [
        (p(!0), w(te, null, ue(t.size, (a, l) => (p(), L(u(Es), {
          key: a,
          class: D(["size-14 rounded-lg border-[#e8e8f0] bg-white text-center focus:border-[#e8e8f0] focus:outline focus:outline-2 focus:outline-offset-0 focus:outline-brand", {
            [t.inputClass]: !0,
            "shadow-[0_2px_0_0_#D16363]": t.error
          }]),
          index: l
        }, null, 8, ["class", "index"]))), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), qr = { class: "flex items-center gap-x-4" }, Yr = { class: "-m-3 flex grow justify-center gap-x-1 overflow-auto p-3 transition-all md:gap-x-2.5" }, Gr = /* @__PURE__ */ W({
  __name: "CfgPagination",
  props: {
    page: {},
    totalItems: {},
    itemsPerPage: {},
    goToPage: { type: Boolean, default: !1 }
  },
  emits: ["update:page"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = U(t.page), l = B(() => Array.from({
      length: Math.ceil(t.totalItems / t.itemsPerPage)
    })), s = B(() => {
      const h = Math.ceil(t.totalItems / t.itemsPerPage), v = 1, y = [], M = 5 + v * 2;
      let S = h <= M ? 1 : t.page - v, b = h <= M ? h : t.page + v;
      if (b = b > h ? h : b, S = S < 1 ? 1 : S, h > M) {
        const f = S - 1 < 3, $ = h - b < 3;
        if (f) {
          b = M - 2;
          for (let T = 1; T < S; T++)
            y.push(T);
        } else
          y.push(1), y.push(null);
        if ($) {
          S = h - (M - 3);
          for (let T = S; T <= h; T++)
            y.push(T);
        } else {
          for (let T = S; T <= b; T++)
            y.push(T);
          y.push(null), y.push(h);
        }
      } else
        for (let f = S; f <= b; f++)
          y.push(f);
      return y;
    }), i = B(() => t.page > 1), r = B(() => t.page < l.value.length);
    function d() {
      if (i.value) {
        const h = t.page - 1;
        a.value = h, o("update:page", h);
      }
    }
    function m() {
      if (r.value) {
        const h = t.page + 1;
        a.value = h, o("update:page", h);
      }
    }
    function c(h) {
      o("update:page", h);
    }
    function g() {
      const h = Number(a.value), v = t.page;
      h && h > 0 && h <= l.value.length && h !== v ? o("update:page", h) : h > l.value.length && o("update:page", l.value.length);
    }
    return (h, v) => (p(), w("nav", qr, [
      x("button", {
        "aria-label": "Předchozí stránka",
        class: D(["focusable hidden rounded-md px-2 text-lg text-brand md:block", {
          "cursor-not-allowed opacity-50": !i.value
        }]),
        type: "button",
        onClick: d
      }, [
        C(u(Rt))
      ], 2),
      x("ul", Yr, [
        (p(!0), w(te, null, ue(s.value, (y, M) => (p(), w("li", {
          key: y || M
        }, [
          (p(), L(Me(y ? "a" : "span"), {
            class: D(["rounded-md border py-[0.5em] text-sm font-highlighted leading-none transition-colors duration-200", {
              "text-brand": y === h.page,
              "border-[transparent] text-grey-300": y !== h.page,
              "lg:hover:border-grey-stroke lg:hover:text-grey-400": h.page && y !== h.page,
              "focusable px-3": h.page
            }]),
            href: `page=${y}`,
            onClick: Le((S) => y && c(y), ["prevent"])
          }, {
            default: k(() => [
              x("span", null, O(y || "..."), 1)
            ]),
            _: 2
          }, 1032, ["class", "href", "onClick"]))
        ]))), 128))
      ]),
      x("button", {
        "aria-label": "Další stránka",
        class: D(["focusable hidden rounded-md px-2 text-lg text-brand md:block", {
          "cursor-not-allowed opacity-50": !r.value
        }]),
        type: "button",
        onClick: m
      }, [
        C(u(Kt))
      ], 2),
      t.goToPage ? (p(), L(ze, {
        key: 0,
        modelValue: a.value,
        "onUpdate:modelValue": v[0] || (v[0] = (y) => a.value = y),
        class: "max-w-[130px]",
        placeholder: "Přejít na stránku:",
        "transform-to-comma-delimiter": !1,
        type: "number",
        onBlur: g,
        onKeyup: Re(g, ["enter"])
      }, null, 8, ["modelValue"])) : E("", !0)
    ]));
  }
}), Kr = { class: "cfg-radio flex gap-x-3" }, Xr = ["for"], Zr = ["id", "checked", "disabled"], Jr = ["for"], Qr = ["innerHTML"], ei = {
  inheritAttrs: !1
}, ti = /* @__PURE__ */ W({
  ...ei,
  __name: "CfgRadio",
  props: {
    ...Ve,
    modelValue: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = Wt(), l = B(() => a.id || lt()), s = U();
    gt(s, {
      initialValue: t.initialFocused
    });
    function i(r) {
      var d;
      o("update:modelValue", ((d = r == null ? void 0 : r.target) == null ? void 0 : d.checked) ?? !t.modelValue);
    }
    return (r, d) => (p(), w("div", null, [
      x("div", Kr, [
        x("label", {
          class: "block",
          for: l.value
        }, [
          x("input", ae({ id: l.value }, r.$attrs, {
            ref_key: "inputRef",
            ref: s,
            checked: e.modelValue,
            class: ["focusable size-5 border-grey-stroke text-brand", {
              "!border-red": r.error
            }],
            disabled: r.disabled,
            type: "radio",
            onChange: i
          }), null, 16, Zr)
        ], 8, Xr),
        r.$slots.default || e.placeholder ? (p(), w("label", {
          key: 0,
          class: D(["block", {
            "text-dark-100": e.modelValue,
            "text-grey-300": !e.modelValue,
            "!text-red": r.error
          }]),
          for: l.value
        }, [
          C(_, {
            class: D({
              "opacity-40": r.disabled,
              "cursor-pointer": !r.disabled,
              "cursor-not-allowed": r.disabled,
              "text-grey-400": !r.error
            }),
            size: u(H).sm
          }, {
            default: k(() => [
              z(r.$slots, "default", {}, () => [
                x("span", { innerHTML: e.placeholder }, null, 8, Qr)
              ])
            ]),
            _: 3
          }, 8, ["class", "size"]),
          r.caption ? (p(), L(_, {
            key: 0,
            class: D(["mt-1 block", {
              "text-grey-300": !r.error
            }]),
            size: u(H).xs
          }, {
            default: k(() => [
              K(O(r.caption), 1)
            ]),
            _: 1
          }, 8, ["class", "size"])) : E("", !0)
        ], 10, Jr)) : E("", !0)
      ]),
      r.error && r.errorMessage ? (p(), L(_, {
        key: 0,
        class: "mt-3 block text-red",
        size: u(H).xs
      }, {
        default: k(() => [
          K(O(r.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : r.caption && !e.placeholder ? (p(), L(_, {
        key: 1,
        class: "mt-3 block text-grey-300",
        size: u(H).xs
      }, {
        default: k(() => [
          K(O(r.caption), 1)
        ]),
        _: 1
      }, 8, ["size"])) : E("", !0)
    ]));
  }
}), ni = /* @__PURE__ */ W({
  __name: "CfgScrollbarView",
  props: {
    as: { default: "div" }
  },
  setup(e, { expose: n }) {
    const t = U(void 0), o = U(0);
    Ke(() => {
      var l;
      (l = t.value) == null || l.addEventListener("scroll", a);
    }), wn(() => {
      var l;
      (l = t.value) == null || l.removeEventListener("scroll", a);
    }), n({
      scrollPositionY: o
    });
    function a() {
      var l;
      o.value = ((l = t.value) == null ? void 0 : l.scrollTop) || 0;
    }
    return (l, s) => (p(), L(Me(l.as), {
      ref_key: "scrollbarView",
      ref: t,
      class: "cfg-scrollbar-view overflow-y-auto"
    }, {
      default: k(() => [
        z(l.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 512));
  }
}), ai = /* @__PURE__ */ Xe(ni, [["__scopeId", "data-v-1c2ab057"]]), si = { class: "sr-only" }, li = { class: "absolute left-0 top-0 size-full rounded-[inherit] bg-[inherit]" }, oi = ["innerHTML"], zd = /* @__PURE__ */ W({
  __name: "CfgSwitch",
  props: /* @__PURE__ */ se(be, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = me(e, "modelValue"), o = U();
    return gt(o, {
      initialValue: n.initialFocused
    }), (a, l) => (p(), L(u(Ws), null, {
      default: k(() => [
        x("div", {
          class: D(["flex gap-x-4 gap-y-3", {
            "flex-col": !a.placeholder,
            "cursor-pointer": !a.disabled,
            "cursor-not-allowed": a.disabled
          }])
        }, [
          C(u(qs), {
            ref_key: "inputRef",
            ref: o,
            modelValue: t.value,
            "onUpdate:modelValue": l[0] || (l[0] = (s) => t.value = s),
            class: D(["cfg-switch relative inline-flex h-[27px] w-11 shrink-0 rounded-full border-[3px] border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2", {
              "cfg-switch--selected": t.value,
              "!bg-red/10": a.error
            }]),
            disabled: a.disabled
          }, {
            default: k(() => [
              x("span", si, O(a.placeholder), 1),
              x("span", {
                "aria-hidden": "true",
                class: D(["cfg-switch__swiper pointer-events-none mx-0 inline-block size-[calc(27px-6px)] rounded-full ring-0 transition duration-200 ease-in-out", {
                  "translate-x-4 bg-brand text-white": t.value,
                  "translate-x-0 bg-white text-grey-300": !t.value,
                  "bg-red": a.error && t.value
                }])
              }, [
                x("span", li, [
                  e.modelValue ? z(a.$slots, "enabled", { key: 0 }) : z(a.$slots, "disabled", { key: 1 })
                ])
              ], 2)
            ]),
            _: 3
          }, 8, ["modelValue", "class", "disabled"]),
          x("div", null, [
            a.placeholder ? (p(), L(u(Ys), {
              key: 0,
              class: "flex items-center"
            }, {
              default: k(() => [
                C(_, {
                  class: D({
                    "opacity-40": a.disabled,
                    "cursor-pointer": !a.disabled,
                    "cursor-not-allowed": a.disabled,
                    "text-red": a.error,
                    "text-grey-400": !a.error
                  }),
                  size: u(H).sm
                }, {
                  default: k(() => [
                    K(O(a.placeholder), 1)
                  ]),
                  _: 1
                }, 8, ["class", "size"])
              ]),
              _: 1
            })) : E("", !0),
            a.caption || a.error && a.errorMessage ? (p(), L(u(Gs), {
              key: 1,
              class: "cursor-text"
            }, {
              default: k(() => [
                a.caption && !(a.error && a.errorMessage) ? (p(), L(_, {
                  key: 0,
                  class: D(["mt-1 block cursor-text text-grey-300", { "mt-0": !a.placeholder }]),
                  size: u(H).xs
                }, {
                  default: k(() => [
                    x("span", { innerHTML: a.caption }, null, 8, oi)
                  ]),
                  _: 1
                }, 8, ["class", "size"])) : a.errorMessage && a.error ? (p(), L(_, {
                  key: 1,
                  class: D(["mt-1 block cursor-text text-red", { "mt-0": !a.placeholder }]),
                  size: u(H).xs
                }, {
                  default: k(() => [
                    K(O(a.errorMessage), 1)
                  ]),
                  _: 1
                }, 8, ["class", "size"])) : E("", !0)
              ]),
              _: 1
            })) : E("", !0)
          ])
        ], 2)
      ]),
      _: 3
    }));
  }
}), Ia = {
  required: {
    type: Boolean,
    default: !1
  },
  /**
   * Placeholder text
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * Field error state (will show error message if provided and set to true)
   */
  error: {
    type: Boolean,
    default: !1
  },
  /**
   * Field error message
   */
  errorMessage: {
    type: String,
    default: ""
  },
  /**
   * Caption text. Will be shown below input. Recommended length is 2-3 words, like 'Enter your name'.
   * In case of error, will be replaced with error message
   */
  caption: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Will set input focus on mount
   */
  initialFocused: {
    type: Boolean,
    default: !1
  },
  loading: {
    type: Boolean,
    default: !1
  }
}, ri = {
  ...Ia,
  /**
   * Will make input fluid (100% width)
   */
  fluid: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  }
}, ii = { class: "block leading-none" }, ui = ["id", "disabled", "readonly", "tabindex", "value"], di = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, ci = ["innerHTML"], Ld = /* @__PURE__ */ W({
  __name: "CfgTextarea",
  props: /* @__PURE__ */ se({
    ...Ia,
    ...ri,
    fieldClass: {
      type: String,
      default: ""
    },
    minHeight: {
      type: Number,
      default: 100
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ se(["input", "focusout", "focusin", "blur", "keydown"], ["update:modelValue"]),
  setup(e, { expose: n, emit: t }) {
    const o = e, a = t, l = lt(), s = me(e, "modelValue"), i = B(() => !String(s.value).trim().length), { textarea: r, input: d } = gs(), { focused: m } = gt(r, {
      initialValue: o.initialFocused
    }), { height: c } = Cn(r);
    n({
      focus() {
        m.value = !0;
      }
    }), de(m, (v) => {
      a(v ? "focusin" : "focusout");
    });
    function g(v) {
      v && (m.value = !0);
    }
    function h(v) {
      const { value: y } = v.target;
      d.value = y, s.value = y;
    }
    return (v, y) => (p(), w("div", {
      class: D({ "w-full": v.fluid, "w-72": !v.fluid })
    }, [
      C(u(Rn), {
        caption: v.caption,
        class: D(["cfg-input cursor-text bg-white", { [e.fieldClass]: e.fieldClass }]),
        disabled: v.disabled,
        empty: i.value,
        error: v.error,
        fluid: !0,
        focused: u(m),
        height: `${u(c)}px`,
        loading: v.loading,
        placeholder: v.placeholder,
        "placeholder-as": "label",
        "placeholder-attrs": { for: u(l) },
        readonly: v.readonly,
        required: v.required,
        "onUpdate:focused": g
      }, {
        default: k(() => [
          x("label", ii, [
            x("textarea", {
              id: u(l),
              ref_key: "textareaRef",
              ref: r,
              class: "w-full resize-none border-none bg-transparent p-0 outline-none focus:border-none focus:outline-none focus:ring-0 focus-visible:outline-none",
              disabled: v.disabled,
              readonly: v.readonly,
              style: Ae({ minHeight: `${e.minHeight}px` }),
              tabindex: v.readonly ? -1 : 0,
              value: s.value,
              onBlur: y[0] || (y[0] = (M) => a("blur")),
              onFocusin: y[1] || (y[1] = (M) => m.value = !0),
              onFocusout: y[2] || (y[2] = (M) => m.value = !1),
              onInput: h,
              onKeydown: y[3] || (y[3] = (M) => a("keydown", M))
            }, null, 44, ui)
          ])
        ]),
        _: 1
      }, 8, ["caption", "class", "disabled", "empty", "error", "focused", "height", "loading", "placeholder", "placeholder-attrs", "readonly", "required"]),
      v.error && v.errorMessage ? (p(), w("small", di, O(v.errorMessage), 1)) : E("", !0),
      !(v.errorMessage && v.error) && v.caption ? (p(), w("small", {
        key: 1,
        class: "block max-w-full pt-1 text-grey-300",
        innerHTML: v.caption
      }, null, 8, ci)) : E("", !0)
    ], 2));
  }
}), fi = { class: "mx-auto flex max-w-[310px] shrink-0 flex-col items-center text-center sm:max-w-[360px]" }, pi = { class: "mx-auto flex max-w-[500px] grow flex-col items-center justify-center py-10 text-center" }, mi = ["innerHTML"], Ad = /* @__PURE__ */ W({
  __name: "CfgApplicationError",
  props: {
    header: {},
    headerClasses: {},
    statusCode: {},
    statusCodeClasses: {},
    title: {},
    titleClasses: {},
    description: {},
    descriptionClasses: {},
    buttonLabel: {},
    buttonClasses: {}
  },
  emits: ["error"],
  setup(e, { emit: n }) {
    const t = n;
    return (o, a) => (p(), w(te, null, [
      x("header", fi, [
        z(o.$slots, "logo"),
        o.header ? (p(), L(_, {
          key: 0,
          class: D(["mt-5 text-grey-400 md:mt-7", o.headerClasses]),
          html: o.header,
          size: u(H).h4,
          "tag-name": "p"
        }, null, 8, ["class", "html", "size"])) : E("", !0)
      ]),
      x("main", pi, [
        x("span", {
          class: D(["text-[120px] font-highlighted leading-none text-grey-200 opacity-10 sm:text-[240px]", [o.statusCodeClasses]])
        }, O(o.statusCode), 3),
        z(o.$slots, "title", {}, () => [
          C(_, {
            class: D(["page-not-found__title -mt-[7%] sm:-mt-[12%]", [o.titleClasses]]),
            html: o.title,
            size: u(H).h1,
            "tag-name": "h1"
          }, null, 8, ["class", "html", "size"])
        ]),
        z(o.$slots, "description", {}, () => [
          C(_, {
            class: D(["mt-5 text-dark-200 md:mt-6", [o.descriptionClasses]]),
            size: u(H).md,
            "tag-name": "p"
          }, {
            default: k(() => [
              x("span", { innerHTML: o.description }, null, 8, mi)
            ]),
            _: 1
          }, 8, ["class", "size"])
        ]),
        o.buttonLabel ? (p(), L(u(Zt), {
          key: 0,
          class: D(["mt-10", [o.buttonClasses]]),
          variant: "primary",
          onClick: a[0] || (a[0] = (l) => t("error"))
        }, {
          default: k(() => [
            K(O(o.buttonLabel), 1)
          ]),
          _: 1
        }, 8, ["class"])) : E("", !0)
      ])
    ], 64));
  }
});
var tt = /* @__PURE__ */ ((e) => (e.register = "register", e.unregister = "unregister", e.errorChanged = "error:changed", e))(tt || {});
const gi = /* @__PURE__ */ W({
  __name: "CfgValidationObserver",
  emits: ["error:changed", "submit"],
  setup(e, { expose: n, emit: t }) {
    const o = t, a = U([]), l = B(() => a.value.some(({ error: y }) => y)), s = U(!1), i = {
      [tt.register]: m,
      [tt.unregister]: c,
      [tt.errorChanged]: r
    };
    n({
      resetForm: h,
      async submit() {
        return d();
      }
    }), de(l, (y) => o("error:changed", y));
    function r(y) {
      const M = a.value.find((S) => S.name === y.name);
      M && (M.error = y.error);
    }
    async function d() {
      var M;
      return await g(), v() ? (o("submit"), !0) : ((M = a.value.find(({ error: S }) => S)) == null || M.focus(), !1);
    }
    function m(y) {
      a.value.find((M) => M.name === y.name) || a.value.push(y);
    }
    function c(y) {
      a.value = a.value.filter((M) => M.name !== y);
    }
    async function g() {
      s.value = !0, await Promise.all(a.value.map((y) => y.forceValidate())), s.value = !1;
    }
    function h() {
      a.value.forEach((y) => y.reset());
    }
    function v() {
      return !l.value;
    }
    return (y, M) => z(y.$slots, "default", {
      on: i,
      submit: d,
      validationLoading: s.value
    });
  }
}), jn = {
  validators: {
    type: Array,
    default: () => []
  }
}, Pa = /* @__PURE__ */ W({
  __name: "CfgValidationProvider",
  props: /* @__PURE__ */ se(jn, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ se(["error:changed", "register", "unregister"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, o = n, a = lt(), l = me(e, "modelValue"), s = bt(l.value), i = pn(!1), r = U(!1), d = U(!1), m = U(""), c = B(() => r.value && d.value);
    let g = null;
    const h = jt("providerRef");
    es(() => {
      o(tt.register, {
        name: a,
        error: d.value,
        reset: S,
        async forceValidate() {
          return r.value = !0, M();
        },
        focus() {
          g == null || g.focus();
        }
      });
    }), Ke(() => {
      Je(() => {
        var b;
        g = (b = h.value) == null ? void 0 : b.querySelector("input");
      });
    }), wn(() => o(tt.unregister, a)), de(() => l.value, M, { immediate: !0, deep: !0 }), de(d, (b) => o(tt.errorChanged, {
      name: a,
      error: b
    }));
    function v(b) {
      l.value = b;
    }
    function y() {
      r.value = !0;
    }
    async function M() {
      let b = !1, f = "";
      const $ = r.value;
      i.value = !0;
      const T = t.validators.some((A) => A.constructor.name === "AsyncFunction");
      T && (r.value = !1);
      for await (const A of t.validators) {
        let R;
        if (A.constructor.name === "AsyncFunction" ? R = await A(l.value || "") : R = A(l.value || ""), typeof R == "string") {
          b = !0, f = R;
          break;
        }
      }
      return d.value = b, m.value = f, i.value = !1, T && (r.value = $), b;
    }
    function S() {
      r.value = !1, d.value = !1, m.value = "", l.value = bt(s);
    }
    return (b, f) => (p(), w("div", {
      ref_key: "providerRef",
      ref: h
    }, [
      z(b.$slots, "default", {
        attrs: {
          error: c.value,
          errorMessage: m.value,
          modelValue: l.value,
          loading: i.value
        },
        on: {
          "update:modelValue": v,
          change: y
        }
      })
    ], 512));
  }
}), vi = {
  "aria-label": "Breadcrumb",
  class: "flex text-grey-300"
}, hi = { class: "flex items-center space-x-3 overflow-hidden" }, yi = { class: "shrink-0" }, bi = { key: 0 }, Id = /* @__PURE__ */ W({
  __name: "CfgBreadcrumbs",
  props: {
    pages: {
      type: Array,
      required: !0
    },
    /**
     * Text to display for the homepage link. If not provided, the home icon will be used.
     */
    homepageText: {
      type: [String, null],
      default: null
    }
  },
  emits: ["link:click"],
  setup(e, { emit: n }) {
    const t = n;
    function o(a) {
      t("link:click", a);
    }
    return (a, l) => (p(), w("nav", vi, [
      x("ol", hi, [
        x("li", yi, [
          C(_, {
            size: u(H).sm,
            "tag-name": "div"
          }, {
            default: k(() => [
              x("a", {
                class: "lg:transition lg:hover:text-brand",
                href: "/",
                onClick: l[0] || (l[0] = Le((s) => o("/"), ["prevent"]))
              }, [
                e.homepageText ? (p(), w("span", bi, O(e.homepageText), 1)) : (p(), w(te, { key: 1 }, [
                  C(u(os), {
                    "aria-hidden": "true",
                    class: "shrink-0 text-[1.25em]"
                  }),
                  l[1] || (l[1] = x("span", { class: "sr-only" }, "Home", -1))
                ], 64))
              ])
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        (p(!0), w(te, null, ue(e.pages, (s) => (p(), w("li", {
          key: s.name,
          class: "min-w-0 max-w-[50%] shrink-0 last:max-w-full last:shrink last:grow"
        }, [
          C(_, {
            class: "flex items-center",
            size: u(H).xs,
            "tag-name": "div"
          }, {
            default: k(() => [
              C(u(Kt), {
                "aria-hidden": "true",
                class: "shrink-0 text-[1.3em]"
              }),
              (p(), L(Me(s.current ? "span" : "a"), ae({ ref_for: !0 }, s.current ? {} : { href: s.path }, {
                "aria-current": s.current ? "page" : void 0,
                class: ["ml-2 truncate", {
                  "lg:transition lg:hover:text-brand": !s.current
                }],
                onClick: Le((i) => !s.current && o(s.path), ["prevent"])
              }), {
                default: k(() => [
                  K(O(s.name), 1)
                ]),
                _: 2
              }, 1040, ["aria-current", "class", "onClick"]))
            ]),
            _: 2
          }, 1032, ["size"])
        ]))), 128))
      ])
    ]));
  }
}), xi = { class: "hide-scrollbar mt-3 flex overflow-x-auto" }, ki = ["onClick"], Pd = /* @__PURE__ */ W({
  __name: "CfgButtonsGroup",
  props: {
    values: {}
  },
  emits: ["input"],
  setup(e, { emit: n }) {
    const t = n, o = U("");
    function a(l) {
      t("input", l), o.value = l;
    }
    return (l, s) => (p(), w(te, null, [
      z(l.$slots, "default", { value: o.value }),
      x("div", xi, [
        (p(!0), w(te, null, ue(l.values, (i) => (p(), w("button", {
          key: i,
          class: "m-1 rounded-xl border border-grey-stroke px-3 py-2",
          type: "button",
          onClick: (r) => a(i)
        }, O(i), 9, ki))), 128))
      ])
    ], 64));
  }
}), wi = { class: "space-y-3" }, Od = /* @__PURE__ */ W({
  __name: "CfgCheckboxGroup",
  props: /* @__PURE__ */ se({
    ...be,
    /**
     * Name of the radio group (will be used as name attribute for all radio buttons)
     */
    name: {
      type: String,
      default: () => lt()
    },
    /**
     * Radio group items
     */
    options: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: "row"
    }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = me(e, "modelValue"), o = B(() => n.options.map((l) => ({
      ...l,
      checked: t.value.includes(l.value)
    })));
    function a(l, s) {
      if (!l) {
        t.value = t.value.filter((i) => i !== s);
        return;
      }
      t.value.push(s);
    }
    return (l, s) => (p(), w("div", wi, [
      x("div", null, [
        C(_, {
          class: D({
            "text-grey-200": !l.error,
            "text-red": l.error
          }),
          size: u(H).md
        }, {
          default: k(() => [
            K(O(l.placeholder), 1)
          ]),
          _: 1
        }, 8, ["class", "size"]),
        l.caption ? (p(), L(_, {
          key: 0,
          class: "mt-1 block pb-1 text-grey-300",
          size: u(H).xs
        }, {
          default: k(() => [
            K(O(l.caption), 1)
          ]),
          _: 1
        }, 8, ["size"])) : E("", !0)
      ]),
      x("div", {
        class: D({
          "flex flex-wrap gap-x-7 gap-y-4": e.layout === "row",
          "space-y-4": e.layout === "column"
        })
      }, [
        (p(!0), w(te, null, ue(o.value, (i) => (p(), w("div", {
          key: i.value
        }, [
          C(_t, {
            disabled: l.disabled || i.disabled,
            "model-value": i.checked,
            name: e.name,
            placeholder: i.label,
            value: i.value,
            "onUpdate:modelValue": (r) => a(r, i.value)
          }, null, 8, ["disabled", "model-value", "name", "placeholder", "value", "onUpdate:modelValue"])
        ]))), 128))
      ], 2),
      l.error && l.errorMessage ? (p(), L(_, {
        key: 0,
        class: "mt-3 block text-red",
        size: u(H).xs
      }, {
        default: k(() => [
          K(O(l.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : E("", !0)
    ]));
  }
}), $i = { class: "flex flex-wrap gap-2" }, Ci = ["for"], Si = ["id", "aria-label", "checked", "name", "type", "value", "onChange"], Fd = /* @__PURE__ */ W({
  __name: "CfgChipsToggle",
  props: {
    id: {},
    options: {},
    isMultiple: {},
    modelValue: {},
    name: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = B(() => t.id || `chips-toggle-${Math.random().toString(36).substr(2, 9)}`), l = B(() => t.name || a.value), s = B(() => t.options.map((r) => ({
      ...r,
      isSelected: r.value === t.modelValue
    }))), i = B(() => t.isMultiple ? "checkbox" : "radio");
    if (t.isMultiple)
      throw new Error("Multiple chips toggle is not implemented yet");
    return (r, d) => (p(), w("div", $i, [
      (p(!0), w(te, null, ue(s.value, ({ isSelected: m, label: c, value: g }, h) => (p(), w("label", {
        key: g,
        class: D(["relative block cursor-pointer overflow-hidden rounded-full border leading-none ring-offset-4 transition duration-200 focus-within:ring focus-within:ring-brand/30 hover:-translate-y-1", {
          "border-brand bg-brand text-white": m,
          "border-grey-stroke bg-white": !m
        }]),
        for: `${a.value}-${h}`
      }, [
        C(_, {
          class: "block px-[1em] py-[0.75em]",
          size: u(H).sm,
          "tag-name": "span"
        }, {
          default: k(() => [
            z(r.$slots, "default", { label: c }, () => [
              x("input", {
                id: `${a.value}-${h}`,
                "aria-label": c,
                checked: m,
                class: "absolute -top-5 opacity-0",
                name: l.value,
                type: i.value,
                value: c,
                onChange: (v) => o("update:modelValue", g)
              }, null, 40, Si),
              K(" " + O(c), 1)
            ])
          ]),
          _: 2
        }, 1032, ["size"])
      ], 10, Ci))), 128))
    ]));
  }
});
var ot = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e.XLarge = "xlarge", e))(ot || {});
const Mi = { class: "fixed inset-0 z-10 overflow-y-auto" }, Di = {
  key: 0,
  class: "absolute right-3 top-3 z-20 mb-2 md:right-5 md:top-5"
}, Ti = { class: "space-y-3" }, Ei = {
  key: 0,
  class: "mb-2 flex items-center justify-end"
}, Vi = {
  key: 0,
  class: "mx-auto mb-5 flex size-[2em] items-center justify-center rounded-full bg-brand-opacity text-[1.5em] text-brand"
}, Rd = /* @__PURE__ */ W({
  __name: "CfgDialog",
  props: {
    opened: {
      type: Boolean,
      required: !0
    },
    initialFocus: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    closable: {
      type: Boolean,
      default: !0
    },
    unmount: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: ot.Small
    },
    /**
     * If true, the dialog will not have a
     * padding and the close button will be moved to the top right corner.
     */
    flat: {
      type: Boolean,
      default: !1
    },
    width: {
      type: String,
      default: void 0
    },
    isFullScreen: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:opened", "close-click:button", "close-click:backdrop", "after-close-animation"],
  setup(e, { emit: n }) {
    const t = e, o = n;
    function a(l) {
      if (t.closable) {
        switch (l) {
          case "button":
            o("close-click:button");
            break;
          case "backdrop":
            o("close-click:backdrop");
            break;
        }
        o("update:opened", !1);
      }
    }
    return (l, s) => (p(), L(u(Dn), {
      as: "template",
      show: e.opened
    }, {
      default: k(() => [
        C(u(Tn), {
          as: "div",
          class: "relative z-modal",
          unmount: !!e.unmount,
          onClose: s[3] || (s[3] = (i) => a("backdrop"))
        }, {
          default: k(() => [
            C(u(ft), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: k(() => s[4] || (s[4] = [
                x("div", { class: "fixed inset-0 bg-dark/60 transition-opacity sm:backdrop-blur" }, null, -1)
              ])),
              _: 1
            }),
            x("div", Mi, [
              e.closable && e.flat ? (p(), w("div", Di, [
                x("button", {
                  class: "flex size-11 items-center justify-center rounded-full bg-grey-100 ring-brand focus-visible:outline-brand focus-visible:ring",
                  type: "button",
                  onClick: s[0] || (s[0] = (i) => a("button"))
                }, [
                  C(u(Ne))
                ])
              ])) : E("", !0),
              x("div", {
                class: D(["flex min-h-full items-center justify-center text-center sm:p-0", {
                  "p-4": !e.isFullScreen
                }])
              }, [
                C(u(ft), {
                  as: "template",
                  enter: "ease-out duration-[350ms]",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  onAfterLeave: s[2] || (s[2] = (i) => o("after-close-animation"))
                }, {
                  default: k(() => [
                    C(u(En), {
                      class: D(["relative w-full overflow-hidden bg-white text-left shadow-base transition-all sm:my-8 sm:w-full", {
                        "sm:max-w-sm": !e.width && e.size === u(ot).Small,
                        "sm:max-w-lg": !e.width && e.size === u(ot).Medium,
                        "sm:max-w-3xl": !e.width && e.size === u(ot).Large,
                        "sm:max-w-[calc(100%-40px-120px)]": !e.width && e.size === u(ot).XLarge,
                        // 40px-120px is padding + close button width
                        "px-4 pb-4 pt-5 sm:p-6": !e.flat,
                        // Add padding for non-flat dialogs
                        "mt-14": e.flat && e.closable,
                        // Prevent layering window to close button,
                        "h-screen w-full": e.isFullScreen,
                        "rounded-xl": !e.isFullScreen
                      }]),
                      style: Ae(e.width ? { width: e.width } : {})
                    }, {
                      default: k(() => [
                        x("header", Ti, [
                          e.closable && !e.flat ? (p(), w("div", Ei, [
                            x("button", {
                              class: "flex size-11 items-center justify-center rounded-full bg-grey-100 ring-brand focus-visible:outline-brand focus-visible:ring",
                              type: "button",
                              onClick: s[1] || (s[1] = (i) => a("button"))
                            }, [
                              C(u(Ne))
                            ])
                          ])) : E("", !0),
                          x("div", null, [
                            z(l.$slots, "heading", {}, () => [
                              l.$slots.icon ? (p(), w("div", Vi, [
                                z(l.$slots, "icon")
                              ])) : E("", !0),
                              e.title || l.$slots.title ? (p(), L(u(Ks), {
                                key: 1,
                                as: "div",
                                class: "text-dark-100"
                              }, {
                                default: k(() => [
                                  z(l.$slots, "title", {}, () => [
                                    C(_, {
                                      class: "text-center",
                                      size: u(H).h3,
                                      "tag-name": "h3"
                                    }, {
                                      default: k(() => [
                                        K(O(e.title), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["size"])
                                  ])
                                ]),
                                _: 3
                              })) : E("", !0),
                              e.description || l.$slots.description ? (p(), L(u(Xs), {
                                key: 2,
                                as: "div",
                                class: "mt-3"
                              }, {
                                default: k(() => [
                                  z(l.$slots, "description", {}, () => [
                                    C(_, {
                                      class: "text-center text-sm text-grey-300",
                                      size: u(H).md,
                                      "tag-name": "p"
                                    }, {
                                      default: k(() => [
                                        K(O(e.description), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["size"])
                                  ])
                                ]),
                                _: 3
                              })) : E("", !0)
                            ])
                          ])
                        ]),
                        x("main", {
                          class: D({ "mt-5": !e.flat })
                        }, [
                          z(l.$slots, "default")
                        ], 2)
                      ]),
                      _: 3
                    }, 8, ["class", "style"])
                  ]),
                  _: 3
                })
              ], 2)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), Hn = {
  origin: {
    type: String,
    default: "left"
  },
  openOnTriggerClick: {
    type: Boolean,
    default: !0
  },
  useTriggerContentWidth: {
    type: Boolean,
    default: !1
  },
  minWidth: {
    type: Number,
    default: 0
  },
  allowedPlacements: {
    type: Array,
    default: () => ["top", "bottom"]
  }
}, Bi = { class: "relative" }, zi = {
  key: 0,
  class: "fixed inset-0 z-floating-overlay bg-black/30"
}, Oa = /* @__PURE__ */ W({
  __name: "CfgFloating",
  props: /* @__PURE__ */ se({
    ...Hn,
    highlightTriggerElement: {
      type: Boolean,
      default: !1
    }
  }, {
    opened: { type: Boolean, default: !1 },
    openedModifiers: {}
  }),
  emits: ["update:opened"],
  setup(e) {
    const n = e, t = me(e, "opened"), o = U(null), a = U(null);
    ba(a, r);
    const { floatingStyles: l } = Sn(o, a, {
      middleware: [xa(), ka(), wa(12), $a({
        allowedPlacements: n.allowedPlacements
      })],
      whileElementsMounted: Mn,
      transform: !1
    }), { width: s } = Ct(o);
    Ke(() => {
      gn(document.documentElement, "keydown", (d) => {
        d.key === "Escape" && t.value && r();
      });
    });
    function i() {
      t.value = !0;
    }
    function r() {
      t.value = !1;
    }
    return (d, m) => (p(), w("div", Bi, [
      x("div", {
        ref_key: "triggerButtonRef",
        ref: o,
        class: D(["focusable relative rounded-xl border-none bg-white p-0", {
          "z-floating-trigger": t.value && !e.highlightTriggerElement,
          "z-floating-trigger-highlighted": t.value && e.highlightTriggerElement
        }]),
        tabindex: "0",
        onClick: m[0] || (m[0] = (c) => d.openOnTriggerClick && i()),
        onKeydown: m[1] || (m[1] = Re((c) => d.openOnTriggerClick && i(), ["enter"]))
      }, [
        z(d.$slots, "trigger", {
          close: r,
          opened: t.value
        })
      ], 34),
      C(nt, {
        "enter-active-class": "transition-opacity duration-200 ease-out",
        "enter-from-class": "transition-opacity opacity-0",
        "enter-to-class": "transition-opacity opacity-100",
        "leave-active-class": "transition-opacity delay-100 duration-200 ease-out",
        "leave-from-class": "transition-opacity opacity-100",
        "leave-to-class": "transition-opacity opacity-0"
      }, {
        default: k(() => [
          t.value ? (p(), w("div", zi)) : E("", !0)
        ]),
        _: 1
      }),
      (p(), L($n, { to: "body" }, [
        C(nt, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "transform scale-125 translate-y-5 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
          "leave-active-class": "transition duration-200 ease-out",
          "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
          "leave-to-class": "transform scale-125 translate-y-5 opacity-0"
        }, {
          default: k(() => [
            Et(x("div", {
              ref_key: "bodyRef",
              ref: a,
              class: D(["absolute top-[calc(var(--input-height)+5px)] z-floating-content w-max min-w-[350px] divide-y divide-grey-stroke overflow-auto rounded-xl border border-grey-stroke bg-white shadow-light focus-visible:outline-none", {
                "border-brand": t.value,
                "left-0": d.origin === "left",
                "right-0": d.origin === "right"
              }]),
              style: Ae({
                ...u(l),
                "max-width": d.useTriggerContentWidth ? "100%" : `${u(s)}px`
              })
            }, [
              z(d.$slots, "content", {
                close: r,
                opened: t.value
              })
            ], 6), [
              [qt, t.value]
            ])
          ]),
          _: 3
        })
      ]))
    ]));
  }
}), Li = ["innerHTML"], Ft = /* @__PURE__ */ W({
  __name: "CfgHint",
  props: {
    content: { default: "" },
    hideIcon: { type: Boolean, default: !1 },
    delay: { default: () => [100, 200] },
    placement: { default: "left-start" },
    iconPlacement: { default: "right" },
    interactive: { type: Boolean },
    disabled: { type: Boolean },
    fluid: { type: Boolean },
    offset: { default: 8 }
  },
  setup(e) {
    const n = e, t = Wt(), o = B(() => {
      var d, m;
      return (m = (d = t.class) == null ? void 0 : d.includes) == null ? void 0 : m.call(d, "w-");
    }), a = U(!1);
    function l() {
      a.value = !1;
    }
    const s = B(() => {
      const d = n.placement || "top", [m, c] = d.split("-"), g = {
        top: "top",
        bottom: "bottom",
        left: "left",
        right: "right",
        auto: "top"
      }, h = {
        start: "start",
        end: "end"
      }, v = g[m] || "top", y = h[c] || "center";
      return {
        side: v,
        align: y
      };
    }), i = B(() => Array.isArray(n.delay) ? n.delay[0] ?? 0 : n.delay ?? 0), r = B(() => Array.isArray(n.delay) ? n.delay[1] ?? 0 : n.delay ?? 0);
    return (d, m) => (p(), w("div", {
      class: D(["flex h-max", { "w-max items-end justify-end": !o.value }])
    }, [
      C(u(Vs), {
        "delay-duration": 0,
        disabled: n.disabled
      }, {
        default: k(() => [
          C(u(Bs), {
            open: a.value,
            "onUpdate:open": m[0] || (m[0] = (c) => a.value = c)
          }, {
            default: k(() => [
              C(u(zs), {
                class: D({ "w-full": o.value }),
                style: { "text-transform": "inherit" }
              }, {
                default: k(() => [
                  x("div", {
                    class: D({ "w-full": o.value })
                  }, [
                    x("div", {
                      class: D(["group inline-flex items-center gap-x-2", [
                        {
                          "flex-row-reverse": n.iconPlacement === "left",
                          "w-full": o.value,
                          "cursor-help": !n.disabled
                        }
                      ]])
                    }, [
                      z(d.$slots, "trigger"),
                      !u(t).disabled && !n.hideIcon ? (p(), L(u(ht), {
                        key: 0,
                        class: D(["text-[1.1em] text-grey-200", { "transition-colors duration-200 group-hover:text-brand": !n.disabled }])
                      }, null, 8, ["class"])) : E("", !0)
                    ], 2)
                  ], 2)
                ]),
                _: 3
              }, 8, ["class"]),
              C(u(Ls), { to: "body" }, {
                default: k(() => [
                  C(nt, { name: "cfg-hint" }, {
                    default: k(() => [
                      C(u(As), {
                        align: s.value.align,
                        class: "z-toast max-w-[350px] rounded-xl bg-white p-5 text-dark-100 shadow-extra",
                        "enter-delay": i.value,
                        interactive: n.interactive,
                        "leave-delay": r.value,
                        side: s.value.side,
                        "side-offset": n.offset
                      }, {
                        default: k(() => [
                          z(d.$slots, "content", { closeHint: l }, () => [
                            x("div", {
                              class: "block max-w-[200px] text-left text-sm",
                              innerHTML: n.content
                            }, null, 8, Li)
                          ])
                        ]),
                        _: 3
                      }, 8, ["align", "enter-delay", "interactive", "leave-delay", "side", "side-offset"])
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["open"])
        ]),
        _: 3
      }, 8, ["disabled"])
    ], 2));
  }
}), Ai = { class: "space-y-3" }, Ii = ["innerHTML"], jd = /* @__PURE__ */ W({
  __name: "CfgRadioGroup",
  props: /* @__PURE__ */ se({
    ...be,
    /**
     * Name of the radio group (will be used as name attribute for all radio buttons)
     */
    name: {
      type: String,
      default: () => lt()
    },
    /**
     * Radio group items
     */
    options: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: "row"
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    var l;
    const n = e, t = me(e, "modelValue");
    t.value || (t.value = ((l = n.options[0]) == null ? void 0 : l.value) ?? "");
    const o = B(() => n.options.map((s) => ({
      ...s,
      checked: s.value === t.value
    })));
    function a(s, i) {
      s && (t.value = i);
    }
    return (s, i) => (p(), w("div", Ai, [
      x("div", null, [
        C(_, {
          class: D({
            "text-grey-200": !s.error,
            "text-red": s.error
          }),
          size: u(H).md
        }, {
          default: k(() => [
            K(O(s.placeholder), 1)
          ]),
          _: 1
        }, 8, ["class", "size"]),
        s.caption ? (p(), L(_, {
          key: 0,
          class: "mt-1 block pb-1 text-grey-300",
          size: u(H).xs
        }, {
          default: k(() => [
            x("span", { innerHTML: s.caption }, null, 8, Ii)
          ]),
          _: 1
        }, 8, ["size"])) : E("", !0)
      ]),
      x("div", {
        class: D({
          "flex flex-wrap gap-x-7 gap-y-4": e.layout === "row",
          "space-y-4": e.layout === "column"
        })
      }, [
        (p(!0), w(te, null, ue(o.value, (r) => (p(), w("div", {
          key: r.value
        }, [
          C(ti, {
            disabled: s.disabled || r.disabled,
            "model-value": r.checked,
            name: e.name,
            placeholder: r.label,
            value: r.value,
            "onUpdate:modelValue": (d) => a(d, r.value)
          }, null, 8, ["disabled", "model-value", "name", "placeholder", "value", "onUpdate:modelValue"])
        ]))), 128))
      ], 2),
      s.error && s.errorMessage ? (p(), L(_, {
        key: 0,
        class: "mt-3 block text-red",
        size: u(H).xs
      }, {
        default: k(() => [
          K(O(s.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : E("", !0)
    ]));
  }
});
function Fa(e, n) {
  const t = B(() => Array.isArray(e.value)), o = $t(n, (r, d) => ({
    label: typeof r == "string" ? r : r.label,
    value: typeof r == "string" ? d.toString() : r.value,
    subtext: typeof r == "string" ? void 0 : r.subtext,
    original: r
  })), a = B(() => {
    if (!e.value)
      return [];
    if (Array.isArray(e.value))
      return e.value.map((d) => {
        const m = s(d);
        return {
          ...m,
          label: typeof d == "string" ? d : (m == null ? void 0 : m.label) ?? ""
        };
      }).filter(Boolean);
    let r = s(e.value);
    return typeof e.value == "object" && r && (r = {
      ...r,
      label: e.value.label || ""
    }), r ? [r] : [];
  }), l = $t(o, (r) => ({
    ...r,
    selected: i(r)
  }));
  function s(r) {
    return typeof r == "string" ? o.value.find(({ label: d }) => d === r) : o.value.find(({ value: d }) => St(d, r == null ? void 0 : r.value));
  }
  function i(r) {
    return !!a.value.find(({ value: d }) => r.value === d);
  }
  return {
    isMultiple: t,
    normalizedModelValue: a,
    statefullOptionsList: l,
    isOptionSelected: i,
    findOption: s
  };
}
const Pi = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, Oi = {
  key: 1,
  class: "max-h-[400px] divide-y divide-grey-stroke overflow-auto"
}, Fi = ["onClick", "onKeydown"], Ri = { class: "grow" }, ji = {
  key: 2,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, Hd = /* @__PURE__ */ W({
  __name: "CfgCombobox",
  props: /* @__PURE__ */ se({
    ...be,
    options: {
      type: Array,
      default: () => []
    },
    emptyMessage: {
      type: String,
      required: !0
    },
    initialSearch: {
      type: String,
      default: ""
    },
    openOptionsOnClick: {
      type: Boolean,
      default: !0
    },
    origin: {
      type: String,
      default: "left"
    },
    compareFn: {
      type: [Function, null],
      default: null
    },
    onSearch: {
      type: Function,
      default: null
    },
    ...Ge(Hn, "allowedPlacements")
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    var M, S;
    const n = e, { options: t } = Gt(n), o = me(e, "modelValue"), a = U(null);
    ba(a, h);
    const { normalizedModelValue: l, statefullOptionsList: s } = Fa(o, t), i = U(n.initialSearch || (((S = (M = l.value) == null ? void 0 : M[0]) == null ? void 0 : S.label) ?? "")), r = U(!1), d = U(!1), m = (b, f) => f.label.toLowerCase().includes(i.value.toLowerCase()), c = vs(async () => {
      const b = n.compareFn || m;
      r.value = !0;
      const f = await xs(
        s.value,
        async ($) => i.value ? b(i.value, $) : !0
      );
      return r.value = !1, f;
    }, s.value);
    function g() {
      d.value = !0;
    }
    function h() {
      d.value = !1;
    }
    function v(b) {
      b && (o.value = b.original, h());
    }
    function y(b) {
      var R;
      if ([27, 13, 9, 16, 17, 18].includes(b.keyCode))
        return;
      const { value: f, label: $ } = ((R = l.value) == null ? void 0 : R[0]) || {}, A = b.key.match(/^[a-z0-9\s]+$/i) ? b.key : "";
      A !== f && A !== $ && g();
    }
    return de(() => n.initialSearch, (b = "") => {
      i.value = b;
    }), de(o, (b) => {
      Array.isArray(b) ? i.value = b.map((f) => typeof f == "string" ? f : f.label).join(", ") : i.value = typeof b == "string" ? b : (b == null ? void 0 : b.label) ?? "";
    }), de(i, (b) => {
      var f;
      b !== n.initialSearch && ((f = n.onSearch) == null || f.call(n, b)), b === "" && (o.value = null);
    }), (b, f) => (p(), L(Oa, {
      opened: d.value,
      "onUpdate:opened": f[1] || (f[1] = ($) => d.value = $),
      "highlight-trigger-element": "",
      "open-on-trigger-click": e.openOptionsOnClick
    }, {
      trigger: k(() => [
        C(ze, {
          modelValue: i.value,
          "onUpdate:modelValue": f[0] || (f[0] = ($) => i.value = $),
          autocomplete: "off",
          error: b.error,
          "error-message": b.errorMessage,
          fluid: "",
          "initial-focused": d.value || b.initialFocused,
          "interect-with-icon": "",
          loading: r.value || b.loading,
          placeholder: b.placeholder,
          required: b.required,
          type: "search",
          onKeydown: y
        }, null, 8, ["modelValue", "error", "error-message", "initial-focused", "loading", "placeholder", "required"])
      ]),
      content: k(() => [
        r.value || b.loading ? (p(), w("div", Pi, [
          C(Vt, { class: "text-[8px] text-brand" })
        ])) : u(c).length ? (p(), w("ul", Oi, [
          (p(!0), w(te, null, ue(u(c), ($) => (p(), w("li", {
            key: $.label,
            class: D(["flex cursor-pointer items-center gap-x-3 p-4 hover:bg-grey-100/50", {
              "text-brand": $.selected
            }]),
            onClick: (T) => v($),
            onKeydown: Re((T) => v($), ["enter"])
          }, [
            z(b.$slots, "option", ae({ ref_for: !0 }, { ...$ }), () => [
              $.selected ? (p(), L(u(ha), {
                key: 0,
                "aria-hidden": "true",
                class: "shrink-0 text-success"
              })) : E("", !0),
              x("span", Ri, O($.label), 1)
            ])
          ], 42, Fi))), 128))
        ])) : (p(), w("div", ji, [
          C(u(rs), { class: "text-[1.3rem] text-grey-300" }),
          C(_, {
            class: "text-center",
            size: u(H).sm
          }, {
            default: k(() => [
              K(O(e.emptyMessage), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]))
      ]),
      _: 3
    }, 8, ["opened", "open-on-trigger-click"]));
  }
}), Hi = {
  class: "cfg-select__button focusable block w-full rounded-xl text-left focus:border-none focus:outline-0",
  type: "button"
}, Ni = {
  key: 0,
  class: "absolute right-0 text-grey-200"
}, _i = {
  key: 0,
  class: "block max-w-full pt-1 text-red"
}, Ui = ["innerHTML"], Wi = {
  key: 0,
  class: "fixed inset-0 z-floating-overlay bg-black/30"
}, qi = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 px-5 py-7"
}, Yi = { key: 1 }, Gi = ["innerHTML"], Ki = ["innerHTML"], Ra = /* @__PURE__ */ W({
  __name: "CfgSelect",
  props: /* @__PURE__ */ se({
    ...be,
    modelValue: {
      type: [Object, Array, null],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    origin: {
      type: String,
      default: "left"
    },
    /**
     * Controls showing overlay under other elements
     */
    overlay: {
      type: Boolean,
      default: !0
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    contentMinWidth: {
      type: String,
      default: "350px"
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = me(e, "modelValue"), o = U(), a = U(), l = U(), s = U(), { width: i } = Ct(a);
    hs(o, f);
    const { width: r } = Ct(l), {
      floatingStyles: d
    } = Sn(l, s, {
      whileElementsMounted: Mn,
      transform: !1,
      middleware: [
        $a({
          allowedPlacements: ["top", "bottom"]
        }),
        ka({ padding: 5 }),
        wa(12),
        xa()
      ]
    }), m = U(0), { options: c } = Gt(n), {
      isMultiple: g,
      normalizedModelValue: h,
      statefullOptionsList: v,
      isOptionSelected: y
    } = Fa(t, c), M = B(() => m.value > i.value), S = B(() => {
      var V;
      return g.value ? h.value.map(({ value: P }) => P) : ((V = h.value[0]) == null ? void 0 : V.value) ?? "";
    }), b = B(() => ({
      label: h.value.map(({ label: V }) => V).join(", "),
      additionalLabel: M.value && h.value.length > 1 ? `(${h.value.length})` : ""
    }));
    function f() {
      var V;
      m.value = ((V = o.value) == null ? void 0 : V.getBoundingClientRect().width) ?? 0;
    }
    function $(V) {
      var q;
      let P = h.value;
      y(V) && g.value ? P = P.filter(({ value: j }) => j !== V.value) : g.value ? P.push(V) : P = [V], t.value = g.value ? P.map(({ original: j }) => j) : ((q = P[0]) == null ? void 0 : q.original) ?? null;
    }
    function T() {
      t.value = g.value ? [] : null;
    }
    const A = B(() => t.value === null || Array.isArray(t.value) && !t.value.length);
    ya(b, f, { immediate: !0, deep: !0, debounce: 50 });
    const R = ys(async () => {
      try {
        return g.value ? (await Promise.resolve().then(() => vr)).default : (await import("./CfgRadio-BxvnZyBv.js")).default;
      } catch {
        return null;
      }
    }, null);
    return (V, P) => (p(), L(u(Zs), {
      as: "div",
      class: "cfg-select relative",
      disabled: V.disabled,
      "model-value": S.value,
      multiple: u(g)
    }, {
      default: k(({ open: q }) => [
        x("div", null, [
          x("div", null, [
            C(u(Js), {
              as: "template",
              type: "button"
            }, {
              default: k(() => [
                x("button", Hi, [
                  x("span", {
                    ref_key: "triggerButtonRef",
                    ref: l,
                    class: "block"
                  }, [
                    z(V.$slots, "trigger", { isOpened: q }, () => [
                      C(Rn, {
                        class: D(["bg-white", {
                          "cursor-pointer": !V.disabled,
                          "cursor-not-allowed": V.disabled,
                          "relative z-floating-trigger ": q
                        }]),
                        disabled: V.disabled,
                        empty: !u(h).length,
                        error: V.error,
                        fluid: "",
                        focused: q,
                        loading: V.loading,
                        placeholder: V.placeholder,
                        readonly: "",
                        required: V.required
                      }, {
                        placeRight: k(() => [
                          e.clearable && !A.value ? (p(), L(u(Ne), {
                            key: 0,
                            class: D(["size-4 text-grey-400", {
                              "!text-brand": q
                            }]),
                            onClick: Le(T, ["prevent"])
                          }, null, 8, ["class"])) : (p(), L(u(at), {
                            key: 1,
                            class: D(["size-4 text-grey-400 transition duration-200", {
                              "rotate-180 !text-brand": q
                            }])
                          }, null, 8, ["class"]))
                        ]),
                        default: k(() => [
                          x("span", {
                            ref_key: "textWrapperRef",
                            ref: a,
                            class: D(["relative block min-h-[1em] truncate", {
                              "pr-5": M.value && u(g)
                            }])
                          }, [
                            x("span", {
                              ref_key: "textRef",
                              ref: o,
                              class: "h-4"
                            }, O(b.value.label), 513),
                            b.value.additionalLabel ? (p(), w("span", Ni, O(b.value.additionalLabel), 1)) : E("", !0)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["class", "disabled", "empty", "error", "focused", "loading", "placeholder", "required"])
                    ])
                  ], 512),
                  V.error && V.errorMessage ? (p(), w("small", _i, O(V.errorMessage), 1)) : E("", !0)
                ])
              ]),
              _: 2
            }, 1024),
            !(V.error && V.errorMessage) && V.caption ? (p(), w("small", {
              key: 0,
              class: "block max-w-full pt-1 text-grey-300",
              innerHTML: V.caption
            }, null, 8, Ui)) : E("", !0)
          ]),
          (p(), L($n, { to: "body" }, [
            e.overlay ? (p(), L(nt, {
              key: 0,
              "enter-active-class": "transition-opacity duration-200 ease-out",
              "enter-from-class": "transition-opacity opacity-0",
              "enter-to-class": "transition-opacity opacity-100",
              "leave-active-class": "transition-opacity delay-100 duration-200 ease-out",
              "leave-from-class": "transition-opacity opacity-100",
              "leave-to-class": "transition-opacity opacity-0"
            }, {
              default: k(() => [
                q ? (p(), w("div", Wi)) : E("", !0)
              ]),
              _: 2
            }, 1024)) : E("", !0),
            C(u(Qs), {
              as: "template",
              static: ""
            }, {
              default: k((j) => [
                C(nt, {
                  "enter-active-class": "transition duration-200 ease-out",
                  "enter-from-class": "transform scale-125 translate-y-5 opacity-0",
                  "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
                  "leave-active-class": "transition duration-200 ease-out",
                  "leave-from-class": "transform scale-100 translate-y-0 opacity-100",
                  "leave-to-class": "transform scale-125 translate-y-5 opacity-0"
                }, {
                  default: k(() => [
                    Et(x("div", {
                      ref_key: "dropdownContent",
                      ref: s,
                      class: "cfg-select__body z-floating-content w-full divide-y divide-grey-stroke overflow-auto rounded-xl bg-white shadow-light focus-visible:outline-none",
                      style: Ae({
                        ...u(d),
                        width: `${u(r)}px`,
                        minWidth: e.contentMinWidth
                      })
                    }, [
                      j.open ? (p(), w(te, { key: 0 }, [
                        V.loading ? (p(), w("div", qi, [
                          C(u(Vt), { class: "text-[8px] text-brand" })
                        ])) : (p(), w("ul", Yi, [
                          (p(!0), w(te, null, ue(u(v), (Y) => (p(), L(u(el), {
                            key: Y.value,
                            as: "li",
                            class: D(["cursor-pointer", {
                              "p-4": !V.$slots.item
                            }]),
                            value: Y.label,
                            onClick: (N) => !u(g) && $(Y),
                            onKeydown: [
                              Re((N) => $(Y), ["enter"]),
                              Re((N) => $(Y), ["space"])
                            ]
                          }, {
                            default: k(({ active: N }) => [
                              z(V.$slots, "item", {
                                focused: N,
                                isSelected: Y.selected,
                                option: Y,
                                toggle: $
                              }, () => [
                                (p(), L(Me(u(R)), {
                                  id: `cfgSelect-${Y.value}`,
                                  focused: N,
                                  "initial-focused": Y.selected,
                                  "model-value": !!Y.selected,
                                  "onUpdate:modelValue": (F) => $(Y)
                                }, Yt({
                                  default: k(() => [
                                    u(g) ? E("", !0) : z(V.$slots, "label", {
                                      key: 0,
                                      value: Y
                                    }, () => [
                                      x("span", {
                                        class: D(["leading-6", { "text-brand": Y.selected, "text-grey-500": !Y.selected }]),
                                        innerHTML: Y.label
                                      }, null, 10, Ki),
                                      Y.subtext ? (p(), L(u(_), {
                                        key: 0,
                                        class: "block text-grey-300",
                                        size: u(H).xs,
                                        "tag-name": "sm"
                                      }, {
                                        default: k(() => [
                                          K(O(Y.subtext), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["size"])) : E("", !0)
                                    ])
                                  ]),
                                  _: 2
                                }, [
                                  u(g) ? {
                                    name: "label",
                                    fn: k(() => [
                                      z(V.$slots, "label", { value: Y }, () => [
                                        x("span", {
                                          class: D(["leading-6", { "text-brand": Y.selected, "text-grey-500": !Y.selected }]),
                                          innerHTML: Y.label
                                        }, null, 10, Gi),
                                        Y.subtext ? (p(), L(u(_), {
                                          key: 0,
                                          class: "block text-grey-300",
                                          size: u(H).xs,
                                          "tag-name": "sm"
                                        }, {
                                          default: k(() => [
                                            K(O(Y.subtext), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["size"])) : E("", !0)
                                      ])
                                    ]),
                                    key: "0"
                                  } : void 0
                                ]), 1032, ["id", "focused", "initial-focused", "model-value", "onUpdate:modelValue"]))
                              ])
                            ]),
                            _: 2
                          }, 1032, ["class", "value", "onClick", "onKeydown"]))), 128))
                        ]))
                      ], 64)) : E("", !0)
                    ], 4), [
                      [qt, j.open]
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]))
        ])
      ]),
      _: 3
    }, 8, ["disabled", "model-value", "multiple"]));
  }
}), Xi = { class: "cfg-slider" }, Zi = {
  key: 1,
  class: "mx-[-12px] mt-6"
}, Ji = { class: "inputs flex justify-between" }, Qi = {
  key: 2,
  class: "block max-w-full pt-3 text-warning"
}, eu = {
  key: 3,
  class: "block max-w-full pt-3 text-grey-300"
}, Nd = /* @__PURE__ */ W({
  __name: "CfgSlider",
  props: {
    ...be,
    modelValue: {
      type: [Number, Array],
      required: !0
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      required: !0
    },
    max: {
      type: Number,
      required: !0
    },
    tipSuffix: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    coloredMode: {
      type: String,
      default: "default"
    },
    useInputs: {
      type: Boolean,
      default: !1
    },
    inputsWidth: {
      type: String,
      default: "80px"
    },
    tooltips: {
      type: Boolean,
      default: !0
    },
    snap: {
      type: Boolean,
      default: !1
    },
    lazy: {
      type: Boolean,
      default: !0
    },
    range: {
      type: Object,
      default: void 0
    }
  },
  emits: ["update:modelValue", "apply", "drag:end"],
  async setup(e, { emit: n }) {
    let t, o;
    const a = e, l = n, s = U(a.modelValue), { default: i } = ([t, o] = Ut(() => import("@vueform/slider")), t = await t, o(), t), r = B(() => {
      const c = {
        snap: a.snap,
        connect: !0,
        range: a.range || { min: a.min, max: a.max }
      };
      return a.lazy ? c : {};
    });
    de(
      () => a.modelValue,
      () => {
        St(s.value, a.modelValue) || (s.value = a.modelValue);
      },
      { deep: !0, immediate: !0 }
    ), de(
      s,
      () => {
        a.lazy || St(s.value, a.modelValue) || l("update:modelValue", s.value);
      },
      { deep: !0, immediate: !0 }
    );
    async function d(c, g) {
      const h = Array.isArray(s.value) && g === 1 ? s.value[0] : a.min;
      let v = Array.isArray(s.value) && g === 0 ? s.value[1] : a.max;
      g === 0 && Array.isArray(s.value) && (v = s.value[1]);
      let y = Number(c);
      y < h ? y = h : y > v && (y = v), y = Math.round(y / a.step) * a.step, Je(() => {
        s.value[g] = y, s.value = [...s.value], m(s.value);
      });
    }
    function m(c) {
      l("update:modelValue", c), l("apply", c);
    }
    return (c, g) => (p(), w("div", Xi, [
      c.placeholder ? (p(), L(_, {
        key: 0,
        class: "mb-5 block text-grey-300",
        size: u(H).md
      }, {
        default: k(() => [
          K(O(c.placeholder), 1)
        ]),
        _: 1
      }, 8, ["size"])) : E("", !0),
      C(u(i), {
        modelValue: s.value,
        "onUpdate:modelValue": g[0] || (g[0] = (h) => s.value = h),
        class: D(["core-slider cfg-slider__slider w-full", { [`cfg-slider__slider--colored-mode__${e.coloredMode}`]: !0 }]),
        disabled: e.disabled || c.loading,
        lazy: e.lazy,
        max: e.max,
        min: e.min,
        options: r.value,
        "show-tooltip": "drag",
        step: e.step,
        tooltips: e.tooltips,
        onEnd: g[1] || (g[1] = (h) => c.$emit("drag:end")),
        onUpdate: m
      }, null, 8, ["modelValue", "class", "disabled", "lazy", "max", "min", "options", "step", "tooltips"]),
      e.useInputs ? (p(), w("div", Zi, [
        x("div", Ji, [
          C(ca, {
            max: e.max,
            min: s.value[0],
            "model-value": String(s.value[0]),
            step: e.step,
            style: Ae({
              width: e.inputsWidth
            }),
            suffix: e.tipSuffix,
            type: "number",
            onBlur: g[2] || (g[2] = (h) => d(h, 0))
          }, null, 8, ["max", "min", "model-value", "step", "style", "suffix"]),
          C(ca, {
            max: e.max,
            min: s.value[0],
            "model-value": String(s.value[1]),
            step: e.step,
            style: Ae({
              width: e.inputsWidth
            }),
            suffix: e.tipSuffix,
            type: "number",
            onBlur: g[3] || (g[3] = (h) => d(h, 1))
          }, null, 8, ["max", "min", "model-value", "step", "style", "suffix"])
        ])
      ])) : E("", !0),
      c.error && c.errorMessage ? (p(), w("small", Qi, O(c.errorMessage), 1)) : E("", !0),
      !(c.error && c.errorMessage) && c.caption ? (p(), w("small", eu, O(c.caption), 1)) : E("", !0)
    ]));
  }
}), _d = /* @__PURE__ */ W({
  __name: "CfgTab",
  props: {
    as: { default: "button" },
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = va("getTabsTabIndex", () => 0)();
    return (o, a) => (p(), L(u(Is), {
      as: o.as,
      class: "relative translate-y-px px-3 pb-4 leading-none transition duration-200 focus:outline-0 data-[disabled]:cursor-not-allowed data-[state=active]:text-brand",
      disabled: o.disabled,
      value: u(t)
    }, {
      default: k(() => [
        z(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "disabled", "value"]));
  }
}), Ud = /* @__PURE__ */ W({
  __name: "CfgTabPanel",
  setup(e) {
    const t = va("getTabsPanelIndex", () => 0)();
    return (o, a) => (p(), L(u(Ps), { value: u(t) }, {
      default: k(() => [
        z(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), Wd = /* @__PURE__ */ W({
  __name: "CfgTabs",
  props: /* @__PURE__ */ se({
    as: { default: "div" }
  }, {
    selectedTab: { default: 0 },
    selectedTabModifiers: {}
  }),
  emits: ["update:selectedTab"],
  setup(e) {
    const n = me(e, "selectedTab"), t = kn({
      tab: 0,
      panel: 0
    });
    function o(a) {
      const l = t[a];
      return t[a] += 1, l;
    }
    return Xn("getTabsTabIndex", () => o("tab")), Xn("getTabsPanelIndex", () => o("panel")), (a, l) => (p(), L(u(Os), {
      modelValue: n.value,
      "onUpdate:modelValue": l[0] || (l[0] = (s) => n.value = s),
      as: a.as
    }, {
      default: k(() => [
        C(u(Fs), { class: "relative flex shrink-0 border-b border-b-grey-stroke" }, {
          default: k(() => [
            C(u(Rs), { class: "absolute bottom-0 left-0 h-px w-[--reka-tabs-indicator-size] translate-x-[--reka-tabs-indicator-position] translate-y-px rounded-full bg-brand px-8 transition-[width,transform] duration-300" }),
            z(a.$slots, "tabs")
          ]),
          _: 3
        }),
        z(a.$slots, "panels")
      ]),
      _: 3
    }, 8, ["modelValue", "as"]));
  }
}), ge = {
  default: "brand",
  success: "success",
  warning: "warning",
  danger: "red",
  neutral: "neutral"
}, tu = { class: "timeline-item relative z-0 grid grid-cols-[2.75rem_1fr] gap-4 before:absolute before:left-[1.375rem] before:top-1/2 before:-z-10 before:h-full before:w-px before:bg-grey-100" }, nu = { class: "flex h-11 items-center justify-center" }, au = {
  key: 1,
  class: "size-3 rounded-full bg-grey-100"
}, su = { class: "flex flex-col items-start justify-center gap-y-0.5" }, lu = /* @__PURE__ */ W({
  __name: "CfgTimelineItem",
  props: {
    color: { default: ge.default },
    icon: { default: void 0 },
    title: { default: void 0 },
    text: { default: void 0 },
    hasPingAnimation: { type: Boolean, default: !1 },
    id: { default: void 0 },
    tooltip: { type: Boolean },
    meta: { default: void 0 }
  },
  setup(e) {
    const n = e, t = B(() => hn(n.icon) ? void 0 : ns[n.icon]), o = B(() => ({
      background: {
        "bg-brand": n.color === ge.default,
        "bg-grey-300": n.color === ge.neutral,
        "bg-success": n.color === ge.success,
        "bg-warning": n.color === ge.warning,
        "bg-red": n.color === ge.danger
      },
      backgroundLight: {
        "bg-brand/30": n.color === ge.default,
        "bg-grey-300/30": n.color === ge.neutral,
        "bg-success/30": n.color === ge.success,
        "bg-warning/30": n.color === ge.warning,
        "bg-red/30": n.color === ge.danger
      },
      ring: {
        "ring-brand/30": n.color === ge.default,
        "ring-success/30": n.color === ge.success,
        "ring-warning/30": n.color === ge.warning,
        "ring-red/30": n.color === ge.danger,
        "ring-grey-300/30": n.color === ge.neutral
      },
      text: {
        "text-dark": n.color === ge.success || n.color === ge.neutral || n.color === ge.default,
        "text-warning": n.color === ge.warning,
        "text-red": n.color === ge.danger
      }
    }));
    return (a, l) => (p(), w("div", tu, [
      x("div", nu, [
        !u(hn)(t.value) || a.$slots.icon ? (p(), w(te, { key: 0 }, [
          x("span", {
            class: D(["flex size-[30px] items-center justify-center rounded-full text-white ring-[7px] [&>*]:size-4", { ...o.value.ring, ...o.value.background }])
          }, [
            z(a.$slots, "icon", {}, () => [
              (p(), L(Me(t.value)))
            ])
          ], 2),
          a.hasPingAnimation ? (p(), w("span", {
            key: 0,
            class: D(["absolute inline-flex size-[33px] animate-ping rounded-full", o.value.backgroundLight])
          }, null, 2)) : E("", !0)
        ], 64)) : (p(), w("span", au))
      ]),
      x("div", su, [
        z(a.$slots, "content", {
          text: a.text,
          title: a.title
        }, () => [
          u(Zn)(a.title) ? E("", !0) : (p(), L(u(_), {
            key: 0,
            class: D(o.value.text),
            size: u(H).sm
          }, {
            default: k(() => [
              z(a.$slots, "title", { title: a.title }, () => [
                K(O(a.title), 1)
              ])
            ]),
            _: 3
          }, 8, ["class", "size"])),
          u(Zn)(a.text) ? E("", !0) : (p(), L(u(_), {
            key: 1,
            class: "text-sm text-grey-300",
            size: u(H).sm
          }, {
            default: k(() => [
              z(a.$slots, "text", { text: a.text }, () => [
                K(O(a.text), 1)
              ])
            ]),
            _: 3
          }, 8, ["size"]))
        ])
      ])
    ]));
  }
}), qd = /* @__PURE__ */ W({
  __name: "CfgTimeline",
  props: {
    items: {}
  },
  setup(e) {
    return (n, t) => (p(), w("div", null, [
      z(n.$slots, "prependItems", { attrs: { class: "timeline-item-wrapper" } }),
      (p(!0), w(te, null, ue(n.items, (o, a) => (p(), w("div", {
        key: a,
        class: "timeline-item-wrapper"
      }, [
        C(Ft, {
          class: "w-full max-w-full [&>*]:max-w-full",
          disabled: !o.tooltip,
          "hide-icon": "",
          "tooltip-padding": !1
        }, {
          trigger: k(() => [
            C(lu, ae({ ref_for: !0 }, o), null, 16)
          ]),
          content: k(() => [
            z(n.$slots, "tooltip", { item: o })
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]))), 128)),
      z(n.$slots, "appendItems", { attrs: { class: "timeline-item-wrapper" } })
    ]));
  }
});
var Ee = /* @__PURE__ */ ((e) => (e.Success = "success", e.Error = "error", e.Warning = "warning", e.Info = "info", e))(Ee || {});
const ou = { class: "p-4" }, ru = { class: "flex items-center" }, iu = { class: "shrink-0" }, uu = { class: "ml-4 w-0 flex-1 pt-0.5" }, du = ["innerHTML"], cu = { class: "ml-5 flex shrink-0 self-center" }, Yd = /* @__PURE__ */ W({
  __name: "CfgToastNotification",
  props: {
    type: {},
    title: {},
    message: {}
  },
  emits: ["close"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = B(() => t.type === Ee.Info ? mn : t.type === Ee.Success ? ha : t.type === Ee.Warning ? is : t.type === Ee.Error ? Ne : mn);
    return (l, s) => (p(), w("div", {
      class: D(["pointer-events-auto w-full max-w-sm overflow-hidden rounded-xl border-l-4 bg-white shadow-base ring-1 ring-dark-100/5", {
        "border-none": l.type === u(Ee).Info,
        "border-success": l.type === u(Ee).Success,
        "border-yellow": l.type === u(Ee).Warning,
        "border-warning": l.type === u(Ee).Error
      }])
    }, [
      x("div", ou, [
        x("div", ru, [
          x("div", iu, [
            z(l.$slots, "icon", {}, () => [
              x("div", {
                class: D(["mt-1 rounded-xl p-2", {
                  "bg-grey-100/50 text-grey-200": l.type === u(Ee).Info,
                  "bg-success-light text-success": l.type === u(Ee).Success,
                  "bg-yellow-light text-yellow": l.type === u(Ee).Warning,
                  "bg-warning-light text-warning": l.type === u(Ee).Error
                }])
              }, [
                (p(), L(Me(a.value), {
                  "aria-hidden": "true",
                  class: "text-lg"
                }))
              ], 2)
            ])
          ]),
          x("div", uu, [
            C(_, {
              class: "text-dark-300 text-[18px] leading-[1.15]",
              "tag-name": "h4"
            }, {
              default: k(() => [
                K(O(l.title), 1)
              ]),
              _: 1
            }),
            l.message ? (p(), w("p", {
              key: 0,
              class: "mt-2 text-sm text-grey-400",
              innerHTML: l.message
            }, null, 8, du)) : E("", !0)
          ]),
          x("div", cu, [
            x("button", {
              class: "focusable inline-flex rounded-xl bg-white text-grey-300 hover:text-grey-500",
              type: "button",
              onClick: s[0] || (s[0] = (i) => o("close"))
            }, [
              s[1] || (s[1] = x("span", { class: "sr-only" }, "Close", -1)),
              C(u(Ne), {
                "aria-hidden": "true",
                class: "text-lg"
              })
            ])
          ])
        ])
      ])
    ], 2));
  }
}), fu = { class: "flex flex-col gap-5" }, pu = { class: "flex gap-x-2" }, mu = { class: "grow" }, Gd = /* @__PURE__ */ W({
  __name: "CfgAddressDetailsField",
  props: {
    ...be,
    ...Ve,
    modelValue: {
      type: [Object, null],
      required: !0
    },
    translates: {
      type: Object,
      required: !0
    },
    zipLengthErrorMessage: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = B({
      get() {
        const s = {
          firstLine: "",
          secondLine: "",
          zip: "",
          state: ""
        };
        return t.modelValue || s;
      },
      set(s) {
        o("update:modelValue", s);
      }
    }), l = B(() => {
      const s = {
        firstLine: "",
        secondLine: "",
        zip: "",
        state: ""
      };
      return t.error && a.value && Object.entries(a.value).forEach(([i, r]) => {
        r || (s[i] = t.errorMessage);
      }), a.value.zip.length > 5 && (s.zip = t.zipLengthErrorMessage), s;
    });
    return (s, i) => {
      var r, d, m, c;
      return p(), w("div", fu, [
        C(ze, {
          caption: e.translates.captions.firstLine,
          error: !!l.value.firstLine,
          "error-message": l.value.firstLine,
          fluid: !0,
          "initial-focused": s.initialFocused,
          "model-value": (r = a.value) == null ? void 0 : r.firstLine,
          placeholder: e.translates.placeholders.firstLine,
          required: s.required,
          "onUpdate:modelValue": i[0] || (i[0] = (g) => {
            a.value = {
              ...a.value,
              firstLine: g.toString()
            };
          })
        }, null, 8, ["caption", "error", "error-message", "initial-focused", "model-value", "placeholder", "required"]),
        x("div", pu, [
          C(ze, {
            caption: e.translates.captions.secondLine,
            error: !!l.value.secondLine,
            "error-message": l.value.secondLine,
            fluid: !0,
            "model-value": (d = a.value) == null ? void 0 : d.secondLine,
            placeholder: e.translates.placeholders.secondLine,
            required: s.required,
            "onUpdate:modelValue": i[1] || (i[1] = (g) => {
              a.value = {
                ...a.value,
                secondLine: g.toString()
              };
            })
          }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"]),
          x("div", mu, [
            C(ze, {
              caption: e.translates.captions.zip,
              class: "w-[100px]",
              error: !!l.value.zip,
              "error-message": l.value.zip,
              fluid: !0,
              "model-value": (m = a.value) == null ? void 0 : m.zip,
              placeholder: e.translates.placeholders.zip,
              required: s.required,
              "onUpdate:modelValue": i[2] || (i[2] = (g) => {
                a.value = {
                  ...a.value,
                  zip: g.toString()
                };
              })
            }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"])
          ])
        ]),
        C(ze, {
          caption: e.translates.captions.state,
          error: !!l.value.state,
          "error-message": l.value.state,
          fluid: !0,
          "model-value": (c = a.value) == null ? void 0 : c.state,
          placeholder: e.translates.placeholders.state,
          required: s.required,
          "onUpdate:modelValue": i[3] || (i[3] = (g) => {
            a.value = {
              ...a.value,
              state: g.toString()
            };
          })
        }, null, 8, ["caption", "error", "error-message", "model-value", "placeholder", "required"])
      ]);
    };
  }
}), pa = 450, Kd = /* @__PURE__ */ W({
  __name: "CfgBankAccountField",
  props: {
    ...be,
    ...Ve,
    modelValue: {
      type: Object,
      default: () => ({
        accountNumber: "",
        bankCode: ""
      })
    },
    codePlaceholder: {
      type: String,
      required: !0
    },
    errorTranslations: {
      type: Object,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = U(), { width: l } = Cn(a), s = B(() => Ge(t, Object.keys(Xt({ ...be, ...Ve }, "modelValue")))), i = Object.entries(on).map((g) => {
      const [h, v] = g;
      return {
        value: on[h],
        label: `${v} - ${ks[`${on[h]}`]}`
      };
    }), r = B({
      get() {
        return t.modelValue || { accountNumber: "", bankCode: "" };
      },
      set(g) {
        o("update:modelValue", g);
      }
    }), d = B({
      get() {
        var g, h;
        if ((g = r.value) != null && g.bankCode) {
          const v = (h = i.find((y) => y.value === r.value.bankCode)) == null ? void 0 : h.value;
          if (v)
            return {
              label: v,
              value: v
            };
        }
        return null;
      },
      set(g) {
        g && (r.value = {
          ...r.value || {},
          bankCode: g.value
        });
      }
    }), m = B(() => {
      const g = {
        accountNumber: "",
        bankCode: ""
      };
      return t.error && (r.value.accountNumber || (g.accountNumber = t.errorTranslations.accountNumber.required), r.value.bankCode || (g.bankCode = t.errorTranslations.bankCode), r.value.accountNumber && !r.value.bankCode && (g.accountNumber = ""), r.value.accountNumber && r.value.bankCode && (g.accountNumber = t.errorTranslations.accountNumber.invalid)), g;
    });
    function c(g) {
      r.value = { ...r.value, accountNumber: g };
    }
    return (g, h) => {
      var v;
      return p(), w("div", {
        ref_key: "rootElRef",
        ref: a,
        class: D(["flex gap-2", {
          "flex-col": u(l) < pa
        }])
      }, [
        C(ze, ae({
          ...s.value,
          modelValue: ((v = r.value) == null ? void 0 : v.accountNumber) || ""
        }, {
          class: "relative grow cursor-pointer",
          error: !!m.value.accountNumber,
          "error-message": m.value.accountNumber,
          fluid: "",
          required: "",
          "onUpdate:modelValue": h[0] || (h[0] = (y) => c(String(y)))
        }), null, 16, ["error", "error-message"]),
        C(Ra, {
          modelValue: d.value,
          "onUpdate:modelValue": h[1] || (h[1] = (y) => d.value = y),
          class: D(["w-1/4 min-w-[180px]", {
            "max-w-[300px]": u(l) >= pa
          }]),
          disabled: t.disabled,
          error: !!m.value.bankCode,
          "error-message": m.value.bankCode,
          options: u(i),
          origin: "right",
          placeholder: e.codePlaceholder,
          required: "",
          style: { "--max-height": "400px" }
        }, null, 8, ["modelValue", "class", "disabled", "error", "error-message", "options", "placeholder"])
      ], 2);
    };
  }
}), gu = { class: "w-[340px] rounded-xl bg-white px-8 pb-6 pt-7 sm:w-[375px]" }, vu = /* @__PURE__ */ W({
  __name: "CfgDateField",
  props: /* @__PURE__ */ se({
    ...be,
    ...Ve,
    ...Ba,
    allowedPlacements: {
      type: Hn.allowedPlacements.type,
      default: () => ["bottom"]
    }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = B(() => Ge(n, Object.keys({ ...be, ...Ve }))), o = me(e, "modelValue"), a = B(() => o.value ? oe(o.value).format("D. M. YYYY") : ""), l = U(!1);
    function s() {
      Je(() => {
        l.value = !1;
      });
    }
    return (i, r) => (p(), L(Oa, {
      opened: l.value,
      "onUpdate:opened": r[1] || (r[1] = (d) => l.value = d),
      "allowed-placements": e.allowedPlacements,
      "min-width": 340,
      "use-trigger-content-width": !0
    }, {
      trigger: k(() => [
        C(ze, ae({
          ...t.value,
          modelValue: a.value,
          readonly: !0,
          fluid: !0
        }, {
          class: "relative cursor-pointer",
          "field-class": "!bg-white"
        }), {
          icon: k(() => [
            C(u(us), {
              class: D(["text-[1.5rem] transition-colors duration-200", { "text-brand": l.value, "text-grey-300": !l.value }])
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 16)
      ]),
      content: k(() => [
        x("div", gu, [
          C(Xl, {
            modelValue: o.value,
            "onUpdate:modelValue": r[0] || (r[0] = (d) => o.value = d),
            "max-date": i.maxDate,
            "min-date": i.minDate,
            onSelectDate: s
          }, null, 8, ["modelValue", "max-date", "min-date"])
        ])
      ]),
      _: 1
    }, 8, ["opened", "allowed-placements"]));
  }
}), hu = { class: "grow" }, ma = 450, Xd = /* @__PURE__ */ W({
  __name: "CfgBirthNumberField",
  props: /* @__PURE__ */ se({
    ...be,
    ...Ve,
    translates: {
      type: Object,
      required: !0
    }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = B(() => Ge(n, Object.keys({ ...be, ...Ve }))), o = me(e, "modelValue"), a = U(), { width: l } = Cn(a), s = B({
      get() {
        var m;
        return ((m = o.value) == null ? void 0 : m.birthDate) || null;
      },
      set(m) {
        m && d({
          birthDate: m
        });
      }
    });
    function i(m) {
      d({ birthNumber: m });
    }
    function r() {
      var m;
      (m = o.value) != null && m.birthNumber && ws.validateBirthNumber(o.value.birthNumber) && d({
        birthDate: $s(o.value.birthNumber)
      });
    }
    function d(m) {
      o.value = {
        ...o.value || { birthDate: null, birthNumber: "" },
        ...m
      };
    }
    return (m, c) => {
      var g;
      return p(), w("div", {
        ref_key: "rootElRef",
        ref: a,
        class: D(["flex gap-2", { "flex-col": u(l) < ma }])
      }, [
        x("div", hu, [
          C(ze, ae({
            ...t.value,
            modelValue: ((g = o.value) == null ? void 0 : g.birthNumber) || "",
            placeholder: e.translates.birthNumberPlaceholder,
            fluid: !0
          }, {
            class: "relative cursor-pointer",
            required: "",
            onBlur: r,
            "onUpdate:modelValue": c[0] || (c[0] = (h) => i(h.toString()))
          }), null, 16)
        ]),
        C(vu, {
          modelValue: s.value,
          "onUpdate:modelValue": c[1] || (c[1] = (h) => s.value = h),
          class: D({ "w-[240px]": u(l) >= ma }),
          disabled: n.disabled,
          placeholder: e.translates.birthDatePlaceholder
        }, null, 8, ["modelValue", "class", "disabled", "placeholder"])
      ], 2);
    };
  }
}), Zd = /* @__PURE__ */ W({
  __name: "CfgPasswordField",
  props: /* @__PURE__ */ se({
    ...be,
    ...Ve
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = B(() => Ge(n, Object.keys({ ...be, ...Ve }))), o = me(e, "modelValue"), a = U(!1);
    function l() {
      a.value = !a.value;
    }
    function s(i) {
      o.value = i;
    }
    return (i, r) => (p(), w("div", null, [
      C(ze, ae({
        ...t.value,
        fluid: !0
      }, {
        "interact-with-icon": "",
        "model-value": o.value,
        type: a.value ? "text" : "password",
        "onUpdate:modelValue": s
      }), {
        icon: k(() => [
          C(u(ds), {
            class: D(["text-[1.5rem] hover:cursor-pointer", {
              "text-grey-300": !a.value,
              "text-brand": a.value
            }]),
            onClick: Le(l, ["prevent"])
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 16, ["model-value", "type"])
    ]));
  }
}), yu = {
  ...Ve,
  ...jn,
  observerSlotEvents: {
    type: Object,
    required: !0
  }
}, Jd = /* @__PURE__ */ W({
  __name: "CfgValidatedField",
  props: /* @__PURE__ */ se(yu, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = me(e, "modelValue"), o = B(() => Ge(n, Object.keys(Ve))), a = B(() => Ge(n, Object.keys(jn)));
    return (l, s) => (p(), L(Pa, ae({
      modelValue: t.value,
      "onUpdate:modelValue": s[0] || (s[0] = (i) => t.value = i),
      required: o.value.required,
      validators: a.value.validators
    }, wt(l.observerSlotEvents || {})), {
      default: k(({ on: i, attrs: r }) => [
        C(ze, ae({ ...l.$attrs, ...o.value, ...r }, {
          "model-value": r.modelValue
        }, wt(i)), {
          icon: k(() => [
            z(l.$slots, "icon")
          ]),
          _: 2
        }, 1040, ["model-value"])
      ]),
      _: 3
    }, 16, ["modelValue", "required", "validators"]));
  }
}), bu = { class: "flex grow items-start justify-between" }, xu = { class: "flex shrink-0 justify-between" }, ku = {
  key: 1,
  class: "items-center"
}, ja = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "CfgOverlayPanelContent",
  props: {
    title: {},
    description: {},
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    isBackAllowed: { type: Boolean },
    renderClose: { type: Boolean, default: !0 },
    disableBottomPadding: { type: Boolean }
  },
  emits: ["close", "back"],
  setup(e) {
    const n = e, t = ["px-", "pr-", "pl"], o = Wt(), a = U(null), l = B(() => o.class ?? ""), s = B(() => n.flat ? !1 : !t.some((i) => l.value.includes(i)));
    return (i, r) => (p(), L(u(ai), {
      ref_key: "scrollbarView",
      ref: a,
      class: D(["shadow-xl flex h-full flex-col rounded-t-xl bg-white", {
        [l.value]: !0,
        "pb-6 ": !i.disableBottomPadding
      }])
    }, {
      default: k(() => {
        var d;
        return [
          i.title || i.description || i.$slots.head ? (p(), w("header", {
            key: 0,
            class: D(["z-sticky flex border-b border-b-grey-stroke bg-white py-5 transition-shadow duration-200", {
              "px-5 sm:px-9": s.value,
              "shadow-light": (((d = a.value) == null ? void 0 : d.scrollPositionY) || 0) > 0 && (i.title || i.description),
              "sticky top-0": i.title || i.description
            }]),
            name: "head"
          }, [
            x("div", bu, [
              x("div", null, [
                z(i.$slots, "head", {}, () => [
                  i.title ? (p(), L(u(_), {
                    key: 0,
                    size: u(H).h2,
                    "tag-name": "h3"
                  }, {
                    default: k(() => [
                      K(O(i.title), 1)
                    ]),
                    _: 1
                  }, 8, ["size"])) : E("", !0),
                  i.description ? (p(), L(u(_), {
                    key: 1,
                    class: "mt-2 text-grey-300",
                    size: u(H).sm,
                    "tag-name": "p"
                  }, {
                    default: k(() => [
                      K(O(i.description), 1)
                    ]),
                    _: 1
                  }, 8, ["size"])) : E("", !0)
                ])
              ])
            ]),
            x("div", xu, [
              i.isBackAllowed ? (p(), w("button", {
                key: 0,
                class: "flex size-11 items-center justify-center rounded-full bg-grey-100 ring-brand focus-visible:outline-brand focus-visible:ring",
                type: "button",
                onClick: r[0] || (r[0] = (m) => i.$emit("back"))
              }, [
                C(u(cs))
              ])) : E("", !0),
              i.closable && i.renderClose ? (p(), w("div", ku, [
                x("button", {
                  class: "flex size-11 items-center justify-center rounded-full bg-grey-100 ring-brand focus-visible:outline-brand focus-visible:ring",
                  type: "button",
                  onClick: r[1] || (r[1] = (m) => i.$emit("close"))
                }, [
                  C(u(Ne))
                ])
              ])) : E("", !0)
            ])
          ], 2)) : E("", !0),
          x("main", {
            class: D(["relative flex flex-1 first-of-type:mt-5 lg:first-of-type:mt-8 [&>*]:flex-1", {
              "px-5 sm:px-9": s.value
            }])
          }, [
            z(i.$slots, "default")
          ], 2)
        ];
      }),
      _: 3
    }, 8, ["class"]));
  }
}), wu = { class: "fixed inset-0 overflow-hidden" }, $u = { class: "pointer-events-none fixed inset-x-0 bottom-0 flex size-full" }, Qd = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "CfgBottomSheet",
  props: {
    opened: { type: Boolean },
    unmount: { type: Boolean },
    onBack: { type: Function, default: void 0 },
    title: { default: "" },
    description: { default: "" },
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 },
    renderClose: { type: Boolean, default: !0 },
    disableBottomPadding: { type: Boolean }
  },
  emits: ["update:opened"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = B(() => Xt(t, ["opened", "unmount", "onBack"]));
    function l() {
      !t.closable && t.onBack && t.onBack(), t.closable && o("update:opened", !1);
    }
    return (s, i) => (p(), L(u(Dn), {
      as: "template",
      show: s.opened
    }, {
      default: k(() => [
        C(u(Tn), {
          as: "div",
          class: "relative z-modal",
          unmount: s.unmount ?? !1,
          onClose: l
        }, {
          default: k(() => [
            C(u(ft), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: k(() => i[0] || (i[0] = [
                x("div", { class: "fixed inset-0 bg-dark/30 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            x("div", wu, [
              x("div", {
                class: "absolute inset-0",
                onClose: l
              }, [
                x("div", $u, [
                  C(u(ft), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "translate-y-full",
                    "enter-to": "translate-y-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-y-0",
                    "leave-to": "translate-y-full"
                  }, {
                    default: k(() => [
                      C(u(En), { class: "pointer-events-auto h-[calc(100%-70px)] w-full self-end" }, {
                        default: k(() => [
                          C(ja, ae({ ...a.value, ...s.$attrs }, {
                            "is-back-allowed": !!t.onBack,
                            onBack: t.onBack,
                            onClose: l
                          }), Yt({
                            default: k(() => [
                              z(s.$slots, "default")
                            ]),
                            _: 2
                          }, [
                            s.$slots.head ? {
                              name: "head",
                              fn: k(() => [
                                z(s.$slots, "head")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["is-back-allowed", "onBack"])
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  })
                ])
              ], 32)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
});
var ye = /* @__PURE__ */ ((e) => (e.Input = "input", e.Textarea = "textarea", e.DateField = "dateField", e.Select = "select", e.Multiselect = "multiselect", e.Combobox = "combobox", e.Radio = "radio", e.Switch = "switch", e.Checkbox = "checkbox", e.RadioGroup = "radioGroup", e.CheckboxGroup = "checkboxGroup", e.AccountNumber = "accountNumber", e.Slider = "slider", e.RangeSlider = "rangeSlider", e.BirthNumberField = "birthNumberField", e.AddressDetailsField = "addressDetailsField", e.PasswordField = "passwordField", e))(ye || {});
function ec(e, n) {
  const t = Object.entries(e).reduce((l, [s, i]) => {
    const {
      value: r,
      cols: d = 2,
      validators: m = [],
      classNames: c,
      show: g,
      ...h
    } = i;
    return l[s] = {
      component: i.control,
      props: h,
      modelValue: r,
      validators: m,
      cols: d,
      show: g,
      _visible: !0,
      attributes: {
        classNames: c
      }
    }, l;
  }, {}), o = kn(
    Object.fromEntries(
      Object.entries(t).map((l) => {
        const [s, i] = l;
        return [s, {
          ...bt(i),
          props: i.props
          // pass props separately to avoid loosing reactivity
        }];
      })
    )
  );
  de(() => n, () => {
    if (n) {
      let l = n;
      ct(n) && (l = n.value), Object.entries(l).forEach((s) => {
        const [i, r] = s;
        o[i].modelValue = bt(r);
      });
    }
  }, { deep: !0, immediate: !0 });
  const a = B(() => Ha(o));
  return ts(() => {
    Object.entries(a.value).forEach((l) => {
      const [s] = l, i = o == null ? void 0 : o[s];
      i._visible = hn(i.show) ? !0 : i.show({ state: a.value });
    });
  }), {
    results: a,
    schema: o,
    resetData() {
      Object.entries(o).forEach((l) => {
        const [s] = l;
        o[s].modelValue = n ? (ct(n) ? n.value : n)[s] : bt(e[s].value);
      });
    }
  };
}
function Ha(e) {
  return Object.entries(e).reduce(
    (n, [t, o]) => ({
      ...n,
      [t]: o.modelValue
    }),
    {}
  );
}
const Cu = {
  key: 0,
  class: "flex justify-center"
}, Su = /* @__PURE__ */ W({
  __name: "CfgForm",
  props: {
    /**
     * The schema of the form. Can be generated useForm hook
     */
    schema: {
      type: Object,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * The label of the submit button. Default button will be replaced with slot name submit. Contains onSubmit event in slot props.
     * For example: v-slot={ onSubmit }
     */
    buttonLabel: {
      type: String,
      default: "DEFAULT_BUTTON_LABEL"
    },
    /**
     * Controls whether the submit button should be rendered or not
     */
    renderSubmitButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Shows elements placed horizontally - next to each other
     */
    horizontal: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["submit"],
  async setup(e, { expose: n, emit: t }) {
    let o, a;
    const l = e, s = t, { schema: i, loading: r } = Gt(l), d = B(() => Us(i.value, (b) => (b == null ? void 0 : b._visible) !== !1)), m = U(null), c = U(null), { width: g } = Ct(m), h = B(() => g.value > 500), v = Object.fromEntries(Object.keys(i).map((b) => [b, null])), y = {
      [ye.Input]: async () => (await import("./CfgInput-DHXRPOo4.js")).default,
      [ye.Textarea]: async () => (await import("./CfgTextarea-DIm7nH6k.js")).default,
      [ye.DateField]: async () => (await import("./CfgDateField-BfVgmlao.js")).default,
      [ye.Select]: async () => (await import("./index-foXr4mpb.js")).CfgSelect,
      [ye.Multiselect]: async () => (await import("./index-foXr4mpb.js")).CfgSelect,
      [ye.Combobox]: async () => (await import("./index-foXr4mpb.js")).CfgCombobox,
      [ye.Radio]: async () => (await import("./index-CdiSTu7J.js")).CfgRadio,
      [ye.Switch]: async () => (await import("./index-CdiSTu7J.js")).CfgSwitch,
      [ye.Checkbox]: async () => (await import("./index-CdiSTu7J.js")).CfgCheckbox,
      [ye.RadioGroup]: async () => (await import("./index-foXr4mpb.js")).CfgRadioGroup,
      [ye.CheckboxGroup]: async () => (await import("./index-foXr4mpb.js")).CfgCheckboxGroup,
      [ye.AccountNumber]: async () => (await import("./CfgBankAccountField-B-5PxEPq.js")).default,
      [ye.Slider]: async () => (await import("./index-foXr4mpb.js")).CfgSlider,
      [ye.RangeSlider]: async () => (await import("./index-foXr4mpb.js")).CfgSlider,
      [ye.BirthNumberField]: async () => (await import("./CfgBirthNumberField-BRdKfdyF.js")).default,
      [ye.AddressDetailsField]: async () => (await import("./CfgAddressDetailsField-R14TQnF6.js")).default,
      [ye.PasswordField]: async () => (await import("./CfgPasswordField-e1IwjUM9.js")).default
    };
    n({
      resetForm() {
        var b;
        (b = c.value) == null || b.resetForm();
      },
      async submit() {
        return c.value ? c.value.submit() : !1;
      }
    }), [o, a] = Ut(() => M()), await o, a();
    async function M() {
      (await Promise.all(
        Object.entries(i.value).map(async (f) => {
          const [$, T] = f, A = await y[T.component]();
          return [$, A];
        })
      )).forEach(([f, $]) => {
        v[f] = $;
      });
    }
    function S() {
      s("submit", Ha(i.value));
    }
    return (b, f) => (p(), w("div", null, [
      C(gi, {
        ref_key: "validationObserverRef",
        ref: c,
        onSubmit: S
      }, {
        default: k(($) => [
          x("form", {
            ref_key: "formRoot",
            ref: m,
            class: "cfg-form space-y-4 pt-2",
            novalidate: "",
            onSubmit: f[0] || (f[0] = Le(() => {
            }, ["prevent"]))
          }, [
            x("div", {
              class: D(["grid gap-5", e.horizontal ? "cfg-table-form-container-horizontal" : "grid-cols-2"])
            }, [
              (p(!0), w(te, null, ue(d.value, (T, A) => (p(), w("div", {
                key: A,
                class: D({
                  "col-span-1": T.cols === 1 && h.value,
                  "col-span-2": T.cols === 2 || !h.value,
                  [`cfg-form__field--${T.component}`]: !0,
                  [T.attributes.classNames]: !!T.attributes.classNames
                })
              }, [
                z(b.$slots, `before:${A}`, {}, void 0, !0),
                C(Pa, ae({
                  modelValue: T.modelValue,
                  "onUpdate:modelValue": (R) => T.modelValue = R,
                  validators: T.validators
                }, wt($.on)), {
                  default: k(({ on: R, attrs: V }) => [
                    (p(), L(Me(u(v)[A]), ae({ ref_for: !0 }, {
                      // User's passed props
                      ...u(Xt)(T.props, "control"),
                      ...V,
                      loading: T.props.loading || V.loading
                    }, { class: "w-full" }, wt(R)), null, 16))
                  ]),
                  _: 2
                }, 1040, ["modelValue", "onUpdate:modelValue", "validators"]),
                z(b.$slots, `after:${A}`, {}, void 0, !0)
              ], 2))), 128))
            ], 2),
            e.renderSubmitButton ? (p(), w("div", Cu, [
              z(b.$slots, "submit", {
                onSubmit: $.submit
              }, () => [
                C(Zt, {
                  class: "mt-4 w-full",
                  fluid: "",
                  loading: u(r) || $.validationLoading,
                  type: "submit",
                  onClick: $.submit
                }, {
                  default: k(() => [
                    K(O(e.buttonLabel), 1)
                  ]),
                  _: 2
                }, 1032, ["loading", "onClick"])
              ], !0)
            ])) : E("", !0)
          ], 544)
        ]),
        _: 3
      }, 512)
    ]));
  }
}), tc = /* @__PURE__ */ Xe(Su, [["__scopeId", "data-v-bdf6ea07"]]), Mu = { class: "rounded-md" }, Du = { class: "flex w-full flex-row items-center justify-between space-y-2 lg:flex-col lg:items-start lg:justify-start" }, Tu = { class: "!mt-0 flex flex-row gap-x-2 lg:!mt-2" }, Eu = ["innerHTML"], Vu = ["innerHTML"], Bu = ["innerHTML"], zu = { class: "mt-4" }, Lu = { class: "flex items-center justify-between pb-8" }, Au = { class: "mt-7 flex flex-wrap justify-start gap-4 lg:gap-x-20" }, Iu = { key: 0 }, Pu = { class: "space-y-1" }, Ou = ["innerHTML"], Fu = { class: "space-y-2" }, Ru = { class: "space-y-1" }, ju = ["innerHTML"], nc = /* @__PURE__ */ W({
  __name: "CfgInvestCalculator",
  props: /* @__PURE__ */ se({
    /**
     * Main parameters on the top of the calculator
     */
    mainParameters: {
      type: Object,
      default: () => ({})
    },
    /**
     * Translations for calculator
     */
    translations: {
      type: Object,
      required: !0
    },
    /**
     * Minimum investment amount
     */
    minInvestment: {
      type: Number,
      required: !0
    },
    /**
     * Max investment amount
     */
    maxInvestment: {
      type: Number,
      required: !0
    },
    /**
     * Show periodic result under slider, should not show on ReturnsPeriodicityEnum.OneTime
     */
    showPeriodicResult: {
      type: Boolean,
      required: !0
    },
    /**
     * Show periodic result and whole period result
     */
    result: {
      type: [Object, null],
      default: null
    },
    /**
     * Each change on slider will increment and decrement by this value
     */
    stepValue: {
      type: Number,
      required: !0
    }
  }, {
    modelValue: { required: !0, type: Number },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ se(["slider:dragEnd"], ["update:modelValue"]),
  setup(e) {
    const n = e, t = me(e, "modelValue"), o = U(Lt(t.value, !0)), a = B(() => n.stepValue ?? 0);
    function l(s) {
      const i = (s ?? o.value).replace(/\s/g, ""), r = Cs(Number(i), {
        min: n.minInvestment,
        max: n.maxInvestment,
        step: a.value
      });
      t.value = r, o.value = Lt(r, !0);
    }
    return de(t, (s) => {
      const i = Lt(s, !0);
      o.value !== i && (o.value = Lt(s, !0));
    }, { deep: !0 }), (s, i) => {
      var r, d;
      return p(), w("div", Mu, [
        z(s.$slots, "searchInput"),
        Object.keys(e.mainParameters).length ? (p(), w("ul", {
          key: 0,
          class: D(["mb-10 flex flex-col flex-wrap gap-y-2 lg:flex-row lg:justify-between", {
            "gap-x-5": Object.keys(e.mainParameters).length > 2,
            "gap-x-10": Object.keys(e.mainParameters).length <= 2
          }])
        }, [
          (p(!0), w(te, null, ue(e.mainParameters, ({ label: m, tooltip: c, description: g, value: h }, v) => (p(), w("li", { key: v }, [
            C(u(Ft), {
              class: "w-full",
              disabled: !c,
              "hide-icon": "",
              interactive: ""
            }, {
              trigger: k(() => [
                x("div", Du, [
                  z(s.$slots, `${v}:label`, { label: m }, () => [
                    C(u(_), {
                      class: "flex items-center gap-x-1.5 text-grey-300",
                      size: u(H).xs
                    }, {
                      default: k(() => [
                        K(O(m) + " ", 1),
                        c ? (p(), L(u(ht), {
                          key: 0,
                          class: "hidden text-[20px] lg:block"
                        })) : E("", !0)
                      ]),
                      _: 2
                    }, 1032, ["size"])
                  ]),
                  x("div", Tu, [
                    C(u(_), {
                      class: "flex flex-col items-end !font-highlighted lg:items-start",
                      size: u(H).md,
                      "tag-name": "strong"
                    }, {
                      default: k(() => [
                        z(s.$slots, `${v}:value`, { value: h }, () => [
                          x("span", {
                            class: "block w-max",
                            innerHTML: h
                          }, null, 8, Eu)
                        ]),
                        z(s.$slots, `${v}:description`, { description: g }, () => [
                          g ? (p(), w("small", {
                            key: 0,
                            class: "block text-xs font-normal text-grey-300",
                            innerHTML: g
                          }, null, 8, Vu)) : E("", !0)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["size"]),
                    c ? (p(), L(u(ht), {
                      key: 0,
                      class: "text-[20px] text-grey-500 lg:hidden"
                    })) : E("", !0)
                  ])
                ])
              ]),
              content: k(() => [
                z(s.$slots, `${v}:tooltip`, { tooltip: c }, () => [
                  C(u(_), {
                    size: u(H).sm
                  }, {
                    default: k(() => [
                      x("span", { innerHTML: c }, null, 8, Bu)
                    ]),
                    _: 2
                  }, 1032, ["size"])
                ])
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]))), 128))
        ], 2)) : E("", !0),
        e.result ? (p(), w(te, { key: 1 }, [
          C(u(_), {
            size: u(H).h3,
            "tag-name": "h2"
          }, {
            default: k(() => [
              K(O(e.translations.title), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          x("div", zu, [
            x("div", Lu, [
              C(u(_), {
                class: "grow text-grey-500",
                size: u(H).h4
              }, {
                default: k(() => [
                  K(O(e.translations.label), 1)
                ]),
                _: 1
              }, 8, ["size"]),
              x("div", null, [
                C(ze, {
                  modelValue: o.value,
                  "onUpdate:modelValue": i[0] || (i[0] = (m) => o.value = m),
                  class: "!w-44 font-highlighted",
                  "field-class": "[&>span]:!py-0 [&>span]:flex [&>span]:items-center",
                  max: e.maxInvestment,
                  min: e.minInvestment,
                  step: a.value,
                  suffix: e.translations.currency,
                  type: "text",
                  onBlur: l,
                  "onKeydown:enter": l
                }, null, 8, ["modelValue", "max", "min", "step", "suffix"])
              ])
            ]),
            C(u(js), {
              class: "relative flex h-5 w-full touch-none select-none items-center",
              max: e.maxInvestment,
              min: e.minInvestment,
              "model-value": [t.value],
              step: a.value,
              "onUpdate:modelValue": i[1] || (i[1] = ([m] = []) => t.value = m),
              onValueCommit: i[2] || (i[2] = (m) => s.$emit("slider:dragEnd"))
            }, {
              default: k(() => [
                C(u(Hs), { class: "relative h-2 grow rounded-full bg-grey-100" }, {
                  default: k(() => [
                    C(u(Ns), { class: "absolute h-full rounded-full bg-brand" })
                  ]),
                  _: 1
                }),
                C(u(_s), {
                  "aria-label": "Volume",
                  class: "block size-8 cursor-pointer rounded-full bg-brand transition-colors hover:bg-brand-dark"
                })
              ]),
              _: 1
            }, 8, ["max", "min", "model-value", "step"])
          ]),
          x("div", Au, [
            e.showPeriodicResult ? (p(), w("div", Iu, [
              C(u(Ft), {
                disabled: !((r = e.translations.result.periodic) != null && r.tooltip),
                "hide-icon": "",
                interactive: ""
              }, {
                trigger: k(() => [
                  x("div", Pu, [
                    C(u(_), {
                      class: "flex items-center gap-x-1.5 text-center font-highlighted text-grey-300 sm:text-left",
                      size: u(H).sm
                    }, {
                      default: k(() => [
                        K(O(e.translations.result.periodic.label) + " ", 1),
                        e.translations.result.periodic.tooltip ? (p(), L(u(ht), {
                          key: 0,
                          class: "hidden text-[20px] sm:block"
                        })) : E("", !0)
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    C(u(_), {
                      class: "block",
                      size: u(H).h3
                    }, {
                      default: k(() => [
                        K(O(e.result.periodic), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                content: k(({ closeHint: m }) => [
                  z(s.$slots, "periodicResultTooltip", { closeHint: m }, () => [
                    x("span", {
                      innerHTML: e.translations.result.periodic.tooltip
                    }, null, 8, Ou)
                  ])
                ]),
                _: 3
              }, 8, ["disabled"])
            ])) : E("", !0),
            x("div", Fu, [
              C(u(Ft), {
                disabled: !((d = e.translations.result.wholePeriod) != null && d.tooltip),
                "hide-icon": "",
                interactive: ""
              }, {
                trigger: k(() => [
                  x("div", Ru, [
                    C(u(_), {
                      class: "flex items-center gap-x-1.5 text-center font-highlighted text-grey-300 sm:text-left",
                      size: u(H).sm
                    }, {
                      default: k(() => [
                        K(O(e.translations.result.wholePeriod.label) + " ", 1),
                        e.translations.result.wholePeriod.tooltip ? (p(), L(u(ht), {
                          key: 0,
                          class: "hidden text-[20px] sm:block"
                        })) : E("", !0)
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    C(u(_), {
                      class: "block !font-extrabold text-brand",
                      size: u(H).h3
                    }, {
                      default: k(() => [
                        K(O(e.result.wholePeriod), 1)
                      ]),
                      _: 1
                    }, 8, ["size"])
                  ])
                ]),
                content: k(({ closeHint: m }) => [
                  z(s.$slots, "wholePeriodTooltip", { closeHint: m }, () => [
                    x("span", {
                      innerHTML: e.translations.result.wholePeriod.tooltip
                    }, null, 8, ju)
                  ])
                ]),
                _: 3
              }, 8, ["disabled"])
            ])
          ])
        ], 64)) : E("", !0)
      ]);
    };
  }
}), Hu = { class: "fixed inset-0 overflow-hidden" }, Nu = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full" }, _u = {
  key: 1,
  class: "flex h-80 max-h-full w-full items-center justify-center"
}, ac = /* @__PURE__ */ W({
  inheritAttrs: !1,
  __name: "CfgSlideOver",
  props: {
    opened: { type: Boolean },
    unmount: { type: Boolean },
    onBack: { type: Function, default: void 0 },
    renderHead: { type: Boolean, default: !0 },
    size: { default: "md" },
    renderClose: { type: Boolean, default: !0 },
    width: { default: void 0 },
    disableBottomPadding: { type: Boolean, default: !1 },
    title: {},
    description: {},
    flat: { type: Boolean },
    closable: { type: Boolean, default: !0 }
  },
  emits: ["update:opened"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = U(!1), l = B(() => Xt(t, ["opened", "unmount", "onBack"]));
    function s() {
      !t.closable && t.onBack && t.onBack(), t.closable && o("update:opened", !1);
    }
    return (i, r) => (p(), L(u(Dn), {
      as: "template",
      show: i.opened
    }, {
      default: k(() => [
        C(u(Tn), {
          as: "div",
          class: "relative z-modal",
          unmount: i.unmount ?? !1,
          onClose: s
        }, {
          default: k(() => [
            C(u(ft), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: k(() => r[2] || (r[2] = [
                x("div", { class: "fixed inset-0 bg-dark/30 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            x("div", Hu, [
              x("div", {
                class: "absolute inset-0 overflow-hidden",
                onClose: s
              }, [
                x("div", Nu, [
                  C(u(ft), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": "translate-x-full",
                    onAfterEnter: r[0] || (r[0] = (d) => a.value = !0),
                    onAfterLeave: r[1] || (r[1] = (d) => a.value = !1)
                  }, {
                    default: k(() => [
                      C(u(En), {
                        class: D(["pointer-events-auto w-screen", {
                          "max-w-sm": !i.width && i.size === "sm",
                          "max-w-xl": !i.width && i.size === "md",
                          "max-w-[700px]": !i.width && i.size === "lg"
                        }]),
                        style: Ae(i.width ? { width: i.width } : {})
                      }, {
                        default: k(() => [
                          C(ja, ae({ ...l.value, ...i.$attrs }, {
                            "is-back-allowed": !!t.onBack,
                            onBack: t.onBack,
                            onClose: s
                          }), Yt({
                            default: k(() => [
                              a.value ? z(i.$slots, "default", { key: 0 }) : E("", !0),
                              a.value ? E("", !0) : (p(), w("div", _u, [
                                C(u(Vt), { class: "text-brand" })
                              ]))
                            ]),
                            _: 2
                          }, [
                            i.$slots.head ? {
                              name: "head",
                              fn: k(() => [
                                z(i.$slots, "head")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["is-back-allowed", "onBack"])
                        ]),
                        _: 3
                      }, 8, ["class", "style"])
                    ]),
                    _: 3
                  })
                ])
              ], 32)
            ])
          ]),
          _: 3
        }, 8, ["unmount"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
});
function Uu(e, n, t) {
  if (!n)
    return {};
  const o = B(() => e.value.reduce((r, { rows: d }) => r + d.length, 0)), a = B(() => (n.value || []).length === o.value);
  function l(r) {
    if (!(n != null && n.value))
      return;
    if (!r) {
      t([]);
      return;
    }
    const d = [];
    e.value.forEach(({ rows: m }) => {
      m.forEach((c) => {
        var g;
        d.push({
          index: c.originalIndex,
          id: (g = c.meta) == null ? void 0 : g.id
        });
      });
    }), t(d);
  }
  function s(r, d) {
    t(
      i(r, d)
    );
  }
  function i(r, d) {
    return n != null && n.value ? d ? [...n.value, r] : n.value.filter((m) => !St(r, m)) : [];
  }
  return {
    toggleAllRowsSelected: l,
    toggleRowSelected: s,
    areAllRowsSelected: a
  };
}
function Wu(e, n) {
  return n ? !!n.find((t) => St(e, t)) : !1;
}
function qu(e, n) {
  return {
    rowGroups: B(() => e.value.data.reduce((t, o, a) => {
      var r;
      let l = {
        ...o,
        originalIndex: a,
        original: o,
        isSelected: !1,
        isExpended: !1,
        cells: e.value.headers.map(({ keyName: d }) => ({
          keyName: d,
          value: o[d]
        }))
      };
      n.mapEachRow && (l = n.mapEachRow(l));
      const s = (r = e.value.groups) == null ? void 0 : r.find((d) => d.value === l.group);
      if (!s)
        return t.length ? t[0].rows.push(l) : t.push({ value: "", label: "", rows: [l] }), t;
      const i = t.find((d) => d.value === s.value);
      return i ? i.rows.push(l) : t.push({ ...s, rows: [l] }), t;
    }, []))
  };
}
var Fe = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e.center = "center", e))(Fe || {});
const At = /* @__PURE__ */ W({
  __name: "CfgTableCell",
  props: {
    flat: { type: Boolean },
    align: {},
    cellIndex: {},
    expended: { type: Boolean },
    selected: { type: Boolean },
    compact: { type: Boolean },
    expendable: { type: Boolean },
    bulk: {}
  },
  setup(e) {
    return (n, t) => (p(), L(u(_), {
      class: D(["pr-5", {
        "pl-5 sm:pl-5": !n.flat,
        "lg:pl-8": !n.flat && (n.bulk ? n.cellIndex + 1 : n.cellIndex) === 0,
        "py-2": n.compact,
        "md:py-3.5": !n.compact,
        "text-center": n.align === u(Fe).center,
        "text-right": n.align === u(Fe).right
      }]),
      size: u(H).sm,
      "tag-name": "td"
    }, {
      default: k(() => [
        z(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "size"]));
  }
}), It = /* @__PURE__ */ W({
  __name: "CfgTableHeadCell",
  props: {
    flat: { type: Boolean },
    align: {},
    cellIndex: {},
    expended: { type: Boolean },
    selected: { type: Boolean },
    compact: { type: Boolean },
    expendable: { type: Boolean },
    bulk: {},
    sort: {},
    width: {},
    text: {}
  },
  emits: ["sort", "update:pagination", "click:row"],
  setup(e, { emit: n }) {
    const t = n;
    function o(a) {
      t("sort", a);
    }
    return (a, l) => (p(), w("th", {
      class: D(["sticky top-0 z-sticky bg-white/30 text-left", {
        "px-5 sm:px-5": !a.flat,
        "lg:px-8": !a.flat && (a.bulk ? a.cellIndex + 1 : a.cellIndex) === 0,
        "py-2": a.compact,
        "md:py-3.5": !a.compact,
        "text-center": a.align === u(Fe).center,
        "text-right": a.align === u(Fe).right
      }]),
      scope: "col",
      style: Ae({
        ...a.width ? { width: a.width } : {}
      })
    }, [
      (p(), L(Me(a.sort ? "button" : "span"), ae(a.sort ? { type: "button" } : {}, wt(a.sort ? {
        click: () => o({
          ...a.sort,
          order: a.sort.order === "asc" ? "desc" : "asc"
        })
      } : {})), {
        default: k(() => {
          var s;
          return [
            x("span", {
              class: D(["flex items-center gap-x-2", {
                "justify-center": a.align === u(Fe).center,
                "justify-end": a.align === u(Fe).right
              }])
            }, [
              x("span", null, [
                C(u(_), {
                  class: D(["!font-highlighted uppercase", [(s = a.sort) != null && s.active ? "text-brand" : "text-grey-200"]]),
                  size: u(H).xs,
                  "tag-name": "span"
                }, {
                  default: k(() => [
                    z(a.$slots, "head", { text: a.text }, () => [
                      K(O(a.text), 1)
                    ])
                  ]),
                  _: 3
                }, 8, ["class", "size"])
              ]),
              a.sort ? (p(), L(u(at), {
                key: 0,
                class: D(["shrink-0", {
                  "rotate-180": a.sort.order === "desc"
                }])
              }, null, 8, ["class"])) : E("", !0)
            ], 2)
          ];
        }),
        _: 3
      }, 16))
    ], 6));
  }
});
function Yu(e) {
  if (!(e != null && e.value))
    return {};
  const n = U(null);
  function t(o) {
    n.value = n.value === o ? null : o;
  }
  return { expendedIndex: n, toggleRowExpendedHandler: t };
}
function Gu(e, n) {
  if (!e)
    return {};
  const t = B({
    get() {
      var s;
      return ((s = e.value) == null ? void 0 : s.page) ?? 1;
    },
    set(s) {
      e.value && n({ ...e.value, page: s });
    }
  }), o = bs(() => {
    if (!e.value)
      return "";
    const s = e.value.page * e.value.perPage - e.value.perPage + 1, i = e.value.page * e.value.perPage;
    return `${s} - ${i > e.value.total ? e.value.total : i} / ${e.value.total}`;
  }), a = [10, 20, 50, 100].map((s) => ({ value: s, label: String(s) })), l = B({
    get() {
      var i;
      const s = ((i = e == null ? void 0 : e.value) == null ? void 0 : i.perPage) || 0;
      return { value: s, label: String(s) };
    },
    set({ value: s }) {
      e.value && n({ ...e.value, perPage: s });
    }
  });
  return {
    paginationPage: t,
    paginationSubtext: o,
    paginationPerPageOptions: a,
    selectedPerPage: l
  };
}
const Ku = { class: "max-w-full overflow-y-hidden" }, Xu = { class: "inline-block min-w-full" }, Zu = { class: "w-max" }, Ju = { class: "block text-md" }, Qu = { class: "w-max" }, ed = ["colspan"], td = ["onClick"], nd = { class: "ml-auto block px-3 py-2" }, ad = ["onClick", "onKeypress"], sd = { class: "overlow-hidden" }, ld = {
  class: "focusable -my-2 min-w-max p-4",
  type: "button"
}, od = { key: 0 }, rd = ["colspan"], id = {
  key: 0,
  class: "border-t border-grey-stroke/50"
}, ud = { class: "flex items-center gap-x-3" }, dd = { class: "flex w-full justify-center lg:grow" }, cd = { class: "min-w-[150px] shrink-0" }, sc = /* @__PURE__ */ W({
  __name: "CfgTable",
  props: {
    actionColumnTitle: {},
    dataSources: {},
    allowSelectPerPage: { type: Boolean, default: !0 },
    pagination: {},
    bulk: {},
    expendable: { type: Boolean },
    interactive: { type: Boolean },
    fixed: { type: Boolean },
    flatFirtsCell: { type: Boolean },
    compact: { type: Boolean },
    hideHeader: { type: Boolean },
    goToPage: { type: Boolean, default: !1 }
  },
  emits: ["sort", "update:pagination", "update:bulk", "click:row"],
  setup(e, { emit: n }) {
    const t = e, o = n, a = ga(), {
      pagination: l,
      bulk: s,
      expendable: i,
      dataSources: r
    } = Gt(t), d = B(() => Ge(t, ["compact", "expendable", "bulk"])), m = $t(r.value.headers, (I) => {
      var Z;
      const J = (Z = t.dataSources.sort) == null ? void 0 : Z.find((ne) => ne.key === I.keyName);
      return {
        ...I,
        sort: J,
        keyName: String(I.keyName)
      };
    }), c = B(() => m.value.every((I) => {
      var J, Z;
      return !((Z = (J = I.text) == null ? void 0 : J.trim()) != null && Z.length);
    })), g = B(() => Object.keys(a).some((I) => I.startsWith("head:"))), h = B(() => !t.hideHeader && (!c.value || !!(s != null && s.value) || g.value)), v = U(null), { height: y } = Ct(v), { expendedIndex: M, toggleRowExpendedHandler: S } = Yu(i), {
      paginationPage: b,
      selectedPerPage: f,
      paginationSubtext: $,
      paginationPerPageOptions: T
    } = Gu(
      l,
      (I) => o("update:pagination", I)
    ), { rowGroups: A } = qu(r, {
      mapEachRow(I) {
        var J;
        return {
          ...I,
          isSelected: Wu({ index: I.originalIndex, id: (J = I.meta) == null ? void 0 : J.id }, (s == null ? void 0 : s.value) || []),
          isExpended: ((M == null ? void 0 : M.value) ?? -1) === I.originalIndex
        };
      }
    }), { areAllRowsSelected: R, toggleAllRowsSelected: V, toggleRowSelected: P } = Uu(A, s, (I) => o("update:bulk", I)), q = B(() => t.dataSources.headers.map(({ footerValue: I, align: J, keyName: Z }) => ({
      value: I,
      align: J,
      keyName: String(Z)
    }))), j = B(() => q.value.some(({ value: I }) => I)), Y = B(() => !!a["body:actions"]), N = [
      s,
      i,
      Y
    ], F = B(() => N.map((I) => I == null ? void 0 : I.value).filter(Boolean).length);
    function X(I) {
      o("sort", I);
    }
    function Q(I, J, Z) {
      S && S(Z), t.interactive && o("click:row", { item: I, e: J });
    }
    return (I, J) => (p(), w("div", Ku, [
      x("div", {
        class: D(["-mt-5 max-w-full pt-5", { "overflow-x-auto": !I.fixed }])
      }, [
        x("div", Xu, [
          x("table", {
            class: D(["min-w-full max-w-full border-spacing-0", {
              "w-max": !I.fixed,
              "w-full table-fixed": I.fixed
            }]),
            style: Ae({
              // Hide head if all headers are hidden.
              // Display none doesn't work because table cells will wrong calculate width without rendered table head
              ...h.value ? {} : { marginTop: `-${u(y)}px` }
            })
          }, [
            x("thead", {
              ref_key: "headRef",
              ref: v,
              class: D(["shadow-none", {
                invisible: !h.value
              }])
            }, [
              x("tr", Zu, [
                u(s) ? (p(), L(It, ae({
                  key: 0,
                  "cell-index": 0,
                  "key-name": "bulk",
                  text: ""
                }, d.value, { width: "80px" }), {
                  head: k(() => [
                    x("span", Ju, [
                      C(u(_t), {
                        class: "text-md",
                        "model-value": u(R),
                        "onUpdate:modelValue": u(V)
                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                    ])
                  ]),
                  _: 1
                }, 16)) : E("", !0),
                (p(!0), w(te, null, ue(u(m), ({
                  keyName: Z,
                  text: ne,
                  sort: pe,
                  align: De,
                  width: ee
                }, re) => (p(), L(It, ae({
                  key: `head-${Z}`,
                  ref_for: !0
                }, d.value, {
                  align: De,
                  "cell-index": u(s) ? re + 1 : re,
                  "key-name": Z,
                  sort: pe,
                  text: ne,
                  width: ee,
                  onSort: X
                }), {
                  head: k(() => [
                    z(I.$slots, `head:${Z}`, { text: ne }, () => [
                      K(O(ne), 1)
                    ])
                  ]),
                  _: 2
                }, 1040, ["align", "cell-index", "key-name", "sort", "text", "width"]))), 128)),
                I.$slots["body:actions"] ? (p(), L(It, {
                  key: "action",
                  align: u(Fe).center,
                  "cell-index": u(m).length + 1,
                  class: D(["text-end", {
                    "pr-10": !u(i)
                  }]),
                  compact: I.compact,
                  "key-name": "action",
                  text: I.actionColumnTitle || "",
                  width: "70px"
                }, null, 8, ["align", "cell-index", "class", "compact", "text"])) : E("", !0),
                u(i) ? (p(), L(It, ae({
                  key: 2,
                  "cell-index": u(m).length + (Y.value ? 2 : 1)
                }, d.value, {
                  class: "pr-10",
                  width: "70px"
                }), null, 16, ["cell-index"])) : E("", !0)
              ])
            ], 2),
            x("tbody", Qu, [
              (p(!0), w(te, null, ue(u(A), ({ rows: Z, value: ne, label: pe }, De) => (p(), w(te, null, [
                pe || ne ? (p(), w("tr", {
                  key: `group-${De}`
                }, [
                  x("th", {
                    class: D(["px-5 pb-2 text-left text-grey-300 lg:px-8", { "pt-2": I.compact, "pt-5": !I.compact }]),
                    colspan: Z[0].cells.length || 0,
                    scope: "colgroup"
                  }, [
                    z(I.$slots, "group", {
                      group: { rows: Z, value: ne, label: pe }
                    }, () => [
                      C(u(_), {
                        class: "font-highlighted",
                        size: u(H).sm
                      }, {
                        default: k(() => [
                          K(O(pe || ne), 1)
                        ]),
                        _: 2
                      }, 1032, ["size"])
                    ])
                  ], 10, ed)
                ])) : E("", !0),
                (p(!0), w(te, null, ue(Z, (ee, re) => (p(), w(te, {
                  key: `row-${re}`
                }, [
                  x("tr", {
                    class: D(["row last-child:!border-b-none", {
                      "cursor-pointer transition-colors duration-200": I.interactive || u(i),
                      "hover:bg-grey-100/50": I.interactive,
                      "border-b border-b-grey-stroke": !ee.isExpended && !ee.isSelected && re !== Z.length - 1,
                      "border-b border-b-brand/20": !ee.isExpended && ee.isSelected && re !== Z.length - 1,
                      "border-b border-b-white": ee.isExpended && re !== Z.length - 1,
                      "hover:bg-brand/10": u(i),
                      "expended-row bg-brand/10": ee.isExpended || ee.isSelected
                    }]),
                    onClick: (ve) => Q(ee.original, ve, ee.originalIndex)
                  }, [
                    u(s) ? (p(), L(At, ae({
                      key: 0,
                      "cell-index": 0,
                      expended: ee.isExpended,
                      "row-index": re,
                      selected: ee.isSelected,
                      ref_for: !0
                    }, d.value), {
                      default: k(() => [
                        C(u(_t), {
                          class: "text-md",
                          "model-value": ee.isSelected,
                          onClick: J[0] || (J[0] = Le(() => {
                          }, ["stop"])),
                          "onUpdate:modelValue": (ve) => {
                            var xe;
                            u(P) && u(P)({
                              index: ee.originalIndex,
                              id: (xe = ee.meta) == null ? void 0 : xe.id
                            }, ve);
                          }
                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1040, ["expended", "row-index", "selected"])) : E("", !0),
                    (p(!0), w(te, null, ue(ee.cells, (ve, xe) => (p(), L(At, ae({
                      key: `cell-${ve.keyName}-${re}`,
                      ref_for: !0
                    }, d.value, {
                      align: u(r).headers[xe].align,
                      "cell-index": u(s) ? xe + 1 : xe,
                      expended: ee.isExpended,
                      flat: I.flatFirtsCell && xe === 0 && !u(s),
                      "row-index": re,
                      selected: ee.isSelected
                    }), {
                      default: k(() => [
                        I.$slots[`body:${ve.keyName}`] ? z(I.$slots, `body:${ve.keyName}`, {
                          key: 0,
                          item: u(r).data[re],
                          value: ve.value
                        }) : z(I.$slots, "body:item", {
                          key: 1,
                          item: u(r).data[re],
                          keyName: ve.keyName,
                          value: ve.value
                        }, () => [
                          K(O(ve.value || "-"), 1)
                        ])
                      ]),
                      _: 2
                    }, 1040, ["align", "cell-index", "expended", "flat", "row-index", "selected"]))), 128)),
                    Y.value ? (p(), L(At, ae({
                      key: 1,
                      "cell-index": ee.cells.length + 1,
                      expended: ee.isExpended,
                      "row-index": re,
                      selected: ee.isSelected,
                      ref_for: !0
                    }, d.value, {
                      onClick: J[1] || (J[1] = Le(() => {
                      }, ["stop"]))
                    }), {
                      default: k(() => [
                        C(Sr, {
                          class: "mx-auto",
                          "origin-x": "right",
                          overlay: ""
                        }, {
                          trigger: k(() => [
                            x("span", nd, [
                              C(u(fs), { class: "text-grey-300" })
                            ])
                          ]),
                          default: k(({ close: ve }) => {
                            var xe, ke;
                            return [
                              x("span", {
                                class: "block min-w-max px-6 py-4",
                                onClick: ve,
                                onKeypress: Re(ve, ["enter"])
                              }, [
                                z(I.$slots, "body:actions", {
                                  index: re,
                                  row: (ke = (xe = u(A)[De]) == null ? void 0 : xe.rows) == null ? void 0 : ke[re]
                                })
                              ], 40, ad)
                            ];
                          }),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "expended", "row-index", "selected"])) : E("", !0),
                    u(i) ? (p(), L(At, ae({
                      key: 2,
                      "cell-index": ee.cells.length + (Y.value ? 2 : 1),
                      expended: ee.isExpended,
                      "row-index": re,
                      selected: ee.isSelected,
                      ref_for: !0
                    }, d.value), {
                      default: k(() => [
                        x("div", sd, [
                          x("button", ld, [
                            C(u(at), {
                              class: D(["size-5 transition duration-200", {
                                "rotate-180 text-brand": ee.isExpended
                              }])
                            }, null, 8, ["class"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1040, ["cell-index", "expended", "row-index", "selected"])) : E("", !0)
                  ], 10, td),
                  u(i) ? (p(), w("tr", od, [
                    x("td", {
                      class: D(["p-0", {
                        "pt-px": ee.isExpended
                      }]),
                      colspan: ee.cells.length + F.value
                    }, [
                      C(Ca, {
                        class: "border-transparent bg-brand/10",
                        opened: ee.isExpended
                      }, {
                        default: k(() => [
                          x("div", null, [
                            x("div", {
                              class: D(["lg:px-8", { "p-3": I.compact, "p-5": !I.compact }])
                            }, [
                              z(I.$slots, "row:expended", {
                                index: ee.originalIndex,
                                row: ee.original
                              })
                            ], 2)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["opened"])
                    ], 10, rd)
                  ])) : E("", !0)
                ], 64))), 128))
              ], 64))), 256))
            ]),
            j.value ? (p(), w("tfoot", id, [
              x("tr", null, [
                u(s) ? (p(), w("td", {
                  key: 0,
                  class: D(["py-3 pl-5 pr-7 text-center text-xs sm:pl-6 lg:pl-8 xl:text-[15px]", {
                    "md:py-5": !I.compact,
                    "md:py-3": I.compact
                  }]),
                  onClick: J[2] || (J[2] = Le(() => {
                  }, ["stop"]))
                }, null, 2)) : E("", !0),
                (p(!0), w(te, null, ue(q.value, ({ value: Z, align: ne, keyName: pe }, De) => (p(), w("td", { key: De }, [
                  x("span", {
                    class: D(["flex w-full py-3 pr-5", {
                      "justify-center text-center": ne === u(Fe).center,
                      "justify-end text-right": ne === u(Fe).right,
                      "pl-5 sm:pl-5": !I.flatFirtsCell
                    }])
                  }, [
                    Z ? z(I.$slots, `footer:${pe}`, {
                      key: 0,
                      item: u(r).data[De],
                      value: Z
                    }, () => [
                      C(u(_), {
                        class: "font-highlighted",
                        html: String(Z),
                        size: u(H).md
                      }, null, 8, ["html", "size"])
                    ]) : E("", !0)
                  ], 2)
                ]))), 128))
              ])
            ])) : E("", !0)
          ], 6)
        ])
      ], 2),
      u(l) && u(b) ? (p(), w("div", {
        key: 0,
        class: D(["mt-0 block w-full border-t border-grey-stroke/50 p-5 lg:px-8", {
          "pt-10": !I.allowSelectPerPage
        }]),
        style: { "--cfg-select-min-width": "150px" }
      }, [
        x("div", ud, [
          C(u(_), {
            class: "shrink-0 text-grey-300",
            size: u(H).sm
          }, {
            default: k(() => [
              K(O(u($)), 1)
            ]),
            _: 1
          }, 8, ["size"]),
          x("div", dd, [
            C(Gr, {
              page: u(b),
              "onUpdate:page": J[3] || (J[3] = (Z) => ct(b) ? b.value = Z : null),
              class: "w-full lg:w-max",
              "go-to-page": t.goToPage,
              "items-per-page": u(l).perPage,
              "total-items": u(l).total
            }, null, 8, ["page", "go-to-page", "items-per-page", "total-items"])
          ]),
          x("div", cd, [
            I.allowSelectPerPage ? (p(), L(Ra, {
              key: 0,
              modelValue: u(f),
              "onUpdate:modelValue": J[4] || (J[4] = (Z) => ct(f) ? f.value = Z : null),
              "content-min-width": "150px",
              options: u(T),
              placeholder: "Řádků na stránku:"
            }, null, 8, ["modelValue", "options"])) : E("", !0)
          ])
        ])
      ], 2)) : E("", !0)
    ]));
  }
}), fd = {
  key: 0,
  class: "flex items-center text-[1.2em]"
}, lc = /* @__PURE__ */ W({
  __name: "CfgTableMenuItem",
  props: {
    as: {
      type: String,
      default: "button"
    }
  },
  setup(e) {
    return (n, t) => (p(), L(u(_), {
      class: "flex items-center gap-x-3 px-3 py-2 transition duration-200 hover:opacity-70",
      size: u(H).md,
      "tag-name": e.as
    }, {
      default: k(() => [
        n.$slots.icon ? (p(), w("div", fd, [
          z(n.$slots, "icon")
        ])) : E("", !0),
        x("div", null, [
          z(n.$slots, "body")
        ])
      ]),
      _: 3
    }, 8, ["size", "tag-name"]));
  }
});
export {
  $d as CfgAccordion,
  Cd as CfgAccordionItem,
  Gd as CfgAddressDetailsField,
  Sd as CfgAlert,
  $e as CfgAlertVariants,
  Ad as CfgApplicationError,
  Kd as CfgBankAccountField,
  Xd as CfgBirthNumberField,
  Qd as CfgBottomSheet,
  Id as CfgBreadcrumbs,
  Zt as CfgButton,
  Pd as CfgButtonsGroup,
  Xl as CfgCalendar,
  Md as CfgCard,
  Dd as CfgCarousel,
  _t as CfgCheckbox,
  Od as CfgCheckboxGroup,
  Td as CfgChip,
  Te as CfgChipColors,
  Fd as CfgChipsToggle,
  lr as CfgCircularProgress,
  Ca as CfgCollapsable,
  Hd as CfgCombobox,
  ca as CfgCompactInput,
  vu as CfgDateField,
  Rd as CfgDialog,
  Sr as CfgDropdown,
  Ed as CfgFilterChip,
  Oa as CfgFloating,
  tc as CfgForm,
  Vd as CfgHeaderBanner,
  Ft as CfgHint,
  ze as CfgInput,
  nc as CfgInvestCalculator,
  ot as CfgModalSizes,
  Bd as CfgOtpInput,
  Gr as CfgPagination,
  Zd as CfgPasswordField,
  Vt as CfgPreloader,
  ti as CfgRadio,
  jd as CfgRadioGroup,
  ai as CfgScrollbarView,
  Ra as CfgSelect,
  ac as CfgSlideOver,
  Nd as CfgSlider,
  zd as CfgSwitch,
  _d as CfgTab,
  Ud as CfgTabPanel,
  sc as CfgTable,
  lc as CfgTableMenuItem,
  Wd as CfgTabs,
  Ld as CfgTextarea,
  qd as CfgTimeline,
  lu as CfgTimelineItem,
  ge as CfgTimelineItemColors,
  Yd as CfgToastNotification,
  Ee as CfgToastNotificationType,
  Mr as CfgTransition,
  _ as CfgTypography,
  H as CfgTypographySizes,
  Jd as CfgValidatedField,
  gi as CfgValidationObserver,
  Pa as CfgValidationProvider,
  ye as FormControlNames,
  Fe as TableCallAlign,
  Ha as buildFormResults,
  ec as useForm
};
